/* fix4: settle the 'moved' flag after a press: real drag/resize (> 3 px change) => moved; a plain tap keeps the prior state. */
window.__sancandoSettleMoved = window.__sancandoSettleMoved || function (el, d) {
  try {
    if (!el || !d || !d.b0) { if (el) el.dataset.userMoved = '1'; return; }
    const r = el.getBoundingClientRect();
    const delta = Math.abs(r.left - d.b0[0]) + Math.abs(r.top - d.b0[1]) + Math.abs(r.width - d.b0[2]) + Math.abs(r.height - d.b0[3]);
    if (delta > 3 || d.prevMoved) el.dataset.userMoved = '1';
    else delete el.dataset.userMoved;
  } catch (e) { if (el) el.dataset.userMoved = '1'; }
};
if (!customElements.get('sancando-customization')) {
    customElements.define(
      'sancando-customization',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';
          try {
            this.maxBytes = Number(this.dataset.maxBytes) || 20971520;
            this.allowedExt = ['png', 'jpg', 'jpeg', 'svg', 'webp', 'pdf', 'ai', 'eps'];
            this.allowedMime = [
              'image/png',
              'image/jpeg',
              'image/svg+xml',
              'image/webp',
              'application/pdf',
              'application/postscript',
              'application/illustrator',
              'application/eps',
              'image/eps',
            ];
            this.addEventListener('change', (event) => this.onChange(event));
            this.addEventListener('input', (event) => this.onInput(event));
            this.addEventListener('keydown', (event) => this.onKeyDown(event));
            /* 2026-10-22 (#167 only): a re-rendered element (colour switch + sold-out size bump) arrives with server defaults;
               put the customer's reveal/text state back BEFORE syncReveal, or applyReveal(off) hides the box and wipes upload/text. */
            /* 2026-10-22 logo-persist: page reload → refill the per-product window cache from sessionStorage first. */
            try { this.hydrateDesignFromSession(); } catch (err) { /* never break the page */ }
            this.restoreFormState();
            this.querySelectorAll('[data-reveal]').forEach((box) => this.syncReveal(box));
            this.querySelectorAll('select[data-text-preview]').forEach((select) => this.syncFontPreview(select));
            this.syncEngravingSide();
            this.syncBackSame();
            this.syncDigitizingNote();
            this.syncDtfPlacementUi();
            this.syncLeatheretteUi();
            this.syncUploadChrome();
            /* Hats color morph replaces this element — restore logo NOW, not on idle. */
            try {
              this.restoreLogoFromCache();
              this.syncUploadChrome();
            } catch (err) {
              /* ignore */
            }
            this.syncImprintPreview();
            /* stripDecorationDims walks the whole PDP — keep it off first paint. */
            const bootHeavy = () => {
              try {
                this.stripDecorationDims();
                this.bindDecorationMedia();
                this.bindSecondSideAddon();
                this.bindBoxTopAddon();
                this.bindDigitizingAddon();
                this.bindDtfPlacementAddon();
                this.bindLeatherettePlateResize();
                this.bindCustomerBoxes();
                this.bindZoomGuard();
                this.bindVariantChangeResync();
                this.bindSectionMorphResync();
                this.bindRequiredLogo();
                this.bindMockupCapture();
                this.bindUploadActions();
                this.restoreLogoFromCache();
                this.syncUploadChrome();
                this.syncImprintPreview();
                this.stripVisibleCustomizerMoney();
                this.rekeyRestoredLogo();
              } catch (err) {
                try { console.error('[sancando] customization heavy boot failed', err); } catch (e) {}
              }
              /* 2026-10-23 (#167 only): add-to-cart guard in customization-form.liquid waits for this (fee/logo/file binders above). */
              this.dataset.sancandoReady = 'true';
              try { document.dispatchEvent(new CustomEvent('sancando:customizer-ready', { detail: { el: this } })); } catch (e) {}
            };
            if ('requestIdleCallback' in window) {
              requestIdleCallback(bootHeavy, { timeout: 1500 });
            } else {
              setTimeout(bootHeavy, 300);
            }
          } catch (err) {
            try { console.error('[sancando] customization boot failed', err); } catch (e) {}
          }
        }


        onInput(event) {
          const target = event.target;
          this.saveFormState();
          this.persistDesignSoon();
          if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLTextAreaElement)) return;
          if (target.name === 'properties[Text - Front]' || target.name === 'properties[Text Font]') {
            this.syncImprintPreview();
          }
        }

        onKeyDown(event) {
          if (event.key !== 'Enter') return;
          const target = event.target;
          if (target instanceof HTMLTextAreaElement && target.name === 'properties[Text - Front]') {
            event.stopPropagation();
          }
        }

        stripDecorationDims() {
          const re = /approx\.?\s*decoration|decoration area\s*:|imprint(?:able)?\s*area\s*:|personalization area\s*:/i;
          const roots = document.querySelectorAll(
            '.sancando-customization, .rte, rte-formatter, .text-block, .product-details'
          );
          roots.forEach((root) => {
            root.querySelectorAll('p, span, small, li, div').forEach((el) => {
              if (el.classList && el.classList.contains('sancando-customization__dims')) {
                el.remove();
                return;
              }
              const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
              if (text && text.length < 160 && re.test(text)) {
                el.remove();
              }
            });
          });
          document.querySelectorAll('.sancando-customization__dims').forEach((el) => el.remove());
        }

        onChange(event) {
          const target = event.target;
          this.saveFormState();
          this.persistDesignSoon();
          if (target instanceof HTMLSelectElement) {
            this.syncFontPreview(target);
            this.syncImprintPreview();
            return;
          }
          if (!(target instanceof HTMLInputElement)) return;
          if (target.type === 'file') {
            /* 2026-10-24: the box-top logo is its own upload — never treat it as the front design. */
            if (target.hasAttribute('data-box-top-file')) return;
            this.onFileChange(target);
            return;
          }
          if (target.name === 'properties[Engraving Side]') {
            this.syncEngravingSide();
            this.syncImprintPreview();
            return;
          }
          if (target.dataset.reveal) this.syncReveal(target);
          if (target.name === 'properties[Decoration Method]') {
            this.applyDecorationMedia();
            this.syncDigitizingNote();
            this.syncDtfPlacementUi();
            this.syncLeatheretteUi();
            /* DTF/UV keep color preview; clear stale laser silver plate from Embroidery. */
            if (this.isFullColorDecoration()) {
              this._laserSilverPreviewFile = null;
              this._imprintLogoKey = '';
            }
          }
          if (target.name === 'properties[_placement_id]') {
            this.syncDtfPlacementLabel();
            this.stripVisibleCustomizerMoney(); this.updateDtfPackagePrice();
            this.applyApparelPlacementBox();
          }
          if (target.name === 'properties[Sleeve Addon]' || target.dataset.dtfSleeveAddonCheck != null) {
            this.syncDtfSleeveAddonUi();
          }
          if (target.name === 'properties[Sleeve Side]') {
            this.stripVisibleCustomizerMoney(); this.updateDtfPackagePrice();
          }
          if (target.name === 'properties[Patch Color]' || target.name === 'properties[Patch Shape]') this.syncLeatheretteUi();
          if (target.name === 'properties[Previously Digitized]') this.syncDigitizingNote();
          if (target.dataset.chargeBothCheck) this.syncBothPriceNote();
          if (target.name === 'properties[Both Sides]') this.syncBackSame();
          this.syncImprintPreview();
        }

        bindDecorationMedia() {
          if (!this._heroSnapBound) {
            this._heroSnapBound = true;
            /* Fresh upload / text edit on the FRONT design (not the box-top fields) re-centres the hero slide. */
            const want = (ev) => { const t = ev.target; if (t && t.closest && !t.closest('[data-box-top]') && (t.type === 'file' || t.matches('input[type="text"], textarea'))) this._heroSnapWanted = true; };
            this.addEventListener('change', want, true);
            this.addEventListener('input', want, true);
          }
          this.applyDecorationMedia();
          const formId = this.querySelector('input[name="properties[Decoration Method]"]')?.getAttribute('form');
          const form = formId ? document.getElementById(formId) : null;
          if (form && form.dataset.sancandoDecoBound !== 'true') {
            form.dataset.sancandoDecoBound = 'true';
            form.addEventListener('change', () => {
              this.schedulePreviewResync();
            });
          }
          if (!this._decoObs) {
            const gallery = document.querySelector('.product-media-gallery, product-media-gallery');
            if (gallery) {
              this._decoObs = new MutationObserver(() => {
                if (this._decoObsTimer) clearTimeout(this._decoObsTimer);
                this._decoObsTimer = setTimeout(() => {
                  if (this._syncingPreview) {
                    this._resyncAfterSync = true;
                    return;
                  }
                  this.schedulePreviewResync();
                }, 160);
              });
              this._decoObs.observe(gallery, { childList: true, subtree: true });
            }
          }
        }

        applyDecorationMedia() {
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const method = (methodInput && methodInput.value) || '';
          const isUv = /uv|full color|dtf/i.test(method);
          document.documentElement.dataset.sancandoDeco = isUv ? 'uv' : 'laser';
          const mapEl = this.querySelector('[data-sancando-media-map]');
          let map = {};
          try {
            map = JSON.parse((mapEl && mapEl.textContent) || '{}');
          } catch (e) {
            map = {};
          }
          const formId = this.querySelector('input[name="properties[Decoration Method]"]')?.getAttribute('form');
          const form = formId
            ? document.getElementById(formId)
            : document.querySelector('form[action*="/cart/add"]');
          const variantId = form && form.querySelector('input[name="id"]')
            ? String(form.querySelector('input[name="id"]').value)
            : '';
          const suffix = (this.dataset.templateSuffix || '').toLowerCase();
          const ptype = (this.dataset.productType || '').toLowerCase();
          const isHats = suffix === 'hats' || ptype === 'hats';
          if (isHats) {
            this.applyHatFrontMedia(map, variantId);
            return;
          }
          const entry = map[variantId] || null;
          const isApparel = suffix === 'apparel' || ptype === 'apparel';
          const customizing =
            document.documentElement.dataset.sancandoCustomizing === '1' ||
            this.hasCachedOrInputLogo();
          let url = '';
          if (entry) {
            /* Apparel: never swap to blank — SKU-blank.jpg often missing and
               breaks the gallery. Keep the color tee; logo overlays on top.
               Gift-set / drinkware: while customizing force blank; idle keeps
               Shopify featured (group hero) when laser empty — do NOT fall
               through laser||blank or idle swaps the hero away.
               If customer explicitly chose "View set photo", keep laser
               (group hero) without clearing logo/text state. */
            if (customizing && entry.blank && !isApparel) {
              if (this._viewingSetPhoto && entry.laser) url = this.setPhotoUrl(entry);
              else url = entry.blank;
            } else if (entry.laser) url = isUv ? (entry.uv || entry.laser) : entry.laser;
            else if (isUv && entry.uv) url = entry.uv;
            else return; // keep whatever Shopify rendered (group hero)
          }
          if (!url) return;
          this.setVisibleProductImage(url);
          /* 2026-10-25 El Jefe FSK312 "doesn't work on this one": the blank is swapped into the HERO slide, but if the
             shopper had swiped to another photo (e.g. the open-box sample-logo shot) the gallery stayed there, so the
             upload/text never showed. On entering customize mode, or after a new upload/text edit, bring the hero
             slide into view. Later manual swipes while customizing are left alone. */
          if (customizing && entry && url === entry.blank) {
            const key = String(this.getCurrentVariantId()) + '|' + url;
            if (this._heroSnapKey !== key || this._heroSnapWanted) {
              this._heroSnapKey = key;
              this._heroSnapWanted = false;
              this.showHeroSlide();
            }
          } else if (!customizing) this._heroSnapKey = '';
          this.syncGiftSetChrome(customizing, entry);
        }

        showHeroSlide() {
          try {
            const hero = this.findHeroProductImages()[0];
            const slide = hero && hero.closest('slideshow-slide');
            const ss = slide && slide.closest('slideshow-component');
            if (!ss || !ss.slides || typeof ss.select !== 'function') return;
            const idx = ss.slides.indexOf(slide);
            if (idx > -1 && ss.current !== idx) ss.select(idx, undefined, { animate: false });
          } catch (e) { /* ignore */ }
        }

        isUvDecoration() {
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const method = (methodInput && methodInput.value) || '';
          return /uv|full color/i.test(method);
        }

        /* Full-color print methods: keep color preview (no laser silver plate). */
        isFullColorDecoration() {
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const method = (methodInput && methodInput.value) || '';
          return /uv|full color|dtf/i.test(method);
        }

        isDtfDecoration() {
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const method = (methodInput && methodInput.value) || '';
          return /^dtf$/i.test(String(method || '').trim());
        }

        isEmbroideryDecoration() {
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const method = (methodInput && methodInput.value) || '';
          return /embroidery/i.test(String(method || '').trim());
        }

        isApparelProduct() {
          const suffix = (this.dataset.templateSuffix || '').toLowerCase();
          const ptype = (this.dataset.productType || '').toLowerCase();
          return suffix === 'apparel' || ptype === 'apparel';
        }

        isHatsProduct() {
          const suffix = (this.dataset.templateSuffix || '').toLowerCase();
          const ptype = (this.dataset.productType || '').toLowerCase();
          if (suffix === 'hats' || ptype === 'hats') return true;
          /* Fallback when data-product-type is blank but hats gallery is on the PDP. */
          return !!(document.querySelector('.sancando-hats-gallery, .product-media--hats, .sancando-pdp--hats'));
        }


        /* Jefe 2026-10-30: leatherette coasters -> solid black; bamboo/wood -> faint black burn; else existing rule. */
        /* Jefe 2026-10-30 PM ink rule: leatherette koozies + coasters: single-colour -> flat solid black;
           two-tone "Base/Second" (Black/Gold, Blue/Silver, Rustic/Gold...) -> engrave in the SECOND colour.
           Cork koozie / beverage holder -> flat solid black. */
        sancandoSelectedColor() {
          const ins = Array.from(document.querySelectorAll('variant-picker fieldset input[type="radio"]:checked, .variant-picker fieldset input[type="radio"]:checked'));
          if (!ins.length) {
            const sel = document.querySelector('variant-picker select, .variant-picker select');
            return sel ? String(sel.value || '') : '';
          }
          const named = ins.find((i) => /colou?r/i.test((i.name || '') + ' ' + ((i.closest('fieldset') || {}).textContent || '').slice(0, 40)));
          return String((named || ins[0]).value || '');
        }

        sancandoTwoToneInk(cv) {
          const parts = String(cv || '').split('/');
          if (parts.length < 2) return '';
          const second = parts[parts.length - 1].trim().toLowerCase();
          if (/gold|brass/.test(second)) return 'gold';
          if (/silver|chrome|gray|grey/.test(second)) return 'silver';
          return 'solid';
        }

        sancandoLaserInk() {
          if (this.isHatsProduct() || this.isGlasswareProduct()) return '';
          const t = ((this.dataset.productTitle || '') + ' ' + (this.dataset.productHandle || '')).toLowerCase();
          const holder = /koozie|beverage holder|beverage-holder|can cooler/.test(t);
          if (holder && /cork/.test(t)) return 'solid';
          if (/leatherette/.test(t) && (holder || /coaster|flask/.test(t))) { /* 2026-11-02 Jefe: leatherette flasks too (single -> solid black, two-tone -> 2nd colour) */
            return this.sancandoTwoToneInk(this.sancandoSelectedColor()) || 'solid';
          }
          if (/bamboo|wood/.test(t) && !/tumbler|flask|shirt|tank|apparel/.test(t)) return 'bamboo';
          return this.isDarkLaserProduct() ? 'black' : '';
        }

        isDarkLaserProduct() {
          if (this.isHatsProduct() || this.isGlasswareProduct()) return false;
          const t = ((this.dataset.productTitle || '') + ' ' + (this.dataset.productHandle || '')).toLowerCase();
          if (!/koozie|beverage holder|beverage-holder|can cooler|leatherette|cork/.test(t)) return false;
          /* Two-tone leatherette (Black/Silver, Blue/Gold...) engraves to the second colour, not black. */
          const colorIn = document.querySelector('variant-picker fieldset input[type="radio"]:checked, .variant-picker fieldset input[type="radio"]:checked');
          const cv = colorIn ? String(colorIn.value || '') : '';
          if (/\//.test(cv) || /^(black|blue black|navy|dark brown|purple|red|teal|blue)$/i.test(cv.trim())) return false;
          return true;
        }

        isGlasswareProduct() {
          const suffix = (this.dataset.templateSuffix || '').toLowerCase();
          const ptype = (this.dataset.productType || '').toLowerCase();
          if (suffix === 'glassware' || ptype === 'glassware' || ptype.indexOf('glassware') !== -1) return true;
          const title = (this.dataset.productTitle || '').toLowerCase();
          if (title.indexOf('rocks') !== -1 || title.indexOf('decanter') !== -1 || title.indexOf('glass') !== -1) {
            /* Prefer type/suffix; title fallback only when type empty. */
            if (!ptype && !suffix) return true;
          }
          return false;
        }

        isHatsLeatherette() {
          if (!this.isHatsProduct()) return false;
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          return !!methodInput && /leatherette/i.test(methodInput.value || '');
        }

        hatPatchAspect(shape) {
          const s = String(shape || '').toLowerCase().replace(/\s+/g, '-');
          if (s === 'rounded-rect' || s === 'oval') return 1.55;
          if (s === 'rectangle') return 1.85;
          if (s === 'capsule') return 2.0;
          return 1; /* round / square / hex */
        }

        ensureImprintMax(box) {
          if (!box || box.dataset.imprintMax) return;
          const area = this.imprintArea(box);
          const top = this.numPct(area.top);
          const left = this.numPct(area.left);
          const width = this.numPct(area.width);
          const height = this.numPct(area.height);
          box.dataset.imprintMax = JSON.stringify({ top: top, left: left, width: width, height: height });
          const fitMode = String((area && area.fit) || '').toLowerCase();
          const boundsMode = fitMode === 'bounds' || (fitMode !== 'presence' && width / Math.max(height, 0.01) > 1.4);
          if (boundsMode && width > height) {
            const side = Math.max(width, height);
            let sqLeft = left + (width - side) / 2;
            let sqTop = top + (height - side) / 2;
            if (sqLeft < 0) sqLeft = 0;
            if (sqTop < 0) sqTop = 0;
            if (sqLeft + side > 100) sqLeft = Math.max(0, 100 - side);
            if (sqTop + side > 100) sqTop = Math.max(0, 100 - side);
            const clampedSide = Math.min(side, 100 - sqLeft, 100 - sqTop);
            box.dataset.imprintMaxSquare = JSON.stringify({
              top: sqTop,
              left: sqLeft,
              width: clampedSide,
              height: clampedSide,
            });
          }
        }

        /* Hats leatherette: clamp travel to FULL front image (cap face), not Markup sew zone.
           Markup imprint_preview may still seed starter SIZE only. */
        ensureHatsLeatheretteCapMax(box) {
          if (!box) return;
          box.dataset.imprintMax = JSON.stringify({ top: 0, left: 0, width: 100, height: 100 });
          delete box.dataset.imprintMaxSquare;
        }

        /* Starter size from Markup @ scale, then re-center inside full-cap max. */
        hatsLeatheretteStarterBox(box, aspect, scale) {
          const s = scale == null ? 0.85 : scale;
          const a = aspect > 0 ? aspect : 1;
          const area = this.imprintArea(box);
          const seedMax = {
            top: this.numPct(area.top),
            left: this.numPct(area.left),
            width: this.numPct(area.width),
            height: this.numPct(area.height),
          };
          const sized = this.fitAspectInMax(seedMax, a, s);
          const w = this.numPct(sized.width);
          const h = this.numPct(sized.height);
          const fullMax = { top: 0, left: 0, width: 100, height: 100 };
          return this.clampBoxToMax(
            {
              top: this.pct((100 - h) / 2),
              left: this.pct((100 - w) / 2),
              width: this.pct(w),
              height: this.pct(h),
            },
            fullMax
          );
        }

        clampBoxToMax(boxPct, maxPct) {
          if (!boxPct || !maxPct) return boxPct;
          let w = this.numPct(boxPct.width);
          let h = this.numPct(boxPct.height);
          let l = this.numPct(boxPct.left);
          let t = this.numPct(boxPct.top);
          const mw = this.numPct(maxPct.width);
          const mh = this.numPct(maxPct.height);
          const ml = this.numPct(maxPct.left);
          const mt = this.numPct(maxPct.top);
          w = Math.max(1, Math.min(w, mw));
          h = Math.max(1, Math.min(h, mh));
          l = Math.max(ml, Math.min(l, ml + mw - w));
          t = Math.max(mt, Math.min(t, mt + mh - h));
          return {
            top: this.pct(t),
            left: this.pct(l),
            width: this.pct(w),
            height: this.pct(h),
          };
        }

        /* Center aspect-fit inside max ceiling (middle of hat / full-cap). */
        fitAspectInMax(maxPct, aspect, scale) {
          /* Default scale 0.85; hats leatherette starter uses hatsLeatheretteStarterBox. */
          const s = scale == null ? 0.85 : scale;
          const a = aspect > 0 ? aspect : 1;
          const mw = this.numPct(maxPct.width);
          const mh = this.numPct(maxPct.height);
          const ml = this.numPct(maxPct.left);
          const mt = this.numPct(maxPct.top);
          let w;
          let h;
          if (mw / Math.max(mh, 0.01) > a) {
            h = mh * s;
            w = h * a;
          } else {
            w = mw * s;
            h = w / a;
          }
          /* Always center: left = max.left + (max.w - w)/2, top = max.top + (max.h - h)/2 */
          const l = ml + (mw - w) / 2;
          const t = mt + (mh - h) / 2;
          return {
            top: this.pct(t),
            left: this.pct(l),
            width: this.pct(w),
            height: this.pct(h),
          };
        }

        reaspectPatchBoxKeepCenter(box, aspect, maxPct) {
          if (!box || !maxPct) return;
          const cur = this.readBox(box);
          const cx = this.numPct(cur.left) + this.numPct(cur.width) / 2;
          const cy = this.numPct(cur.top) + this.numPct(cur.height) / 2;
          const curArea = Math.max(this.numPct(cur.width) * this.numPct(cur.height), 0.01);
          const a = aspect > 0 ? aspect : 1;
          let w = Math.sqrt(curArea * a);
          let h = w / a;
          const mw = this.numPct(maxPct.width);
          const mh = this.numPct(maxPct.height);
          if (w > mw) {
            w = mw;
            h = w / a;
          }
          if (h > mh) {
            h = mh;
            w = h * a;
          }
          const l = cx - w / 2;
          const t = cy - h / 2;
          this.writeBox(
            box,
            this.clampBoxToMax(
              {
                top: this.pct(t),
                left: this.pct(l),
                width: this.pct(w),
                height: this.pct(h),
              },
              maxPct
            )
          );
        }

        /* Antifreeze: drag-time plate follow only — no chip re-eager, no DOM remount. */
        syncLeatherettePlateFollow() {
          if (!this.isHatsLeatherette()) return;
          document.querySelectorAll('.sancando-hats-gallery .product-media, .product-media--hats').forEach((parent) => {
            const plate = parent.querySelector(':scope > .sancando-leatherette-plate');
            const box = parent.querySelector('.sancando-imprint-preview.is-patch-frame');
            if (!plate || !box) return;
            this.writeBox(plate, this.readBox(box));
          });
        }


        /* SanCanDo 2026-10-21 gallery-hero (#167 only, not ported): swap ONLY the hero
           slide. Previously every matching gallery image was overwritten, so any extra
           media appended to a product rendered as a duplicate hero. Hero = the slide
           showing the current variant's media-map photo (variant-linked) or one we
           already swapped, else the first gallery slide. All other slides
           (and their zoom-dialog copies) are left exactly as Shopify rendered them. */
        findHeroProductImages() {
          const okImg = (img) =>
            !!img &&
            img.tagName === 'IMG' &&
            !img.classList.contains('sancando-imprint-preview__logo') &&
            !img.classList.contains('sancando-placeholder-hint__img') &&
            !img.closest('.sancando-imprint-preview, .sancando-imprint-text, .sancando-placeholder-hint, .sancando-leatherette-plate');
          const slideImg = (slide) => {
            if (!slide) return null;
            const list = Array.from(slide.querySelectorAll('img.product-media__image, img')).filter(okImg);
            return list[0] || null;
          };
          const pathOf = (u) => {
            try {
              return new URL(String(u || ''), window.location.href).pathname.split('/').pop();
            } catch (e) {
              return String(u || '').split('?')[0].split('/').pop();
            }
          };
          const gallery =
            document.querySelector('.sancando-drinkware-gallery') ||
            document.querySelector('.sancando-journals-gallery') ||
            document.querySelector('.product-media-gallery') ||
            document.querySelector('media-gallery');
          const scope = gallery || document;
          const slides = Array.from(scope.querySelectorAll('slideshow-slide')).filter(
            (sl) => !sl.closest('zoom-dialog, dialog, .announcement-bar')
          );
          /* Variant-linked hero paths: current variant only (other colors' heroes
             that Shopify shows as extra slides must stay untouched). */
          const cur = this.getMediaMapEntry();
          const heroPaths = [];
          const addPaths = (e) => {
            if (!e) return;
            ['laser', 'uv', 'front', 'side', 'blank'].forEach((k) => {
              const p = e[k] ? pathOf(e[k]) : '';
              if (p && heroPaths.indexOf(p) === -1) heroPaths.push(p);
            });
          };
          addPaths(cur);
          let heroIndex = -1;
          if (slides.length) {
            for (let i = 0; i < slides.length && heroIndex === -1; i++) {
              const img = slideImg(slides[i]);
              if (!img) continue;
              if (heroPaths.indexOf(pathOf(img.getAttribute('src'))) !== -1 || img.dataset.sancandoHero === '1') heroIndex = i;
            }
            if (heroIndex === -1) heroIndex = 0;
            const out = [];
            const heroImg = slideImg(slides[heroIndex]);
            if (heroImg) out.push(heroImg);
            /* Zoom dialog copy of the same index only. */
            const zoomSlides = Array.from(document.querySelectorAll('zoom-dialog slideshow-slide, dialog slideshow-slide, .dialog-zoomed-gallery > *'));
            const zImg = zoomSlides.length > heroIndex ? slideImg(zoomSlides[heroIndex]) : null;
            if (zImg && out.indexOf(zImg) === -1) out.push(zImg);
            out.forEach((img) => {
              img.dataset.sancandoHero = '1';
            });
            return out;
          }
          /* Single-media layout (no slideshow): first eligible product image only. */
          const single = Array.from(
            scope.querySelectorAll('.product-media--drinkware img.product-media__image, .product-media--image img, .product-media__image')
          ).filter(okImg);
          return single.length ? [single[0]] : [];
        }

        setVisibleProductImage(url) {
          if (!url || String(url).indexOf('undefined') !== -1) return;
          const ordered = this.findHeroProductImages();
          if (!ordered.length) return;
          /* SanCanDo 2026-09-29 perf: compare file paths without the ?v=/width= query.
             Skip the swap when the photo is already showing (no re-download of the
             LCP image), and keep a responsive srcset + the gallery's sizes on swaps. */
          const pathOf = (u) => {
            try {
              return new URL(String(u || ''), window.location.href).pathname;
            } catch (e) {
              return String(u || '').split('?')[0];
            }
          };
          const targetPath = pathOf(url);
          const srcsetFor = (u) => {
            try {
              const base = new URL(String(u), window.location.href);
              return [240, 352, 832, 1200]
                .map((w) => {
                  base.searchParams.set('width', String(w));
                  return base.toString() + ' ' + w + 'w';
                })
                .join(', ');
            } catch (e) {
              return '';
            }
          };
          ordered.forEach((visible) => {
            const prev = visible.getAttribute('src') || '';
            const prevSrcset = visible.getAttribute('srcset');
            const prevSizes = visible.getAttribute('sizes');
            const shownPath = pathOf(visible.currentSrc || prev);
            if (pathOf(prev) === targetPath && (!visible.currentSrc || shownPath === targetPath)) return;
            /* Different file (e.g. blank vs colour wrap): always swap.
               SanCanDo 2026-10-28 (#167): swatch-tap black-flash fix. Preload the new photo off-DOM with the
               same srcset/sizes, decode it, then swap, so the old photo stays visible until the new one is ready.
               Never blank or hide in between; on error swap anyway (old onerror fallback kept). Rapid taps: last wins. */
            const newSrcset = srcsetFor(url);
            const sizesNow = prevSizes || (newSrcset ? '(min-width: 750px) 50vw, 100vw' : '');
            const token = {};
            visible._sancandoSwapToken = token;
            const apply = () => {
              if (visible._sancandoSwapToken !== token) return;
              visible._sancandoSwapToken = null;
              if (newSrcset) {
                if (!prevSizes) visible.setAttribute('sizes', sizesNow);
                visible.setAttribute('srcset', newSrcset);
              } else if (visible.hasAttribute('srcset')) {
                visible.removeAttribute('srcset');
              }
              visible.setAttribute('src', url);
              visible.onerror = () => {
                if (prev && visible.getAttribute('src') === url) {
                  if (prevSrcset) visible.setAttribute('srcset', prevSrcset);
                  else visible.removeAttribute('srcset');
                  if (prevSizes) visible.setAttribute('sizes', prevSizes);
                  visible.setAttribute('src', prev);
                }
                visible.onerror = null;
              };
            };
            let pre;
            try { pre = new Image(); } catch (e) { pre = null; }
            if (!pre) { apply(); return; }
            let settled = false;
            const finish = () => { if (settled) return; settled = true; clearTimeout(cap); apply(); };
            /* hard cap: never leave the old colour up longer than 4 s on a slow network */
            const cap = setTimeout(finish, 4000);
            pre.onload = () => {
              if (typeof pre.decode === 'function') pre.decode().then(finish, finish);
              else finish();
            };
            pre.onerror = finish;
            if (sizesNow) pre.sizes = sizesNow;
            if (newSrcset) pre.srcset = newSrcset;
            pre.src = url;
          });
        }

        getMediaMap() {
          const mapEl = this.querySelector('[data-sancando-media-map]');
          try {
            return JSON.parse((mapEl && mapEl.textContent) || '{}') || {};
          } catch (e) {
            return {};
          }
        }

        getCurrentVariantId() {
          const formId = this.querySelector('input[name="properties[Decoration Method]"]')?.getAttribute('form');
          const form = formId
            ? document.getElementById(formId)
            : document.querySelector('form[action*="/cart/add"]');
          const idInput = form && form.querySelector('input[name="id"]');
          return idInput ? String(idInput.value) : '';
        }

        getMediaMapEntry() {
          const map = this.getMediaMap();
          const variantId = this.getCurrentVariantId();
          return (map && variantId && map[variantId]) || null;
        }

        /* Journals (template journals / type Journals): their media map also has photo + straight-on blank,
           but they are single products, never a gift set (2026-10-02 Pepe pack). */
        isJournalProduct() {
          const suffix = (this.dataset.templateSuffix || '').toLowerCase();
          const ptype = (this.dataset.productType || '').toLowerCase();
          return suffix === 'journals' || suffix === 'journal' || ptype === 'journals' || ptype === 'journal';
        }

        /* Gift-set pattern: title/handle looks like a gift/decanter set. Never for hats/apparel/journals.
           2026-10-07 pack2 (#167 only, not ported): a blank + laser photo pair is NOT a set signal. Nearly every
           single drinkware/glassware product has one (its "SKU | blank" / "Laser Engraving" media or the
           {SKU}-blank.jpg fallback), so 55 single items showed "This set: every piece gets the same sandcarved
           logo". Non-RTIC: name match only (all 9 real sets match). RTIC keeps its generic "Every piece in your
           order..." note exactly as before (blank+laser OR name). hasGiftSetBlankLaser (set-photo toggle) and the
           glassware method locks are unchanged. */
        isGiftSetProduct(entry) {
          const suffix = (this.dataset.templateSuffix || '').toLowerCase();
          const ptype = (this.dataset.productType || '').toLowerCase();
          if (suffix === 'hats' || ptype === 'hats' || suffix === 'apparel' || ptype === 'apparel') {
            return false;
          }
          if (this.isJournalProduct()) return false;
          if (this.isHatsProduct()) return false;
          const title = String(this.dataset.productTitle || '').toLowerCase();
          const handleGuess =
            (document.querySelector('link[rel="canonical"]')?.href || window.location.pathname || '').toLowerCase();
          const nameHit =
            /gift[\s-]?set|decanter[\s-]?set/.test(title) ||
            /gift-set|decanter-set/.test(handleGuess);
          if (nameHit) return true;
          const isRtic = String(this.dataset.productVendor || '').trim().toLowerCase() === 'rtic';
          if (!isRtic) return false;
          const e = entry || this.getMediaMapEntry();
          return !!(e && e.blank && e.laser);
        }

        hasGiftSetBlankLaser(entry) {
          if (this.isJournalProduct()) return false;
          const e = entry || this.getMediaMapEntry();
          return !!(e && e.blank && e.laser);
        }

        ensureGiftSetCaveat() {
          if (!this.isGiftSetProduct() && this.dataset.flaskSet !== '1') {
            const existing = this.querySelector('[data-sancando-gift-set-caveat]');
            if (existing) existing.remove();
            return;
          }
          if (this.querySelector('[data-sancando-gift-set-caveat]')) return;
          const callout = document.createElement('p');
          callout.className = 'sancando-gift-set-caveat';
          callout.setAttribute('data-sancando-gift-set-caveat', '1');
          const isRtic = String(this.dataset.productVendor || '').trim().toLowerCase() === 'rtic';
          /* 2026-10-23 (#167 only): flask sets = flask front only (UV print for color art, laser engraving for text). */
          if (this.dataset.flaskSet === '1') {
            const btc = Number(this.dataset.boxTopCents || 595);
            callout.innerHTML = 'Your logo or text goes on the flask front. ' +
              (this.dataset.boxTopVariant
                ? 'Want the box top decorated too? Turn on “Decorate box top” below (+$' + (btc / 100).toFixed(2) + ').'
                : 'Want the box top decorated too? Email <a href="mailto:sandi@sancandoswag.com">sandi@sancandoswag.com</a>.');
          } else
          callout.innerHTML = isRtic
            ? 'Every piece in your order gets the same logo or text. ' +
              'Want different art on each piece? Email ' +
              '<a href="mailto:sandi@sancandoswag.com">sandi@sancandoswag.com</a>.'
            : 'This set: every piece gets the <strong>same</strong> sandcarved logo or text. ' +
              'Want different art on each piece? Email ' +
              '<a href="mailto:sandi@sancandoswag.com">sandi@sancandoswag.com</a>.';
          const helper = this.querySelector('.sancando-customization__helper');
          const header = this.querySelector('.sancando-customization__header');
          if (helper && helper.parentNode) {
            helper.insertAdjacentElement('afterend', callout);
          } else if (header) {
            header.appendChild(callout);
          } else {
            this.insertBefore(callout, this.firstChild);
          }
        }

        bindSetViewToggleClicks(bar) {
          if (!bar || bar.dataset.sancandoSetViewBound === 'true') return;
          bar.dataset.sancandoSetViewBound = 'true';
          bar.addEventListener('click', (ev) => {
            const t = ev.target;
            if (!(t instanceof Element)) return;
            const entry = this.getMediaMapEntry();
            if (!entry) return;
            if (t.closest('[data-sancando-view-set]')) {
              this._viewingSetPhoto = true;
              if (entry.laser) this.setVisibleProductImage(this.setPhotoUrl(entry));
              this.syncGiftSetChrome(true, entry);
            } else if (t.closest('[data-sancando-view-blank]')) {
              this._viewingSetPhoto = false;
              if (entry.blank) this.setVisibleProductImage(entry.blank);
              this.syncGiftSetChrome(true, entry);
            }
          });
        }

        buildSetViewToggleBar(attrs) {
          const bar = document.createElement('div');
          bar.className = 'sancando-set-view-toggle';
          Object.keys(attrs || {}).forEach((k) => bar.setAttribute(k, attrs[k]));
          bar.hidden = true;
          bar.innerHTML =
            '<button type="button" class="sancando-set-view-toggle__btn" data-sancando-view-set>View set photo</button>' +
            '<button type="button" class="sancando-set-view-toggle__btn" data-sancando-view-blank hidden>Back to customize preview</button>';
          this.bindSetViewToggleClicks(bar);
          return bar;
        }

        ensureSetViewToggle() {
          const formBar = this.querySelector('[data-sancando-set-view-toggle]');
          const galleryBar = document.querySelector('[data-sancando-set-view-toggle-gallery]');
          if (!this.hasGiftSetBlankLaser()) {
            if (formBar) formBar.remove();
            if (galleryBar) galleryBar.remove();
            return null;
          }
          let bar = formBar;
          if (!bar) {
            bar = this.buildSetViewToggleBar({ 'data-sancando-set-view-toggle': '1' });
            const header = this.querySelector('.sancando-customization__header');
            if (header) header.insertAdjacentElement('afterend', bar);
            else this.insertBefore(bar, this.firstChild);
          }
          if (!galleryBar) {
            const gallery =
              document.querySelector('.sancando-drinkware-gallery') ||
              document.querySelector('.product-media-gallery') ||
              document.querySelector('media-gallery');
            if (gallery) {
              const gBar = this.buildSetViewToggleBar({
                'data-sancando-set-view-toggle': '1',
                'data-sancando-set-view-toggle-gallery': '1',
              });
              gallery.insertAdjacentElement('afterend', gBar);
            }
          }
          return bar;
        }

        /* 2026-10-23 flask sets: custom.imprint_preview_set = {variantId:{top,left,width,height}} box for the
           "View set photo" view (set photo flask is smaller/offset). Blank customize view keeps custom.imprint_preview.
           Products without the metafield are unchanged. */
        currentSetEntry() {
          let map = null;
          try { map = JSON.parse(this.dataset.setImprintAreas || 'null'); } catch (e) { map = null; }
          if (!map || typeof map !== 'object') return null;
          const formId = this.querySelector('input[name="properties[Decoration Method]"]')?.getAttribute('form');
          const form = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');
          const vid = form && form.querySelector('input[name="id"]') ? String(form.querySelector('input[name="id"]').value) : '';
          return map[vid] || null;
        }

        /* Set-photo background: clean (no placeholder art) bg from custom.imprint_preview_set when present. */
        setPhotoUrl(entry) {
          const se = this.currentSetEntry();
          return (se && se.bg) || (entry && entry.laser) || '';
        }

        /* 2026-10-23 FSK11 pilot: optional per-variant "corners" [[x%,y%]x4: TL,TR,BR,BL of frame] fit the
           set-photo box to the flask face with a perspective matrix3d. Only when viewing set photo + clean bg. */
        applySetQuad() {
          const se = this.currentSetEntry();
          const on = !!(this._viewingSetPhoto && se && se.bg && Array.isArray(se.corners) && se.corners.length === 4);
          const boxes = this.textBoxes().concat(this.imprintBoxes());
          if (!on) {
            if (this._setQuadOn) {
              this._setQuadOn = false;
              boxes.forEach((b) => { b.style.transform = ''; b.style.transformOrigin = 'center center'; delete b.dataset.setQuad; });
              try { this.setTextRotation(0); } catch (e) { /* ignore */ }
            }
            return;
          }
          this._setQuadOn = true;
          if (!this._setQuadResize) {
            this._setQuadResize = true;
            window.addEventListener('resize', () => { try { this.applySetQuad(); } catch (e) { /* ignore */ } });
          }
          boxes.forEach((b) => {
            const fr = b.offsetParent;
            if (!fr) return;
            const W = fr.clientWidth, H = fr.clientHeight, bw = b.offsetWidth, bh = b.offsetHeight;
            if (!W || !H || !bw || !bh) return;
            const q = se.corners.map((c) => [Number(c[0]) / 100 * W - b.offsetLeft, Number(c[1]) / 100 * H - b.offsetTop]);
            const [x0, y0] = q[0], [x1, y1] = q[1], [x2, y2] = q[2], [x3, y3] = q[3];
            const dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3;
            const dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
            const den = dx1 * dy2 - dx2 * dy1;
            let g = 0, h = 0;
            if (den && (dx3 || dy3)) { g = (dx3 * dy2 - dx2 * dy3) / den; h = (dx1 * dy3 - dx3 * dy1) / den; }
            const a = x1 - x0 + g * x1, bb = x3 - x0 + h * x3, d = y1 - y0 + g * y1, e = y3 - y0 + h * y3;
            const m = [a / bw, d / bw, 0, g / bw, bb / bh, e / bh, 0, h / bh, 0, 0, 1, 0, x0, y0, 0, 1];
            b.style.transformOrigin = '0 0';
            b.style.transform = 'matrix3d(' + m.map((v) => (Math.abs(v) < 1e-12 ? 0 : +v.toFixed(8))).join(',') + ')';
            b.dataset.setQuad = '1';
          });
        }

        applySetPhotoArea(on) {
          let map = null;
          try { map = JSON.parse(this.dataset.setImprintAreas || 'null'); } catch (e) { map = null; }
          if (!map || typeof map !== 'object') return false;
          const formId = this.querySelector('input[name="properties[Decoration Method]"]')?.getAttribute('form');
          const form = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');
          const vid = form && form.querySelector('input[name="id"]') ? String(form.querySelector('input[name="id"]').value) : '';
          const setArea = map[vid] || null;
          let changed = false;
          document.querySelectorAll('.sancando-imprint-preview, .sancando-imprint-text').forEach((el) => {
            if (el.dataset.blankImprintArea === undefined) el.dataset.blankImprintArea = el.getAttribute('data-imprint-area') || '';
            let want = el.dataset.blankImprintArea;
            if (on && setArea && setArea.top) want = JSON.stringify({ top: setArea.top, left: setArea.left, width: setArea.width, height: setArea.height });
            else if (setArea && setArea.blank && setArea.blank.top) want = JSON.stringify(setArea.blank);
            if (!want || el.getAttribute('data-imprint-area') === want) return;
            el.setAttribute('data-imprint-area', want);
            if (el.dataset.mfImprintArea !== undefined) el.dataset.mfImprintArea = want;
            delete el.dataset.userMoved;
            changed = true;
          });
          /* Optional per-variant "rotate" (deg) for the set-photo box; only when the entry has a clean bg. */
          const rot = on && setArea && setArea.bg && setArea.rotate !== undefined ? Number(setArea.rotate) || 0 : null;
          if (rot !== null && this._setPhotoRot !== rot) {
            this._setPhotoRot = rot;
            this.setTextRotation(rot);
            this.imprintBoxes().forEach((b) => { b.style.transform = rot ? 'rotate(' + rot + 'deg)' : ''; b.style.transformOrigin = 'center center'; });
          } else if (rot === null && this._setPhotoRot !== undefined && this._setPhotoRot !== null) {
            this._setPhotoRot = null;
            this.setTextRotation(0);
            this.imprintBoxes().forEach((b) => { b.style.transform = ''; });
          }
          if (changed) requestAnimationFrame(() => { try { this.syncImprintPreview(); } catch (e) { /* ignore */ } });
          return changed;
        }

        syncGiftSetChrome(customizing, entry) {
          this.ensureGiftSetCaveat();
          this.ensureSetViewToggle();
          const bars = Array.from(
            document.querySelectorAll('[data-sancando-set-view-toggle]')
          );
          const show = !!(customizing && this.hasGiftSetBlankLaser(entry));
          if (!customizing) this._viewingSetPhoto = false;
          const viewing = !!this._viewingSetPhoto;
          try { this.applySetPhotoArea(!!(show && viewing)); } catch (e) { /* ignore */ }
          /* 2026-10-23 Jefe "copy over copy": set photos carry printed placeholder art, so on flask sets
             (custom.imprint_preview_set present) hide the overlay box while "View set photo" is active. */
          try {
            let hasSet = false;
            try { const m = JSON.parse(this.dataset.setImprintAreas || 'null'); hasSet = !!(m && typeof m === 'object'); } catch (e) { hasSet = false; }
            if (hasSet && !document.getElementById('sancando-set-view-hide-css')) {
              const st = document.createElement('style');
              st.id = 'sancando-set-view-hide-css';
              st.textContent = 'html.sancando-viewing-set-photo .product-media .sancando-imprint-preview,html.sancando-viewing-set-photo .product-media .sancando-imprint-text,html.sancando-viewing-set-photo .product-media .sancando-leatherette-plate{visibility:hidden!important;}';
              document.head.appendChild(st);
            }
            const seBg = hasSet ? this.currentSetEntry() : null;
            document.documentElement.classList.toggle('sancando-viewing-set-photo', !!(hasSet && show && viewing && !(seBg && seBg.bg)));
            if (hasSet) { this.applySetQuad(); requestAnimationFrame(() => { try { this.applySetQuad(); } catch (e) { /* ignore */ } }); }
          } catch (e) { /* ignore */ }
          bars.forEach((b) => {
            b.hidden = !show;
            const viewSet = b.querySelector('[data-sancando-view-set]');
            const viewBlank = b.querySelector('[data-sancando-view-blank]');
            if (viewSet) viewSet.hidden = !show || viewing;
            if (viewBlank) viewBlank.hidden = !show || !viewing;
            b.classList.toggle('is-viewing-set', viewing);
          });
        }

        applyHatFrontMedia(map, variantId) {
          /* Hats: like apparel — NEVER overwrite Horizon's color gallery with
             setVisibleProductImage. That stamped the OLD color onto the new
             variant and made logos look "stuck." Only prefer the hat_front
             slide for this color, then remount the imprint on top. */
          const entry = (map && map[variantId]) || {};
          const color = String(entry.color || '');
          const isFrontAlt = (alt) => /hat_front|\|\s*Front\s*\|/i.test(alt || '');
          const matchesColor = (alt) =>
            !color || String(alt || '').toLowerCase().indexOf(color.toLowerCase()) !== -1;

          const activateFrontSlide = () => {
            const slides = document.querySelectorAll(
              '.product-media-gallery slideshow-slide, .sancando-hats-gallery slideshow-slide, slideshow-slide'
            );
            let frontSlide = null;
            slides.forEach((slide) => {
              if (frontSlide) return;
              const img = slide.querySelector('img');
              const alt = (img && img.getAttribute('alt')) || '';
              if (isFrontAlt(alt) && matchesColor(alt)) frontSlide = slide;
            });
            if (!frontSlide) {
              slides.forEach((slide) => {
                if (frontSlide) return;
                const img = slide.querySelector('img');
                const alt = (img && img.getAttribute('alt')) || '';
                if (isFrontAlt(alt)) frontSlide = slide;
              });
            }
            if (!frontSlide) return null;

            const frontImg = frontSlide.querySelector('img');
            const frontAlt = (frontImg && frontImg.getAttribute('alt')) || '';
            const thumbs = document.querySelectorAll(
              '.product-media-gallery button[aria-label], .thumbnail-list button, [data-thumbnail]'
            );
            let clicked = false;
            thumbs.forEach((btn) => {
              if (clicked) return;
              const label = btn.getAttribute('aria-label') || '';
              if (frontAlt && label && label.indexOf(frontAlt.split('|')[0].trim()) !== -1 && /front/i.test(label)) {
                try {
                  btn.click();
                  clicked = true;
                } catch (err) {
                  /* ignore */
                }
              }
            });

            if (!clicked) {
              try {
                frontSlide.removeAttribute('hidden');
                frontSlide.setAttribute('aria-hidden', 'false');
                if (frontSlide.scrollIntoView) {
                  frontSlide.scrollIntoView({ block: 'nearest', inline: 'center' });
                }
              } catch (err) {
                /* ignore */
              }
            }
            return frontImg;
          };

          activateFrontSlide();
          /* SanCanDo 2026-09-29 antifreeze: syncImprintPreview() ends in applyDecorationMedia() ->
             applyHatFrontMedia() -> syncImprintPreview() again. Without this guard that recursed
             ~1.4k-4k levels until the stack overflowed (RangeError swallowed below), each level
             forcing a layout via scrollIntoView: 17-33 s freeze after upload, 90+ s on colour switch.
             One nested pass keeps the old end state (front slide + imprint remount + sync). */
          if (this._hatFrontSyncing) return;
          this._hatFrontSyncing = true;
          try {
            this.restoreLogoFromCache();
            this.remountImprintsOnVisibleMedia();
            this.syncImprintPreview();
          } catch (err) {
            /* ignore */
          } finally {
            this._hatFrontSyncing = false;
          }
        }

        syncFontPreview(select) {
          if (!(select instanceof HTMLSelectElement) || !select.dataset.textPreview) return;
          const font = select.value || 'Bree Serif';
          const family = '"' + font + '", sans-serif';
          select.style.fontFamily = family;
          const input = document.getElementById(select.dataset.textPreview);
          if (input) input.style.fontFamily = family;
        }

        bothSidesPieceCount() {
          const raw = Number(this.dataset.bothSidesPieces || this.getAttribute('data-both-sides-pieces') || 1);
          return Number.isFinite(raw) && raw > 0 ? Math.floor(raw) : 1;
        }

        syncBothPriceNote() {
          const note = this.querySelector('[data-both-price-note]');
          const check = this.querySelector('[data-charge-both-check]');
          const bothRadio = this.querySelector('input[name="properties[Engraving Side]"][value="Both sides"]');
          const on = (bothRadio && bothRadio.checked) || (check && check.checked);
          if (!note) return;
          note.hidden = !on;
          const unit = Number(note.dataset.bothUnit || 5.95);
          const pieces = Number(note.dataset.bothPieces || this.bothSidesPieceCount() || 1);
          const nUnit = Number.isFinite(unit) ? unit : 5.95;
          const nPieces = Number.isFinite(pieces) && pieces > 0 ? Math.floor(pieces) : 1;
          const total = Math.round(nUnit * nPieces * 100) / 100;
          const money = (n) =>
            n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          /* 2026-10-09 (#167 only): public-price products show the real second-side fee and bump the PDP price. */
          if (this.dataset.bothFeePublic === '1') {
            const cents = Number(this.dataset.bothFeeCents || 595);
            const fee = Math.round((Number.isFinite(cents) ? cents : 595) * nPieces) / 100;
            note.textContent = '+' + money(fee) + ' second-side engraving, added to your cart';
            this.syncBothPdpPrice(on ? fee : 0);
            return;
          }
          if (nPieces > 1) {
            note.textContent =
              'Both sides — pricing on quote';
          } else {
            note.textContent = 'Both sides — pricing on quote';
          }
        }

        /* 2026-10-09 (#167 only): PDP price (public-price block) = base + fee while both sides is on; restores the base when off.
           Survives Horizon variant re-renders of product-price (observer re-applies the fee to the fresh base). */
        syncBothPdpPrice(fee) {
          this._bothPdpFee = fee || 0;
          const money = (n) => n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          const scope = this.closest('.shopify-section') || document;
          const els = [...scope.querySelectorAll('product-price[data-sancando-public-price] .price')].filter(
            (el) => !el.classList.contains('compare-at-price')
          );
          els.forEach((el) => {
            const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
            let node = null;
            for (let n = walker.nextNode(); n; n = walker.nextNode()) {
              if (/\$\s*[\d,]+\.\d{2}/.test(n.nodeValue) && !(n.parentElement && n.parentElement.classList.contains('visually-hidden'))) node = n;
            }
            if (!node) return;
            const cur = node.nodeValue.trim();
            let base;
            if (el.dataset.scBothShown && cur === el.dataset.scBothShown && el.dataset.scBothBase) base = Number(el.dataset.scBothBase);
            else base = Number(cur.replace(/[^\d.]/g, ''));
            if (!Number.isFinite(base) || base <= 0) return;
            const shown = money(Math.round((base + this._bothPdpFee) * 100) / 100);
            el.dataset.scBothBase = String(base);
            el.dataset.scBothShown = shown;
            if (cur !== shown) node.nodeValue = node.nodeValue.replace(cur, shown);
          });
          if (!this._bothPdpObs && typeof MutationObserver !== 'undefined') {
            let busy = false;
            this._bothPdpObs = new MutationObserver(() => {
              if (busy || !this._bothPdpFee) return;
              busy = true;
              window.requestAnimationFrame(() => {
                try { this.syncBothPdpPrice(this._bothPdpFee); } finally { busy = false; }
              });
            });
            this._bothPdpObs.observe(scope, { subtree: true, childList: true, characterData: true });
          }
        }

        syncBackSame() {
          const hidden = this.querySelector('[data-sancando-back-same]');
          if (!hidden) return;
          const bothRadio = this.querySelector('input[name="properties[Engraving Side]"][value="Both sides"]');
          const check = this.querySelector('input[name="properties[Both Sides]"][type="checkbox"]');
          const on = !!(bothRadio && bothRadio.checked) || !!(check && check.checked);
          hidden.disabled = !on;
        }

        syncEngravingSide() {
          const bothRadio = this.querySelector('input[name="properties[Engraving Side]"][value="Both sides"]');
          const hidden = this.querySelector('[data-both-sides-prop]');
          const on = !!(bothRadio && bothRadio.checked);
          if (hidden) hidden.disabled = !on;
          this.syncBackSame();
          this.syncBothPriceNote();
        }

        applyReveal(panel, on) {
          panel.hidden = !on;
          panel.querySelectorAll('input, textarea, select').forEach((el) => {
            el.disabled = !on;
            if (!on) {
              if (el instanceof HTMLInputElement && el.type === 'file') {
                el.value = '';
                const nameEl = document.getElementById(el.dataset.filenameTarget);
                if (nameEl) nameEl.textContent = '';
                const errorEl = document.getElementById(el.dataset.errorTarget);
                if (errorEl) {
                  errorEl.hidden = true;
                  errorEl.textContent = '';
                  errorEl.classList.remove('is-visible');
                }
              } else if (
                (el instanceof HTMLInputElement && el.type === 'text') ||
                (el instanceof HTMLTextAreaElement && el.name === 'properties[Text - Front]')
              ) {
                el.value = '';
              }
            } else if (el instanceof HTMLSelectElement) {
              this.syncFontPreview(el);
            }
          });
        }

        bindRequiredLogo() {
          if ((this.dataset.mode || '') !== 'logo_only') return;
          if (this.dataset.requiredLogoBound === 'true') return;
          this.dataset.requiredLogoBound = 'true';
          const root = this;
          const logoInput = () => root.querySelector('input[name="properties[Logo - Front]"]');
          const hasLogo = () => {
            const input = logoInput();
            if (input && input.files && input.files[0]) return true;
            return typeof root.hasCachedOrInputLogo === 'function' && root.hasCachedOrInputLogo();
          };
          const showNeed = () => {
            const input = logoInput();
            const errorEl = input && input.dataset.errorTarget
              ? document.getElementById(input.dataset.errorTarget)
              : null;
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = 'Upload a logo to continue.';
              errorEl.classList.add('is-visible');
            }
            if (input && typeof input.scrollIntoView === 'function') {
              input.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          };
          const guardEvent = (event) => {
            if (hasLogo()) return false;
            if (event && typeof event.preventDefault === 'function') {
              event.preventDefault();
              event.stopPropagation();
            }
            showNeed();
            return true;
          };
          document.addEventListener(
            'click',
            (e) => {
              const t = e.target;
              if (!(t instanceof Element)) return;
              if (!t.closest('button[type="submit"], button[name="add"], [name="add"], .add-to-cart')) return;
              guardEvent(e);
            },
            true
          );
          document.addEventListener(
            'submit',
            (e) => {
              const form = e.target;
              if (!(form instanceof HTMLFormElement)) return;
              const action = form.getAttribute('action') || '';
              if (action.indexOf('/cart/add') === -1) return;
              guardEvent(e);
            },
            true
          );
          /* Client-side Ajax ATC guard: native required + click/submit do not
             stop fetch/XHR /cart/add.js with no logo. Block before network. */
          if (root.dataset.requiredLogoFetchBound !== 'true') {
            root.dataset.requiredLogoFetchBound = 'true';
            const cartAddRe = /\/cart\/add(\.js)?(\?|$)/i;
            const prevFetch = window.fetch.bind(window);
            window.fetch = async (input, init) => {
              const url = typeof input === 'string' ? input : (input && input.url) || '';
              if (cartAddRe.test(url) && !hasLogo()) {
                const body = init && init.body;
                let looksLikeAddonOnly = false;
                try {
                  if (typeof body === 'string' && /digitizing|_addon/i.test(body)) looksLikeAddonOnly = true;
                  if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
                    const ids = body.getAll('items[][id]').concat(body.getAll('id'));
                    /* fee-only adds should not require a logo file */
                    if (!body.get('properties[Decoration Method]') && !body.get('properties[Logo - Front]')) {
                      looksLikeAddonOnly = true;
                    }
                  }
                } catch (err) {
                  /* fall through to logo check */
                }
                if (!looksLikeAddonOnly) {
                  showNeed();
                  return new Response(
                    JSON.stringify({
                      status: 422,
                      message: 'Upload a logo to continue.',
                      description: 'A logo file is required before adding this product to cart.',
                    }),
                    { status: 422, headers: { 'Content-Type': 'application/json' } }
                  );
                }
              }
              return prevFetch(input, init);
            };
          }
        }


        /* 2026-10-24 (#167 only): flask-set box-top add-on v2 (replaces 2026-10-23 prep).
           Toggle "Decorate box top (+$5.95)" -> text and/or logo, laser or full-color UV. While on, the product media shows the
           CLOSED blank box (custom.box_top_preview {variantId:{bg,corners}}) with the text/logo fitted to the lid via matrix3d;
           "Back to flask front" hides it. Fee line (_addon box-top, _parent) is added after the product add succeeds, qty = product qty.
           Internal data: _Box top preview, _Box top fee variant (hidden at checkout). Requires text or logo when on. */
        bindBoxTopAddon() {
          const feeVid = String(this.dataset.boxTopVariant || '').trim();
          if (!feeVid) return;
          const root = this;
          const wrap = root.querySelector('[data-box-top]');
          if (!wrap || root.dataset.boxTopBound === 'true') return;
          root.dataset.boxTopBound = 'true';
          const q = (sel) => wrap.querySelector(sel);
          const check = q('[data-box-top-check]'), panel = q('[data-box-top-panel]'), prop = q('[data-box-top-prop]');
          const bgProp = q('[data-box-top-bgprop]'), feeProp = q('[data-box-top-feeprop]');
          const text = q('[data-box-top-text]'), file = q('[data-box-top-file]'), err = q('[data-box-top-error]');
          const noPhoto = q('[data-box-top-nophoto]'), showBtn = q('[data-box-top-show]');
          const type = () => { const r = wrap.querySelector('[data-box-top-type]:checked'); return r ? r.value : 'Laser engraved'; };
          const on = () => !!(check && check.checked);
          let previewMap = null;
          try { previewMap = JSON.parse(root.dataset.boxTopPreview || 'null'); } catch (e) { previewMap = null; }
          const currentVid = () => {
            const formId = text && text.getAttribute('form');
            const form = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');
            const inp = form && form.querySelector('[name="id"]');
            return inp ? String(inp.value) : '';
          };
          const entry = () => {
            if (!previewMap || typeof previewMap !== 'object') return null;
            const e = previewMap[currentVid()] || null;
            return e && e.bg ? e : null;
          };
          let userHidden = false, logoUrl = '', stage = null;
          const pos = { logo: null, text: null, userMoved: false, layoutKey: '' };
          const BT_MAX_LINES = 4, BT_MAX_CHARS = 30;
          const btLines = (v) => String(v || '').replace(/\r/g, '').split('\n').slice(0, BT_MAX_LINES).map((l) => l.slice(0, BT_MAX_CHARS));
          const posText = q('[data-box-top-textpos]'), posLogo = q('[data-box-top-logopos]');
          const rnd = (r) => r ? JSON.stringify({ left: +r.left.toFixed(1) + '%', top: +r.top.toFixed(1) + '%', width: +r.width.toFixed(1) + '%', height: +r.height.toFixed(1) + '%' }) : '';
          const savePos = () => {
            const isOn = on(), hasT = !!String(text.value || '').trim(), hasL = !!logoUrl;
            if (posText) { posText.disabled = !(isOn && hasT && pos.text); posText.value = isOn && hasT ? rnd(pos.text) : ''; }
            if (posLogo) { posLogo.disabled = !(isOn && hasL && pos.logo); posLogo.value = isOn && hasL ? rnd(pos.logo) : ''; }
          };
          const galleryHost = () =>
            document.querySelector('.sancando-drinkware-gallery') ||
            document.querySelector('.product-media-gallery') ||
            document.querySelector('media-gallery') ||
            document.querySelector('.product-information__media');
          const buildStage = () => {
            const host = galleryHost();
            if (!host) return null;
            if (stage && host.contains(stage)) return stage;
            if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
            stage = document.createElement('div');
            stage.className = 'sancando-boxtop-stage';
            stage.setAttribute('data-sancando-boxtop-stage', '');
            stage.innerHTML =
              '<style>.sancando-boxtop-stage[hidden],html:not(.sancando-boxtop-on) .sancando-boxtop-stage{display:none!important;}.sancando-boxtop-stage{position:absolute;inset:0;z-index:1000;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;}' +
              '.sancando-boxtop-stage__frame{position:relative;width:min(100%,640px);aspect-ratio:1/1;overflow:hidden;}' +
              '.sancando-boxtop-stage__frame>img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;}' +
              '.sancando-boxtop-stage__box{position:absolute;left:0;top:0;width:300px;height:150px;overflow:visible;pointer-events:none;outline:1.5px dashed rgba(255,255,255,.95);box-shadow:0 0 0 1.5px rgba(0,0,0,.28);}' +
              '.sancando-bt-item{position:absolute;box-sizing:border-box;pointer-events:auto;cursor:move;touch-action:none;display:flex;align-items:center;justify-content:center;user-select:none;-webkit-user-select:none;}' +
              '.sancando-bt-item:hover,.sancando-bt-item.is-drag{outline:1px dashed rgba(60,120,220,.9);}' +
              '.sancando-bt-item img{max-width:100%;max-height:100%;object-fit:contain;pointer-events:none;}' +
              '.sancando-bt-item span{font-weight:600;line-height:1.1;text-align:center;white-space:pre;pointer-events:none;}' +
              '.sancando-bt-rs{position:absolute;right:-6px;bottom:-6px;width:12px;height:12px;background:#fff;border:1.5px solid #3c78dc;border-radius:2px;cursor:nwse-resize;touch-action:none;}' +
              '.sancando-boxtop-stage__bar{display:flex;gap:12px;align-items:center;padding:8px 0;font-size:14px;}' +
              '.sancando-boxtop-stage__bar button{border:1px solid currentColor;border-radius:999px;background:#fff;padding:6px 14px;cursor:pointer;font:inherit;}</style>' +
              '<div class="sancando-boxtop-stage__bar"><strong>Box top preview</strong><button type="button" data-boxtop-back>Back to flask front</button></div>' +
              '<div class="sancando-boxtop-stage__frame"><img alt="Gift box top (closed)"><div class="sancando-boxtop-stage__box"></div></div>';
            host.appendChild(stage);
            stage.querySelector('[data-boxtop-back]').addEventListener('click', () => { userHidden = true; render(); });
            return stage;
          };
          const fitBox = (st, corners) => {
            const fr = st.querySelector('.sancando-boxtop-stage__frame'), b = st.querySelector('.sancando-boxtop-stage__box');
            const W = fr.clientWidth, H = fr.clientHeight, bw = b.offsetWidth, bh = b.offsetHeight;
            if (!W || !H || !bw || !bh) return;
            const qd = corners.map((c) => [Number(c[0]) / 100 * W, Number(c[1]) / 100 * H]);
            const [x0, y0] = qd[0], [x1, y1] = qd[1], [x2, y2] = qd[2], [x3, y3] = qd[3];
            const dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
            const den = dx1 * dy2 - dx2 * dy1;
            let g = 0, h = 0;
            if (den && (dx3 || dy3)) { g = (dx3 * dy2 - dx2 * dy3) / den; h = (dx1 * dy3 - dx3 * dy1) / den; }
            const a = x1 - x0 + g * x1, bb = x3 - x0 + h * x3, d = y1 - y0 + g * y1, e = y3 - y0 + h * y3;
            const m = [a / bw, d / bw, 0, g / bw, bb / bh, e / bh, 0, h / bh, 0, 0, 1, 0, x0, y0, 0, 1];
            b.style.transformOrigin = '0 0';
            b.style.transform = 'matrix3d(' + m.map((v) => (Math.abs(v) < 1e-12 ? 0 : +v.toFixed(8))).join(',') + ')';
          };
          /* 2026-11-04: lid-face bounds (% of the square blank) from the flat box-top photo; cached per bg, null until measured. */
          const btLidCache = window.__sancandoBtLid || (window.__sancandoBtLid = {});
          const btLid = (bg, done) => {
            if (!bg) return null;
            const k = String(bg);
            if (Object.prototype.hasOwnProperty.call(btLidCache, k)) return btLidCache[k] === 'pending' ? null : btLidCache[k];
            btLidCache[k] = 'pending';
            try {
              const im = new Image();
              im.crossOrigin = 'anonymous';
              im.onload = () => {
                let r = false;
                try {
                  const N = 200, cv = document.createElement('canvas');
                  cv.width = N; cv.height = N;
                  const cx = cv.getContext('2d');
                  cx.drawImage(im, 0, 0, N, N);
                  const px = cx.getImageData(0, 0, N, N).data, col = new Array(N).fill(0), row = new Array(N).fill(0);
                  for (let y = 0; y < N; y++) for (let x = 0; x < N; x++) {
                    const i = (y * N + x) * 4;
                    if (765 - px[i] - px[i + 1] - px[i + 2] > 60) { col[x]++; row[y]++; }
                  }
                  const span = (a) => { const m = Math.max(...a); let lo = -1, hi = -1; a.forEach((v, i) => { if (v > m * 0.5) { if (lo < 0) lo = i; hi = i; } }); return m > 0 ? [lo, hi + 1] : null; };
                  const sx = span(col), sy = span(row);
                  if (sx && sy && sx[1] - sx[0] > N * 0.2 && sy[1] - sy[0] > N * 0.2) {
                    const ix = (sx[1] - sx[0]) * 0.04, iy = (sy[1] - sy[0]) * 0.04;
                    r = [(sx[0] + ix) / N * 100, (sx[1] - ix) / N * 100, (sy[0] + iy) / N * 100, (sy[1] - iy) / N * 100];
                  }
                } catch (e) { r = false; }
                btLidCache[k] = r || false;
                if (r && typeof done === 'function') { try { done(); } catch (e2) { /* ignore */ } }
              };
              im.onerror = () => { btLidCache[k] = false; };
              im.src = k + (k.indexOf('?') === -1 ? '?' : '&') + 'width=400';
            } catch (e) { btLidCache[k] = false; }
            return null;
          };
          /* 2026-10-25 Jefe "no box checked ... see the image": the stage's display:flex beat [hidden], so after
             unchecking, the box-top preview (with the box-top logo) stayed over the gallery. Unchecked now removes every
             stage; a stale binding (section re-render) never draws, adds a fee, or blocks add-to-cart. */
          const live = () => wrap.isConnected;
          const render = () => {
            if (!live()) return;
            const en = entry();
            const want = on() && !!en && !userHidden;
            if (noPhoto) noPhoto.hidden = !(on() && !en);
            if (showBtn) showBtn.hidden = !(on() && en && userHidden);
            if (bgProp) { bgProp.disabled = !(on() && en); bgProp.value = on() && en ? en.bg : ''; }
            document.documentElement.classList.toggle('sancando-boxtop-on', want);
            if (!document.getElementById('sancando-boxtop-hide-css')) {
              const hs = document.createElement('style');
              hs.id = 'sancando-boxtop-hide-css';
              hs.textContent = 'html.sancando-boxtop-on .sancando-imprint-preview,html.sancando-boxtop-on .sancando-imprint-text,html.sancando-boxtop-on .sancando-leatherette-plate{visibility:hidden!important;}';
              document.head.appendChild(hs);
            }
            if (!want) { document.querySelectorAll('[data-sancando-boxtop-stage]').forEach((el) => { el.hidden = true; if (!on()) el.remove(); }); if (!on()) stage = null; return; }
            const st = buildStage();
            if (!st) return;
            st.hidden = false;
            const img = st.querySelector('.sancando-boxtop-stage__frame>img');
            if (img.getAttribute('src') !== en.bg) img.setAttribute('src', en.bg);
            { const f0 = file && !file.disabled && file.files && file.files[0]; if (!f0 && logoUrl) { try { URL.revokeObjectURL(logoUrl); } catch (e4) { /* ignore */ } logoUrl = ''; } }
            const box = st.querySelector('.sancando-boxtop-stage__box');
            const uv = type() === 'Full-color UV print';
            const t = btLines(text.value).join('\n').trim();
            box.innerHTML = '';
            /* 2026-11-03 Jefe "box top text ... can be multiple and should have overlay box to move around": multi-line text
               (max 4 lines x 30 chars) and logo are draggable/resizable items inside the dashed lid print box; positions -> _Box top text box % / _Box top logo box %. */
            const hasLogo = !!logoUrl, hasTxt = !!(t || !logoUrl);
            if (!pos.logo || pos.layoutKey !== (hasLogo ? 'L' : '') + (t ? 'T' : '')) {
              pos.layoutKey = (hasLogo ? 'L' : '') + (t ? 'T' : '');
              if (!pos.userMoved) {
                pos.logo = hasLogo && hasTxt ? { left: 25, top: 4, width: 50, height: 52 } : { left: 15, top: 10, width: 70, height: 80 };
                pos.text = hasLogo && hasTxt ? { left: 5, top: 58, width: 90, height: 38 } : { left: 5, top: 10, width: 90, height: 80 };
              }
            }
            const mkItem = (key, child) => {
              const it = document.createElement('div');
              it.className = 'sancando-bt-item'; it.dataset.btItem = key;
              const r = pos[key];
              it.style.left = r.left + '%'; it.style.top = r.top + '%'; it.style.width = r.width + '%'; it.style.height = r.height + '%';
              it.appendChild(child);
              const rs = document.createElement('div'); rs.className = 'sancando-bt-rs'; it.appendChild(rs);
              const startDrag = (e, mode) => {
                e.preventDefault(); e.stopPropagation();
                const br = box.getBoundingClientRect();
                const kx = (br.width || 300) / 100, ky = (br.height || 150) / 100;
                const sx = e.clientX, sy = e.clientY, o = Object.assign({}, pos[key]);
                it.classList.add('is-drag');
                const mv = (ev) => {
                  const dx = (ev.clientX - sx) / kx, dy = (ev.clientY - sy) / ky, n = pos[key];
                  if (mode === 'move') {
                    n.left = Math.max(0, Math.min(100 - o.width, o.left + dx));
                    n.top = Math.max(0, Math.min(100 - o.height, o.top + dy));
                  } else {
                    const s = Math.max(0.2, Math.min((100 - o.left) / o.width, (100 - o.top) / o.height, 1 + Math.max(dx / o.width, dy / o.height)));
                    n.width = o.width * s; n.height = o.height * s;
                  }
                  it.style.left = n.left + '%'; it.style.top = n.top + '%'; it.style.width = n.width + '%'; it.style.height = n.height + '%';
                  if (key === 'text') fitText(it);
                };
                const up = () => {
                  it.classList.remove('is-drag'); pos.userMoved = true;
                  window.removeEventListener('pointermove', mv, true); window.removeEventListener('pointerup', up, true); window.removeEventListener('pointercancel', up, true);
                  savePos();
                };
                window.addEventListener('pointermove', mv, true); window.addEventListener('pointerup', up, true); window.addEventListener('pointercancel', up, true);
              };
              it.addEventListener('pointerdown', (e) => startDrag(e, 'move'));
              rs.addEventListener('pointerdown', (e) => startDrag(e, 'size'));
              box.appendChild(it);
              return it;
            };
            const fitText = (it) => {
              const sp = it.querySelector('span'); if (!sp) return;
              const ls = (sp.textContent || ' ').split('\n'), mx = Math.max(1, ...ls.map((l) => l.length));
              const w = it.offsetWidth || 270, h = it.offsetHeight || 120;
              sp.style.fontSize = Math.max(6, Math.min(h / (ls.length * 1.15), w / (mx * 0.62), 40)).toFixed(1) + 'px';
            };
            /* 2026-11-03 Jefe "Top of box should be black, same as flask": laser box top uses the flask's leatherette ink
               (single-colour -> solid black, two-tone -> 2nd colour). Non-leatherette (e.g. Rosewood FSK01, UV) unchanged. */
            const btInkMap = {
              solid: { c: '#000', f: 'grayscale(1) brightness(0)' },
              black: { c: '#141414', f: 'grayscale(1) brightness(0) opacity(0.9)' },
              gold: { c: '#c9a878', f: 'brightness(0) invert(0.58) sepia(0.8) saturate(1.8)' },
              silver: { c: '#c2c3c6', f: 'brightness(0) invert(0.765)' }
            };
            let btInk = null;
            if (!uv && /leatherette/i.test((root.dataset.productTitle || '') + ' ' + (root.dataset.productHandle || ''))) {
              try { btInk = btInkMap[root.sancandoLaserInk()] || null; } catch (e5) { btInk = null; }
            }
            if (logoUrl) {
              const li = document.createElement('img'); li.src = logoUrl; li.alt = '';
              li.style.filter = uv ? 'none' : (btInk ? btInk.f : 'grayscale(1) brightness(1.6) contrast(.9)');
              li.style.opacity = uv ? '1' : (btInk ? '1' : '.85');
              mkItem('logo', li);
            }
            if (t || !logoUrl) {
              const sp = document.createElement('span');
              sp.textContent = t || 'Your text here';
              sp.style.opacity = t ? '1' : '.45';
              sp.style.color = uv ? '#111' : (btInk ? btInk.c : (root.dataset.boxTopEngrave || '#d8d2c6'));
              if (!uv && !btInk) sp.style.textShadow = '0 1px 0 rgba(0,0,0,.35)';
              fitText(mkItem('text', sp));
            }
            savePos();
            /* 2026-10-25: straight-on lid blanks (custom.box_top_preview_flat, en.flat) - place the art flat + centred in the print rect, uniform scale, no tilt. */
            /* 2026-11-04 Jefe "Don't limit size for top of box decoration for each method": the print box was the fixed 2:1
               corners rect (~47% x 23% of the photo), so laser and UV art could never grow past it. Flat lids now use the whole
               lid face, measured from the blank photo (CDN sends CORS *), inset 4%, never smaller than the old rect; the dashed
               box takes the lid's aspect so items can be dragged/resized up to the full face. Saved % = % of that lid face. */
            const flatFit = () => {
              const fr = st.querySelector('.sancando-boxtop-stage__frame'), W = fr.clientWidth, H = fr.clientHeight;
              if (!W || !H) return;
              const c = en.corners;
              let rx0 = Math.min(c[0][0], c[3][0]), rx1 = Math.max(c[1][0], c[2][0]), ry0 = Math.min(c[0][1], c[1][1]), ry1 = Math.max(c[2][1], c[3][1]);
              const lid = btLid(en.bg, render);
              if (lid) { rx0 = Math.min(rx0, lid[0]); rx1 = Math.max(rx1, lid[1]); ry0 = Math.min(ry0, lid[2]); ry1 = Math.max(ry1, lid[3]); }
              const x0 = rx0 / 100 * W, x1 = rx1 / 100 * W, y0 = ry0 / 100 * H, y1 = ry1 / 100 * H;
              const bw = 300, bh = Math.max(40, Math.round(bw * (y1 - y0) / (x1 - x0)));
              if (box.offsetHeight !== bh) { box.style.width = bw + 'px'; box.style.height = bh + 'px'; box.querySelectorAll('.sancando-bt-item[data-bt-item="text"]').forEach((it) => fitText(it)); }
              const s = Math.min((x1 - x0) / bw, (y1 - y0) / bh);
              box.style.transformOrigin = '0 0';
              box.style.transform = 'translate(' + ((x0 + x1 - bw * s) / 2).toFixed(2) + 'px,' + ((y0 + y1 - bh * s) / 2).toFixed(2) + 'px) scale(' + s.toFixed(5) + ')';
            };
            const go = () => (en.flat && Array.isArray(en.corners) && en.corners.length === 4) ? flatFit() : fitBox(st, en.corners || [[30, 35], [65, 28], [72, 42], [38, 50]]);
            go(); requestAnimationFrame(go);
            if (!img.complete) img.addEventListener('load', go, { once: true });
          };
          const sync = () => {
            const isOn = on();
            panel.hidden = !isOn;
            prop.disabled = !isOn; prop.value = isOn ? type() : '';
            if (feeProp) feeProp.disabled = !isOn;
            text.disabled = !isOn; file.disabled = !isOn;
            if (err) { err.hidden = true; err.textContent = ''; }
            if (isOn && !wrap.dataset.wasOn) userHidden = false;
            wrap.dataset.wasOn = isOn ? '1' : '';
            render();
            savePos();
          };
          wrap.addEventListener('change', (e) => {
            if (e.target === file) {
              if (logoUrl) { try { URL.revokeObjectURL(logoUrl); } catch (e2) { /* ignore */ } }
              const f0 = file.files && file.files[0];
              logoUrl = f0 && /^image\//.test(f0.type) ? URL.createObjectURL(f0) : '';
            }
            sync();
          });
          text.addEventListener('input', () => {
            const cl = btLines(text.value).join('\n');
            if (cl !== String(text.value).replace(/\r/g, '')) { const c = text.selectionStart; text.value = cl; try { text.setSelectionRange(Math.min(c, cl.length), Math.min(c, cl.length)); } catch (e6) { /* ignore */ } }
            userHidden = false; render();
          });
          text.addEventListener('focus', () => { userHidden = false; render(); });
          if (showBtn) showBtn.addEventListener('click', () => { userHidden = false; render(); });
          document.addEventListener('change', (e) => { if (!wrap.contains(e.target)) setTimeout(render, 60); });
          document.addEventListener('variant:update', () => setTimeout(render, 60));
          window.addEventListener('resize', () => { try { render(); } catch (e) { /* ignore */ } });
          sync();
          const missing = () => {
            if (!live() || !on()) return '';
            const hasT = !!String(text.value || '').trim(), hasF = !!(file.files && file.files[0]);
            return hasT || hasF ? '' : 'Enter box-top text or upload a logo (or turn off “Decorate box top”).';
          };
          const block = (msg) => {
            if (err) { err.hidden = false; err.textContent = msg; err.classList.add('is-visible'); }
            if (text && text.scrollIntoView) text.scrollIntoView({ block: 'center', behavior: 'smooth' });
          };
          const guard = (e) => { const m = missing(); if (!m) return; e.preventDefault(); e.stopPropagation(); block(m); };
          document.addEventListener('click', (e) => {
            const t = e.target;
            if (!(t instanceof Element)) return;
            if (!t.closest('button[type="submit"], button[name="add"], [name="add"], .add-to-cart')) return;
            guard(e);
          }, true);
          document.addEventListener('submit', (e) => {
            const f = e.target;
            if (!(f instanceof HTMLFormElement) || String(f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
            guard(e);
          }, true);
          const cartAddRe = /\/cart\/add(\.js)?(\/|$|\?)/;
          const prevFetch = window.fetch.bind(window);
          const isFeeOnly = (body) => {
            try {
              if (typeof body === 'string') { const j = JSON.parse(body); const it = j.items || [j]; return it.every((x) => x.properties && x.properties._addon); }
            } catch (e2) { /* not json */ }
            return false;
          };
          let queue = Promise.resolve();
          window.fetch = async (input, init) => {
            const url = typeof input === 'string' ? input : (input && input.url) || '';
            if (!cartAddRe.test(url) || !live()) return prevFetch(input, init);
            const body = init && init.body;
            if (isFeeOnly(body)) return prevFetch(input, init);
            const isForm = typeof FormData !== 'undefined' && body instanceof FormData;
            const wants = on() && (isForm ? !!String(body.get('properties[Box Top Decoration]') || '') : true);
            if (wants) {
              const m = missing();
              if (m) {
                block(m);
                return new Response(JSON.stringify({ status: 422, message: m, description: m }), { status: 422, headers: { 'Content-Type': 'application/json' } });
              }
            }
            const res = await prevFetch(input, init);
            if (!wants || !res.ok) return res;
            try { const d = await res.clone().json(); if (d && d.status) return res; } catch (e3) { /* html ok */ }
            const qty = isForm ? Number(body.get('quantity') || 1) || 1 : 1;
            const props = { _addon: 'box-top', For: (root.dataset.productTitle || '').trim(), 'Box top': type() };
            if (root.dataset.productId) props._parent = String(root.dataset.productId);
            const run = queue.then(() => prevFetch('/cart/add.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(feeVid), quantity: qty, properties: props }] }),
            }).then(async (r) => { if (!r.ok) console.warn('[sancando] box-top fee add failed', r.status, await r.text()); return r.ok; }));
            queue = run.catch(() => {});
            const feeOk = await run.catch(() => false);
            /* 2026-10-27 (#167 only, audit fix 1): the fee line WAS reaching the server cart, but Horizon renders the cart drawer from the
               sections HTML in `res`, which Shopify built BEFORE the fee existed -> drawer showed product only (no $5.95 line, product-only subtotal).
               Same fix as the second-side add-on: re-render the requested sections after the fee is in and hand Horizon the fresh HTML. */
            if (feeOk) {
              try {
                const secIds = isForm ? String(body.get('sections') || '') : '';
                if (secIds) {
                  const data = await res.clone().json();
                  if (data && !data.status) {
                    const fresh = await prevFetch(window.location.pathname + '?sections=' + encodeURIComponent(secIds), { credentials: 'same-origin' });
                    if (fresh.ok) {
                      const freshSections = await fresh.json();
                      data.sections = Object.assign({}, data.sections || {}, freshSections || {});
                      return new Response(JSON.stringify(data), { status: res.status, statusText: res.statusText, headers: { 'Content-Type': 'application/json' } });
                    }
                  }
                }
              } catch (e5) { /* keep the original response */ }
            }
            return res;
          };
        }

        bindSecondSideAddon() {
          if (this.dataset.chargeBoth !== 'true') return;
          const variantId = String(this.dataset.secondSideVariant || '').trim();
          if (!variantId) return;
          if (window.__sancandoSecondSideBound === 'true') return;
          window.__sancandoSecondSideBound = 'true';
          const origFetch = window.fetch.bind(window);
          const cartAddRe = /\/cart\/add(\.js)?(\/|$|\?)/;
          const feeVid = String(variantId);

          const getRoot = () => document.querySelector('sancando-customization[data-charge-both="true"]');

          const readUiWantsBoth = () => {
            const root = getRoot();
            if (!root) return false;
            const bothRadio = root.querySelector('input[name="properties[Engraving Side]"][value="Both sides"]');
            if (bothRadio && bothRadio.checked) return true;
            const check = root.querySelector('input[name="properties[Both Sides]"][type="checkbox"]');
            if (check && check.checked) return true;
            const hidden = root.querySelector('[data-both-sides-prop]');
            if (hidden && !hidden.disabled && String(hidden.value || '') === 'Yes') return true;
            return false;
          };

          const parsePayload = (body) => {
            const out = { ids: [], side: '', both: '', qty: 1 };
            if (!body) return out;
            const take = (src) => {
              if (!src || typeof src !== 'object') return;
              const props = src.properties || src.attributes || {};
              const side = src['properties[Engraving Side]'] || props['Engraving Side'] || props.engraving_side;
              const both = src['properties[Both Sides]'] || props['Both Sides'] || props.both_sides;
              if (side && !out.side) out.side = String(side);
              if (both && !out.both) out.both = String(both);
              const id = src.id || src.variant_id || src.merchandiseId;
              if (id != null && String(id) !== '') out.ids.push(String(id).replace(/^gid:\/\/shopify\/ProductVariant\//, ''));
              if (src.quantity != null) out.qty = Number(src.quantity) || out.qty;
            };
            if (typeof FormData !== 'undefined' && body instanceof FormData) {
              out.side = String(body.get('properties[Engraving Side]') || '');
              out.both = String(body.get('properties[Both Sides]') || '');
              const id = body.get('id');
              if (id) out.ids.push(String(id));
              out.qty = Number(body.get('quantity') || 1) || 1;
              return out;
            }
            let raw = '';
            if (typeof body === 'string') raw = body;
            else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) raw = body.toString();
            if (!raw) return out;
            try {
              const json = JSON.parse(raw);
              if (Array.isArray(json.items)) json.items.forEach(take);
              else take(json);
            } catch (err) {
              try {
                const params = new URLSearchParams(raw);
                out.side = String(params.get('properties[Engraving Side]') || '');
                out.both = String(params.get('properties[Both Sides]') || '');
                const id = params.get('id');
                if (id) out.ids.push(String(id));
                out.qty = Number(params.get('quantity') || 1) || 1;
              } catch (err2) {
                /* ignore */
              }
            }
            return out;
          };

          const wantsBoth = (payload) => {
            if (payload && (payload.side === 'Both sides' || /^yes$/i.test(String(payload.both || '')))) return true;
            return readUiWantsBoth();
          };

          const pieceCountFor = (root) => {
            const raw = Number(
              (root && (root.dataset.bothSidesPieces || root.getAttribute('data-both-sides-pieces'))) || 1
            );
            return Number.isFinite(raw) && raw > 0 ? Math.floor(raw) : 1;
          };

          /* 2026-10-07 23:4x (#167 only until El Jefe PASS; Jefe-approved): ONE fee request per both-sides add.
             Before: the fetch wrapper (after the product add) AND the submit hook (350 ms after submit) each POSTed the fee, so one
             tumbler could end with the fee at qty 2 ($11.90). Re-reading /cart.js is not a safe guard: while Horizon's add (with its
             sections render) is still running, a cart read can miss a fee that was just added.
             Now the fetch wrapper OWNS the fee whenever it sees the product add (it marks the add the moment the request starts, and
             only adds the fee after the product add succeeded). The submit hook is a fallback for submits the wrapper never sees:
             it waits 1.5 s and does nothing if the wrapper saw an add since that submit; otherwise it reconciles against /cart.js
             (adds only the units missing for both-sides lines of this product), so a blocked/failed product add never gets a fee.
             All fee POSTs go through one queue.
             Fee qty rule unchanged: product qty of THIS add x pieces (rocks sets 4), i.e. per unit. */
          let secondSideQueue = Promise.resolve();
          let wrapperSawAddAt = 0;
          const ensureSecondSideFee = (qty) => {
            const run = secondSideQueue.then(() => addSecondSideFee(qty));
            secondSideQueue = run.catch(() => {});
            return run;
          };
          const fallbackSecondSideFee = () => {
            const run = secondSideQueue.then(async () => {
              const root = getRoot();
              if (!root) return;
              const title = (root.dataset.productTitle || '').trim();
              const parentId = String(root.dataset.productId || '').trim();
              const pieces = pieceCountFor(root);
              let items = [];
              try {
                const r = await origFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
                items = ((await r.json()) || {}).items || [];
              } catch (err) {
                return;
              }
              const both = (p) => /^yes$/i.test(String(p['Both Sides'] || '')) || String(p['Engraving Side'] || '') === 'Both sides';
              let wanted = 0;
              let existing = 0;
              items.forEach((it) => {
                const p = it.properties || {};
                if (String(it.variant_id) === String(feeVid)) {
                  if (String(p._addon || '') !== 'second-side') return;
                  const fp = p._parent == null ? '' : String(p._parent);
                  if (fp ? fp === parentId : String(p.For || '') === title) existing += Number(it.quantity) || 0;
                  return;
                }
                if (p._addon != null && String(p._addon) !== '') return;
                const mine = parentId ? String(it.product_id) === parentId : String(it.product_title || '') === title;
                if (mine && both(p)) wanted += (Number(it.quantity) || 0) * pieces;
              });
              const missing = Math.floor((wanted - existing) / pieces);
              if (missing > 0) await addSecondSideFee(missing);
            });
            secondSideQueue = run.catch(() => {});
            return run;
          };
          const addSecondSideFee = async (qty) => {
            const root = getRoot();
            if (!root) return;
            const title = (root.dataset.productTitle || '').trim();
            const pieces = pieceCountFor(root);
            const productQty = Number(qty) || 1;
            const feeQty = Math.max(1, productQty * pieces);
            const props = {
              _addon: 'second-side',
              For: title,
            };
            /* 2026-10-07 (#167): parent product id so the cart lanes (snippets/sancando-line-public.liquid,
               assets/sancando-quote-cart.js) keep this fee with a public-price parent in the buy lane. */
            const parentId = String(root.dataset.productId || '').trim();
            if (parentId) props._parent = parentId;
            if (pieces > 1) {
              props['Per glass'] = 'Quoted';
              props['Glasses'] = String(pieces);
              props['Note'] = pieces + ' glasses both-sides (rocks gift set) — quoted';
            }
            try {
              await origFetch('/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: Number(feeVid),
                      quantity: feeQty,
                      properties: props,
                    },
                  ],
                }),
              });
            } catch (err) {
              /* product already in cart */
            }
          };

          window.fetch = async (input, init) => {
            const url = typeof input === 'string' ? input : (input && input.url) || '';
            const isCartAdd = cartAddRe.test(url);
            const body = init && init.body;
            const payload = isCartAdd ? parsePayload(body) : null;
            const isAddonLine = !!(payload && payload.ids.length && payload.ids.every((id) => id === feeVid));
            if (isCartAdd && !isAddonLine && getRoot()) wrapperSawAddAt = Date.now();
            const res = await origFetch(input, init);
            if (!isCartAdd || isAddonLine) return res;
            if (!getRoot()) return res;
            let addFailed = !res.ok;
            try {
              const clone = res.clone();
              const data = await clone.json();
              if (data && data.status) addFailed = true;
            } catch (err) {
              /* Horizon sometimes receives HTML; still add if HTTP ok */
            }
            if (addFailed) return res;
            if (!wantsBoth(payload)) return res;
            await ensureSecondSideFee(payload && payload.qty);
            /* 2026-10-07 23:0x (#167 only until El Jefe PASS; Jefe-approved drawer fix): the sections HTML in `res` (e.g. the cart drawer) was rendered by Shopify BEFORE the fee
               line existed, so the drawer showed only the product (count 1, product-only subtotal) while the badge said 2.
               Re-render the same sections now that the fee is in, and hand Horizon the fresh HTML. Any failure keeps `res`. */
            try {
              const secIds =
                typeof FormData !== 'undefined' && body instanceof FormData ? String(body.get('sections') || '') : '';
              if (secIds) {
                const data = await res.clone().json();
                if (data && !data.status) {
                  const fresh = await origFetch(
                    window.location.pathname + '?sections=' + encodeURIComponent(secIds),
                    { credentials: 'same-origin' }
                  );
                  if (fresh.ok) {
                    const freshSections = await fresh.json();
                    data.sections = Object.assign({}, data.sections || {}, freshSections || {});
                    return new Response(JSON.stringify(data), {
                      status: res.status,
                      statusText: res.statusText,
                      headers: { 'Content-Type': 'application/json' },
                    });
                  }
                }
              }
            } catch (err) {
              /* keep the original response */
            }
            return res;
          };

          /* Horizon Buy Buttons may submit without a FormData fetch body — mirror DTF submit hook. */
          document.addEventListener(
            'submit',
            (event) => {
              const form = event.target;
              if (!(form instanceof HTMLFormElement)) return;
              const action = String(form.getAttribute('action') || form.action || '');
              if (action.indexOf('/cart/add') === -1) return;
              if (!getRoot()) return;
              if (!readUiWantsBoth()) return;
              const qtyInput = form.querySelector('input[name="quantity"]');
              const qty = qtyInput ? Number(qtyInput.value || 1) || 1 : 1;
              const submittedAt = Date.now();
              window.setTimeout(() => {
                if (wrapperSawAddAt >= submittedAt) return; /* the fetch wrapper handled (or is handling) this add */
                fallbackSecondSideFee();
              }, 1500);
            },
            true
          );
        }



        bindLeatherettePlateResize() {
          if (this._leatheretteResizeBound) return;
          this._leatheretteResizeBound = true;
          let ticking = false;
          const run = () => {
            ticking = false;
            try { this.syncLeatherettePatchPlate(); } catch (err) { /* ignore */ }
          };
          const onResize = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(run);
          };
          window.addEventListener('resize', onResize, { passive: true });
          window.addEventListener('orientationchange', onResize, { passive: true });
          if (typeof ResizeObserver !== 'undefined') {
            const ro = new ResizeObserver(onResize);
            document.querySelectorAll('.sancando-hats-gallery .product-media, .product-media--hats').forEach((el) => ro.observe(el));
            this._leatheretteRo = ro;
          }
        }

        syncLeatheretteUi() {
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const isLeather = !!methodInput && /leatherette/i.test(methodInput.value || '');
          if (isLeather) this.ensureLeatheretteChipBackgrounds();
          try {
            const mapEl = document.querySelector('[data-sancando-media-map]');
            const map = mapEl ? JSON.parse(mapEl.textContent || '{}') : {};
            const vid = (window.Shopify && Shopify.analytics && Shopify.analytics.meta && Shopify.analytics.meta.selectedVariantId)
              || (document.querySelector('input[name="id"]') && document.querySelector('input[name="id"]').value)
              || '';
            if (vid) this.applyHatFrontMedia(map, String(vid));
          } catch (e) {}
          const panels = this.querySelectorAll('[data-leatherette-only]');
          if (panels.length) {
            panels.forEach((panel) => { panel.hidden = !isLeather; });
            this.querySelectorAll('[data-leatherette-input]').forEach((input) => {
              input.disabled = !isLeather;
            });
            const selected = this.querySelector('input[name="properties[Patch Color]"]:checked');
            const labelEl = this.querySelector('[data-patch-color-selected]');
            if (labelEl) {
              if (isLeather && selected) {
                const nice = selected.getAttribute('data-patch-color-label') || selected.value || '';
                labelEl.textContent = nice ? `: ${nice}` : '';
              } else {
                labelEl.textContent = '';
              }
            }
          }
          /* Always sync plate/frame — do not wait on async leatherette panel mount. */
          this.syncLeatherettePatchPlate();
        }


        mountLeatherettePanel() {
          if (this.querySelector('[data-leatherette-only]')) return true;
          const mount = this.querySelector('[data-leatherette-mount]');
          if (!mount) return false;
          if (mount.dataset.loading === '1') return false;
          const src = mount.getAttribute('data-leatherette-src');
          const tpl = document.getElementById('sancando-leatherette-tpl');
          const finish = (html) => {
            const wrap = document.createElement('div');
            wrap.innerHTML = html;
            const panel = wrap.querySelector('[data-leatherette-only]') || wrap.firstElementChild;
            if (!panel) return false;
            mount.replaceWith(panel);
            const root = this.querySelector('[data-leatherette-only]');
            if (root) {
              const rawhide = root.getAttribute('data-rawhide-url');
              if (rawhide) {
                root.querySelectorAll('.sancando-leatherette__shape-swatch').forEach((el) => {
                  el.style.backgroundImage = 'url("' + String(rawhide).replace(/"/g, '') + '")';
                });
              }
              this.ensureLeatheretteChipBackgrounds();
            }
            return true;
          };
          if (tpl) {
            return finish(tpl.innerHTML);
          }
          if (!src) return false;
          if (window.__sancandoLeatheretteHtml) {
            return finish(window.__sancandoLeatheretteHtml);
          }
          mount.dataset.loading = '1';
          // sync XHR avoided; use cached fetch promise
          if (!window.__sancandoLeatherettePromise) {
            window.__sancandoLeatherettePromise = fetch(src, { credentials: 'same-origin' })
              .then((r) => r.text())
              .then((t) => {
                window.__sancandoLeatheretteHtml = t;
                return t;
              });
          }
          window.__sancandoLeatherettePromise
            .then((t) => {
              mount.dataset.loading = '0';
              if (!this.querySelector('[data-leatherette-only]')) finish(t);
              try { this.syncLeatheretteUi(); } catch (e) {}
            })
            .catch(() => {
              mount.dataset.loading = '0';
            });
          return false;
        }

        ensureLeatheretteChipBackgrounds() {
          this.mountLeatherettePanel();
          const root = this.querySelector('[data-leatherette-only]');
          if (!root || root.dataset.bgReady === '1') return;
          root.querySelectorAll('.sancando-leatherette__chip[data-bg]').forEach((chip) => {
            const url = chip.getAttribute('data-bg');
            if (!url) return;
            chip.style.backgroundImage = 'url("' + String(url).replace(/"/g, '') + '")';
            chip.removeAttribute('data-bg');
          });
          root.dataset.bgReady = '1';
        }

        leatheretteTextureUrl() {
          const selected = this.querySelector('input[name="properties[Patch Color]"]:checked');
          const chip = selected && selected.closest('label') && selected.closest('label').querySelector('.sancando-leatherette__chip');
          if (chip) {
            const bg = (chip.getAttribute('style') || '').match(/url\(['\"]?([^'\")]+)['\"]?\)/);
            if (bg && bg[1]) return bg[1];
            try {
              const computed = getComputedStyle(chip).backgroundImage;
              const m = computed && computed.match(/url\(["']?([^"')]+)["']?\)/);
              if (m && m[1]) return m[1];
            } catch (err) {
              /* ignore */
            }
          }
          const panel = this.querySelector('[data-rawhide-url]');
          return (panel && panel.getAttribute('data-rawhide-url')) || '';
        }


        ensureBoxHandles(box) {
          if (!box || !(box instanceof Element)) return;
          const dirs = ['nw', 'ne', 'sw', 'se'];
          dirs.forEach((dir) => {
            if (box.querySelector(':scope > .sancando-box-handle--' + dir)) return;
            const handle = document.createElement('i');
            handle.className = 'sancando-box-handle sancando-box-handle--' + dir;
            handle.setAttribute('data-dir', dir);
            box.appendChild(handle);
          });
        }

        /* Hats: if hat_front media has plate-path but no liquid imprint box (zoom clone,
           variant swap race, partial section render), create the shopper frame so
           is-patch-frame + 4 handles always appear with the leatherette plate. */
        ensureHatsImprintBox(parent) {
          if (!parent || !(parent instanceof Element)) return null;
          let box = parent.querySelector(':scope > .sancando-imprint-preview');
          if (box) return box;
          const area = this.imprintArea(null) || { top: '35.9%', left: '24.5%', width: '48.7%', height: '23.7%' };
          const json = JSON.stringify(area);
          box = document.createElement('div');
          box.className = 'sancando-imprint-preview';
          box.setAttribute('aria-hidden', 'false');
          box.setAttribute('data-imprint-area', json);
          box.setAttribute('data-box-kind', 'logo');
          box.style.top = area.top;
          box.style.left = area.left;
          box.style.width = area.width;
          box.style.height = area.height;
          const inner = document.createElement('div');
          inner.className = 'sancando-imprint-preview__inner';
          const img = document.createElement('img');
          img.className = 'sancando-imprint-preview__logo';
          img.alt = '';
          img.hidden = true;
          inner.appendChild(img);
          box.appendChild(inner);
          this.ensureBoxHandles(box);
          parent.appendChild(box);
          return box;
        }

        syncLeatherettePatchPlate() {
          if (!this.isHatsProduct()) {
            document.querySelectorAll('.sancando-leatherette-plate').forEach((el) => el.remove());
            document.querySelectorAll('.sancando-imprint-preview.is-patch-frame').forEach((el) => {
              el.classList.remove('is-patch-frame');
            });
            delete document.documentElement.dataset.sancandoLeatherette;
            return;
          }
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const isLeather = !!methodInput && /leatherette/i.test(methodInput.value || '');
          if (!isLeather) {
            document.querySelectorAll('.sancando-leatherette-plate').forEach((el) => el.remove());
            document.querySelectorAll('.sancando-imprint-preview.is-patch-frame').forEach((el) => {
              el.classList.remove('is-patch-frame');
            });
            delete document.documentElement.dataset.sancandoLeatherette;
            return;
          }
          /* Chips on demand once — never re-eager ~57 background-image URLs per sync. */
          if (!this._leatheretteChipsReady) {
            this.ensureLeatheretteChipBackgrounds();
            this._leatheretteChipsReady = true;
          }
          document.querySelectorAll('.sancando-placeholder-hint').forEach((hint) => hint.classList.add('is-hidden'));
          document.documentElement.dataset.sancandoLeatherette = '1';
          const shapeInput = this.querySelector('input[name="properties[Patch Shape]"]:checked');
          const shape = ((shapeInput && shapeInput.value) || 'Round').toLowerCase().replace(/\s+/g, '-');
          const aspect = this.hatPatchAspect(shape);
          const prevShape = this._leatherettePatchShape || '';
          const shapeChanged = !!(prevShape && prevShape !== shape);
          this._leatherettePatchShape = shape;
          const texture = this.leatheretteTextureUrl();
          const isHatFrontMedia = (el) => {
            if (!el) return false;
            const img = el.querySelector('img');
            const alt = ((img && (img.getAttribute('alt') || '')) || el.getAttribute('data-alt') || '');
            return /hat_front|\|\s*Front\s*\|/.test(alt);
          };
          const isMainHatMedia = (el) => {
            if (!el) return false;
            if (el.closest('.dialog-zoomed-gallery, .media-gallery__grid, zoom-dialog')) return false;
            return isHatFrontMedia(el);
          };
          const boxes = this.imprintBoxes();
          const parents = [];
          boxes.forEach((box) => {
            const parent = box.parentElement;
            if (!parent || parents.indexOf(parent) !== -1) return;
            if (!isMainHatMedia(parent)) return;
            parents.push(parent);
          });
          if (!parents.length) {
            document.querySelectorAll('.sancando-hats-gallery .product-media, .product-media--hats').forEach((el) => {
              if (isMainHatMedia(el) && parents.indexOf(el) === -1) parents.push(el);
            });
          }
          const used = [];
          parents.forEach((parent) => {
            if (!parent) return;
            /* Never mount plate-only: create missing imprint frame first so handles show. */
            const box = this.ensureHatsImprintBox(parent);
            let plate = parent.querySelector(':scope > .sancando-leatherette-plate');
            if (!plate) {
              plate = document.createElement('div');
              plate.className = 'sancando-leatherette-plate';
              plate.setAttribute('aria-hidden', 'true');
              if (box && box.parentNode === parent) parent.insertBefore(plate, box);
              else parent.appendChild(plate);
            }
            used.push(plate);
            if (box) {
              this.ensureHatsLeatheretteCapMax(box);
              this.ensureBoxHandles(box);
              box.classList.add('is-patch-frame');
              box.setAttribute('aria-hidden', 'false');
              let maxPct = null;
              try {
                const raw = box.dataset.imprintMax;
                if (raw) maxPct = JSON.parse(raw);
              } catch (err) {
                maxPct = null;
              }
              if (!box.dataset.userMoved && maxPct) {
                this.writeBox(box, this.hatsLeatheretteStarterBox(box, aspect, 0.85));
              } else if (box.dataset.userMoved && shapeChanged && maxPct) {
                this.reaspectPatchBoxKeepCenter(box, aspect, maxPct);
              }
              /* Plate AABB = exact copy of imprint box. Shape is clip-path/CSS only. */
              this.writeBox(plate, this.readBox(box));
            } else {
              const area = this.imprintArea(null);
              this.writeBox(plate, area);
            }
            plate.dataset.shape = shape;
            plate.style.backgroundImage = texture ? 'url(' + JSON.stringify(texture) + ')' : '';
            plate.hidden = false;
          });
          document.querySelectorAll('.sancando-leatherette-plate').forEach((el) => {
            if (used.indexOf(el) === -1) el.remove();
          });
        }

        syncDigitizingNote() {
          const notes = this.querySelectorAll('[data-digitizing-note]');
          if (!notes.length) return;
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const isEmb = !!methodInput && /embroider/i.test(methodInput.value || '');
          notes.forEach((note) => { note.hidden = !isEmb; });
          this.querySelectorAll('[data-prev-digitized]').forEach((radio) => { radio.disabled = !isEmb; });
          const prevNo = this.querySelector('[data-prev-digitized][value="No"]');
          const feeNote = this.querySelector('[data-digitizing-fee-note]');
          if (feeNote) feeNote.hidden = !isEmb || !!(prevNo && prevNo.checked);
        }

        bindDigitizingAddon() {
          if (this.dataset.chargeDigitizing !== 'true') return;
          const variantId = String(this.dataset.digitizingVariant || '').trim();
          if (!variantId) return;
          if (window.__sancandoDigitizingBound === 'true') return;
          window.__sancandoDigitizingBound = 'true';
          const origFetch = window.fetch.bind(window);
          const cartAddRe = /\/cart\/add(\.js)?(\/|$|\?)/;
          const feeVid = String(variantId);

          const getRoot = () => document.querySelector('sancando-customization[data-charge-digitizing="true"]');

          const readUiState = () => {
            const root = getRoot();
            if (!root) return { method: '', prev: '' };
            const methodInput = root.querySelector('input[name="properties[Decoration Method]"]:checked');
            const prevInput = root.querySelector('input[name="properties[Previously Digitized]"]:checked');
            return {
              method: methodInput ? String(methodInput.value || '') : '',
              prev: prevInput ? String(prevInput.value || '') : '',
            };
          };

          const shouldCharge = (method, prev) => {
            const m = String(method || '');
            const p = String(prev || '');
            if (!m || !/embroider/i.test(m)) return false;
            if (/leatherette/i.test(m)) return false;
            return /^yes$/i.test(p);
          };

          const isNoFeePrev = (prev) => /^no$/i.test(String(prev || ''));

          const readBodyText = (body) => {
            if (body == null) return '';
            if (typeof body === 'string') return body;
            if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.toString();
            return '';
          };

          const parseCartAddPayload = (body) => {
            const out = { ids: [], method: '', prev: '', isAddonOnly: false };
            if (!body) return out;
            const takeProps = (src) => {
              if (!src || typeof src !== 'object') return;
              const props = src.properties || src.attributes || {};
              const method = src['properties[Decoration Method]'] || props['Decoration Method'] || props.decoration_method;
              const prev = src['properties[Previously Digitized]'] || props['Previously Digitized'] || props.previously_digitized;
              if (method && !out.method) out.method = String(method);
              if (prev && !out.prev) out.prev = String(prev);
              const id = src.id || src.variant_id || src.merchandiseId;
              if (id != null && String(id) !== '') out.ids.push(String(id).replace(/^gid:\/\/shopify\/ProductVariant\//, ''));
            };
            if (typeof FormData !== 'undefined' && body instanceof FormData) {
              out.method = String(body.get('properties[Decoration Method]') || '');
              out.prev = String(body.get('properties[Previously Digitized]') || '');
              const id = body.get('id');
              if (id) out.ids.push(String(id));
              return out;
            }
            const raw = readBodyText(body);
            if (!raw) return out;
            try {
              const json = JSON.parse(raw);
              if (Array.isArray(json.items)) json.items.forEach(takeProps);
              else takeProps(json);
            } catch (err) {
              try {
                const params = new URLSearchParams(raw);
                out.method = String(params.get('properties[Decoration Method]') || '');
                out.prev = String(params.get('properties[Previously Digitized]') || '');
                const id = params.get('id');
                if (id) out.ids.push(String(id));
              } catch (err2) {
                /* ignore unreadable bodies */
              }
            }
            return out;
          };

          const payloadLooksLikeAddon = (payload) => {
            if (!payload || !payload.ids.length) return false;
            return payload.ids.every((id) => id === feeVid);
          };

          let feeInflight = null;
          let removeInflight = null;
          const removeDigitizingFee = async () => {
            if (removeInflight) return removeInflight;
            removeInflight = (async () => {
              try {
                const cartRes = await origFetch('/cart.js', {
                  credentials: 'same-origin',
                  headers: { Accept: 'application/json' },
                });
                const cart = await cartRes.json();
                const lines = (cart.items || []).filter((it) => String(it.variant_id) === feeVid);
                for (const line of lines) {
                  const key = line.key || line.id;
                  if (!key) continue;
                  await origFetch('/cart/change.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      Accept: 'application/json',
                    },
                    body: JSON.stringify({ id: key, quantity: 0 }),
                  });
                }
              } catch (err) {
                /* skip failing a hat add if fee remove fails */
              } finally {
                removeInflight = null;
              }
            })();
            return removeInflight;
          };

          const ensureDigitizingFee = async () => {
            if (!getRoot()) return;
            const ui = readUiState();
            if (!shouldCharge(ui.method, ui.prev)) return;
            if (feeInflight) return feeInflight;
            feeInflight = (async () => {
              try {
                try {
                  const cartRes = await origFetch('/cart.js', {
                    credentials: 'same-origin',
                    headers: { Accept: 'application/json' },
                  });
                  const cart = await cartRes.json();
                  const already = (cart.items || []).some((it) => String(it.variant_id) === feeVid);
                  if (already) return;
                } catch (err) {
                  /* cart read failed; fall through and add the fee once */
                }
                await origFetch('/cart/add.js', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({
                    items: [
                      {
                        id: Number(feeVid),
                        quantity: 1,
                        properties: {
                          _addon: 'digitizing',
                          For: 'Need digitizing — quoted',
                        },
                      },
                    ],
                  }),
                });
              } catch (err) {
                /* hat is already in cart; skip failing the add */
              } finally {
                feeInflight = null;
              }
            })();
            return feeInflight;
          };

          const wantsFeeFromPayloadOrUi = (payload) => {
            const ui = readUiState();
            const method = (payload && payload.method) || ui.method;
            const prevPayload = payload && payload.prev;
            const prevUi = ui.prev;
            if (isNoFeePrev(prevPayload) || isNoFeePrev(prevUi)) return false;
            if (/leatherette/i.test(String(method || ''))) return false;
            const prev = prevPayload || prevUi;
            return shouldCharge(method, prev);
          };

          const shouldRemoveFee = (payload) => {
            const ui = readUiState();
            const method = (payload && payload.method) || ui.method;
            const prevPayload = payload && payload.prev;
            const prevUi = ui.prev;
            if (isNoFeePrev(prevPayload) || isNoFeePrev(prevUi)) return true;
            if (/leatherette/i.test(String(method || ''))) return true;
            return false;
          };

          window.fetch = async (input, init) => {
            const url = typeof input === 'string' ? input : (input && input.url) || '';
            const isCartAdd = cartAddRe.test(url);
            const body = init && init.body;
            const payload = isCartAdd ? parseCartAddPayload(body) : null;
            const isAddonLine = payloadLooksLikeAddon(payload);
            const res = await origFetch(input, init);
            if (!isCartAdd || isAddonLine) return res;
            if (!getRoot()) return res;
            let addFailed = !res.ok;
            try {
              const clone = res.clone();
              const data = await clone.json();
              if (data && data.status) addFailed = true;
            } catch (err) {
              /* Horizon sometimes receives HTML; still add if HTTP ok */
            }
            if (addFailed) return res;
            if (shouldRemoveFee(payload)) {
              await removeDigitizingFee();
              return res;
            }
            if (!wantsFeeFromPayloadOrUi(payload)) return res;
            await ensureDigitizingFee();
            return res;
          };

          document.addEventListener(
            'submit',
            (event) => {
              const form = event.target;
              if (!(form instanceof HTMLFormElement)) return;
              const action = form.getAttribute('action') || form.action || '';
              if (!cartAddRe.test(action)) return;
              const payload = parseCartAddPayload(new FormData(form));
              if (payloadLooksLikeAddon(payload)) return;
              if (event.defaultPrevented) {
                if (shouldRemoveFee(payload)) removeDigitizingFee();
                return;
              }
              const wantsFee = wantsFeeFromPayloadOrUi(payload);
              const dropFee = shouldRemoveFee(payload);
              if (!wantsFee && !dropFee) return;
              event.preventDefault();
              event.stopPropagation();
              (async () => {
                try {
                  const res = await origFetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: new FormData(form),
                    headers: { Accept: 'application/json' },
                  });
                  let addFailed = !res.ok;
                  try {
                    const data = await res.clone().json();
                    if (data && data.status) addFailed = true;
                  } catch (err) {
                    /* HTML cart add still counts if HTTP ok */
                  }
                  if (!addFailed && dropFee) await removeDigitizingFee();
                  if (!addFailed && wantsFee) await ensureDigitizingFee();
                  window.location.href = '/cart';
                } catch (err) {
                  form.submit();
                }
              })();
            },
            false
          );

          const onCartLinesUpdate = (event) => {
            const action = event.action || (event.detail && event.detail.action) || '';
            if (action !== 'add') return;
            const lines = event.lines || (event.detail && event.detail.lines) || [];
            const lineIds = (Array.isArray(lines) ? lines : []).map((line) =>
              String((line && (line.merchandiseId || line.id || line.variant_id)) || '').replace(
                /^gid:\/\/shopify\/ProductVariant\//,
                ''
              )
            );
            if (lineIds.length && lineIds.every((id) => id === feeVid)) return;
            const finish = (result) => {
              if (result && result.detail && result.detail.didError) return;
              if (!getRoot()) return;
              const ui = readUiState();
              if (isNoFeePrev(ui.prev) || /leatherette/i.test(ui.method)) {
                removeDigitizingFee();
                return;
              }
              if (!shouldCharge(ui.method, ui.prev)) return;
              ensureDigitizingFee();
            };
            const promise = event.promise || (event.detail && event.detail.promise);
            if (promise && typeof promise.then === 'function') {
              promise.then(finish).catch(() => {});
            } else {
              finish({});
            }
          };
          document.addEventListener('shopify:cart:lines-update', onCartLinesUpdate);

          document.addEventListener('change', (event) => {
            const target = event.target;
            if (!(target instanceof HTMLInputElement)) return;
            if (
              target.name !== 'properties[Previously Digitized]' &&
              target.name !== 'properties[Decoration Method]'
            ) {
              return;
            }
            const ui = readUiState();
            if (isNoFeePrev(ui.prev) || /leatherette/i.test(ui.method) || !/embroider/i.test(ui.method)) {
              removeDigitizingFee();
            }
          });
        }

        syncDtfPlacementLabel() {
          const checked = this.querySelector('input[data-dtf-placement]:checked');
          const labelInput = this.querySelector('[data-dtf-placement-label]');
          if (!checked || !labelInput) return;
          labelInput.value = checked.getAttribute('data-placement-label') || checked.value || '';
          labelInput.disabled = false;
          try { this.syncPlacementProperty(); } catch (err) { /* ignore */ }
        }

        /* Stackable Sleeve add-on (+$2.95) — independent of placement radios. */
        syncDtfSleeveAddonUi() {
          const wrap = this.querySelector('[data-dtf-sleeve-addon]');
          if (!wrap) return;
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const isDtf = !!methodInput && /^dtf$/i.test(String(methodInput.value || '').trim());
          wrap.hidden = !isDtf;
          const check = this.querySelector('[data-dtf-sleeve-addon-check]');
          if (check) check.disabled = !isDtf;
          const on = isDtf && check && check.checked;
          const sideWrap = this.querySelector('[data-dtf-sleeve-side]');
          if (sideWrap) sideWrap.hidden = !on;
          this.querySelectorAll('[data-dtf-sleeve-side-input]').forEach((r) => {
            r.disabled = !on;
            if (on) r.setAttribute('required', 'required');
            else r.removeAttribute('required');
          });
          if (!isDtf && check) check.checked = false;
          /* Refresh PDP package price when sleeve toggles / side changes. */
          if (isDtf) { this.stripVisibleCustomizerMoney(); this.updateDtfPackagePrice(); }
        }

        syncDtfPlacementUi() {
          const section = this.querySelector('[data-dtf-placement-section]');
          if (!section) return;
          if (this.dataset.chargeDtfPlacement !== 'true') {
            section.hidden = true;
            this.querySelectorAll('[data-dtf-placement]').forEach((r) => { r.disabled = true; });
            const labelInput = this.querySelector('[data-dtf-placement-label]');
            if (labelInput) labelInput.disabled = true;
            this.syncDtfSleeveAddonUi();
            return;
          }
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const isDtf = !!methodInput && /^dtf$/i.test(String(methodInput.value || '').trim());
          section.hidden = !isDtf;
          this.querySelectorAll('[data-dtf-placement]').forEach((r) => { r.disabled = !isDtf; });
          const labelInput = this.querySelector('[data-dtf-placement-label]');
          if (labelInput) labelInput.disabled = !isDtf;
          /* Jefe 2026-10-02 item 6 (#167 only): both-methods items carry an embroidery Placement property; only one Placement is sent. */
          this.querySelectorAll('[data-both-emb-placement]').forEach((el) => { el.disabled = isDtf; });
          if (isDtf) {
            this.syncDtfSleeveAddonUi();
            this.syncDtfPlacementLabel();
            this.stripVisibleCustomizerMoney(); this.updateDtfPackagePrice();
            this.applyApparelPlacementBox();
          } else {
            this.syncDtfSleeveAddonUi();
            this.restoreBaseProductPrice();
            this.applyApparelPlacementBox();
          }
        }

        /* Apparel imprint boxes — resize logo stamp for left-chest vs full-front. */
        ensureApparelImprintBoxes() {
          const suffix = (this.dataset.templateSuffix || '').toLowerCase();
          const ptype = (this.dataset.productType || '').toLowerCase();
          if (suffix !== 'apparel' && ptype !== 'apparel') return;
          // Do not bail when boxes exist on a hidden slide — visible tee may still lack one.
          const parents = document.querySelectorAll(
            '.sancando-apparel-gallery slideshow-slide:not([hidden]) .product-media, .sancando-apparel-gallery .product-media--apparel, .product-media--apparel'
          );
          const area = { top: '26%', left: '30%', width: '40%', height: '38%' };
          const json = JSON.stringify(area);
          parents.forEach((parent) => {
            if (!parent || parent.querySelector('.sancando-imprint-preview')) return;
            const box = document.createElement('div');
            box.className = 'sancando-imprint-preview';
            box.setAttribute('aria-hidden', 'true');
            box.setAttribute('data-imprint-area', json);
            box.style.top = area.top;
            box.style.left = area.left;
            box.style.width = area.width;
            box.style.height = area.height;
            const inner = document.createElement('div');
            inner.className = 'sancando-imprint-preview__inner';
            const img = document.createElement('img');
            img.className = 'sancando-imprint-preview__logo';
            img.alt = '';
            img.hidden = true;
            inner.appendChild(img);
            box.appendChild(inner);
            parent.appendChild(box);
          });
        }

        applyApparelPlacementBox() {
          const suffix = (this.dataset.templateSuffix || '').toLowerCase();
          const ptype = (this.dataset.productType || '').toLowerCase();
          if (suffix !== 'apparel' && ptype !== 'apparel') return;
          const boxes = {
            'full-front': { top: '26%', left: '30%', width: '40%', height: '38%' },
            'left-chest': { top: '24%', left: '55%', width: '18%', height: '16%' },
            'left-chest-full-back': { top: '24%', left: '55%', width: '18%', height: '16%' },
          };
          /* Jefe 2026-10-02 19:08 (#167 only): left-chest (and the front of Left chest / Full back) uses the product's own box when
             custom.color_swatches carries "_imprint_boxes": {"left-chest": {top,left,width,height}} (rendered as data-color-swatches;
             entries without .hex are skipped by the chip code). No own box = the fixed 24/55/18/16 above, unchanged. */
          const own = this.productImprintBoxes();
          if (own['left-chest']) boxes['left-chest'] = own['left-chest'];
          if (own['left-chest-full-back'] || own['left-chest']) boxes['left-chest-full-back'] = own['left-chest-full-back'] || own['left-chest'];
          /* Jefe 2026-10-03 12:11 (#167 only): Full front uses the product's own _imprint_boxes['full-front'] when present (same validation,
             same re-apply on placement / colour switch as left-chest). Absent = the fixed 26/30/40/38, unchanged. */
          const fixedFullFront = boxes['full-front'];
          if (own['full-front']) boxes['full-front'] = own['full-front'];
          /* 19:08 item 2: a colour switch re-renders the gallery; schedulePreviewResync re-applies this placement box (see kick). */
          this._placementBoxOn = true;
          let pid = 'full-front';
          const methodInput = this.querySelector('input[name="properties[Decoration Method]"]:checked');
          const isDtf = !!methodInput && /^dtf$/i.test(String(methodInput.value || '').trim());
          if (isDtf) {
            const checked = this.querySelector('input[data-dtf-placement]:checked');
            if (checked && checked.value) pid = checked.value;
          }
          /* Jefe 2026-10-02 bottoms pilot (#167 only): 'left-hip' has no fixed tee box. It uses the product's own
             custom.imprint_preview box (the data-imprint-area product-media rendered, cached once per element before any
             placement override), else a default upper-left-leg box. Other placements unchanged. */
          const hipDefault = { top: '30%', left: '52%', width: '14%', height: '12%' };
          document.querySelectorAll('.sancando-imprint-preview, .sancando-imprint-text').forEach((el) => {
            if (el.dataset.mfImprintArea === undefined) el.dataset.mfImprintArea = el.getAttribute('data-imprint-area') || '';
            let area = boxes[pid] || fixedFullFront;
            /* item 6: right-chest DTF and the embroidery side of a both-methods item use the product's own imprint_preview box. */
            const useMf = pid === 'left-hip' || pid === 'right-chest' || (!isDtf && this.dataset.bothMethods === 'true');
            if (useMf) {
              area = pid === 'left-hip' ? hipDefault : { top: '39%', left: '54%', width: '10%', height: '9%' };
              try {
                const mf = el.dataset.mfImprintArea ? JSON.parse(el.dataset.mfImprintArea) : null;
                if (mf && mf.top && mf.left && mf.width && mf.height) area = { top: mf.top, left: mf.left, width: mf.width, height: mf.height };
              } catch (e) { /* keep default */ }
            }
            el.setAttribute('data-imprint-area', JSON.stringify(area));
            if (!el.dataset.userMoved) this.writeBox(el, area);
          });
          this.syncImprintPreview();
        }

        /* Jefe 2026-10-02 19:08 (#167 only): per-placement boxes from custom.color_swatches._imprint_boxes (percent strings only). */
        productImprintBoxes() {
          if (this._ownBoxes && Object.keys(this._ownBoxes).length) return this._ownBoxes;
          const out = {};
          const host = this.closest('[data-color-swatches]') || document.querySelector('[data-testid="product-information"][data-color-swatches]');
          if (!host || !host.hasAttribute('data-color-swatches')) return out;
          try {
            const all = JSON.parse(host.getAttribute('data-color-swatches') || '{}');
            const own = all && all._imprint_boxes;
            /* 21:37 hardening: percent strings within 0-100 only (width/height > 0); anything else = fixed box. */
            /* 2026-10-22: clamp numeric percent strings to 0-100 (was reject-only); non-numeric = fixed box. */
            const pct = (v) => (typeof v === 'string' && /^-?\d+(\.\d+)?%$/.test(v.trim()) ? Math.min(100, Math.max(0, parseFloat(v))) + '%' : null);
            if (own && typeof own === 'object') {
              Object.keys(own).forEach((id) => {
                const b = own[id];
                if (!b) return;
                const t = pct(b.top), l = pct(b.left), w = pct(b.width), h = pct(b.height);
                if (t && l && w && h && parseFloat(w) > 0 && parseFloat(h) > 0) out[id] = { top: t, left: l, width: w, height: h };
              });
            }
          } catch (e) { /* fixed boxes */ }
          /* 21:37 hardening: cache only a non-empty list, so a read before the swatch host exists (or before it is filled) is retried. */
          if (Object.keys(out).length) this._ownBoxes = out;
          return out;
        }

        parseDtfJsonAttr(name) {
          try {
            const raw = this.getAttribute(name) || this.dataset[name.replace(/^data-/, '').replace(/-([a-z])/g, (_, c) => c.toUpperCase())] || '';
            if (!raw || raw === 'null' || raw === 'nil') return {};
            return typeof raw === 'string' ? JSON.parse(raw) : (raw || {});
          } catch (err) {
            return {};
          }
        }


        stripVisibleCustomizerMoney() {
          /* CFP sitewide: remove any leftover $ amounts inside customizer tiles/notes. */
          if (
            !(
              document.body.classList.contains('sancando-cfp-sitewide') ||
              document.documentElement.classList.contains('sancando-cfp-sitewide')
            )
          ) {
            return;
          }
          const moneyRe = /(?:^|\s)[+$]?\$?\d{1,4}(?:\.\d{2})?(?:\s|$)/;
          this.querySelectorAll(
            '.sancando-customization__method-sub, .sancando-customization__method-price, .sancando-customization__price-note'
          ).forEach((el) => {
            /* 2026-10-09 (#167 only): keep the real second-side fee note on public-price products. */
            if (this.dataset.bothFeePublic === '1' && el.hasAttribute('data-both-price-note')) return;
            const t = (el.textContent || '').trim();
            if (!t) return;
            if (/^\$?\d+(\.\d{2})?$/.test(t) || /^\+\$?\d+(\.\d{2})?$/.test(t)) {
              el.textContent = '';
              el.hidden = true;
              return;
            }
            if (/\$\d/.test(t) || moneyRe.test(t) && /\$/.test(t)) {
              el.textContent = t.replace(/\$?\d{1,4}\.\d{2}/g, '').replace(/\s{2,}/g, ' ').trim();
              if (!el.textContent) el.hidden = true;
            }
          });
        }

        updateDtfPackagePrice() {
          /* Jefe 2026-09-18 strip-all-pricing: never inject $ into PDP under CFP sitewide.
             Placement fee variants still bind via bindDtfPlacementAddon for ops/quote cart. */
          if (
            document.body.classList.contains('sancando-cfp-sitewide') ||
            document.documentElement.classList.contains('sancando-cfp-sitewide')
          ) {
            return;
          }
          if (this.dataset.chargeDtfPlacement !== 'true') return;
          /* non-CFP fallback retained but unused while sitewide CFP is on */
          return;
        }

        restoreBaseProductPrice() {
          if (!this._dtfBasePriceHtml) return;
          this._dtfBasePriceHtml.forEach((entry) => {
            if (entry && entry.el) entry.el.innerHTML = entry.html;
          });
        }

        bindDtfPlacementAddon() {
          if (this.dataset.chargeDtfPlacement !== 'true') return;
          if (window.__sancandoDtfPlacementBound === 'true') return;
          window.__sancandoDtfPlacementBound = 'true';
          const origFetch = window.fetch.bind(window);
          const cartAddRe = /\/cart\/add(\.js)?(\/|$|\?)/;
          const feeMap = (() => {
            try {
              const raw = document.querySelector('sancando-customization[data-charge-dtf-placement="true"]');
              if (!raw) return {};
              const attr = raw.getAttribute('data-dtf-placement-fees') || '{}';
              return JSON.parse(attr);
            } catch (err) {
              return {};
            }
          })();
          const sleeveFeeVid = (() => {
            const raw = document.querySelector('sancando-customization[data-charge-dtf-placement="true"]');
            if (!raw) return '';
            return String(raw.getAttribute('data-dtf-sleeve-addon-fee') || '').trim();
          })();
          const feeVids = Object.values(feeMap)
            .map(String)
            .filter(Boolean)
            .concat(sleeveFeeVid ? [sleeveFeeVid] : []);

          const getRoot = () => document.querySelector('sancando-customization[data-charge-dtf-placement="true"]');

          const readUiState = () => {
            const root = getRoot();
            if (!root) {
              return {
                method: '',
                placementId: '',
                placementLabel: '',
                sleeveOn: false,
                sleeveSide: '',
              };
            }
            const methodInput = root.querySelector('input[name="properties[Decoration Method]"]:checked');
            const placeInput = root.querySelector('input[name="properties[_placement_id]"]:checked');
            const sleeveCheck = root.querySelector('[data-dtf-sleeve-addon-check]');
            const sideInput = root.querySelector('input[name="properties[Sleeve Side]"]:checked');
            const placementId = placeInput ? String(placeInput.value || '') : '';
            const placementLabel = placeInput
              ? String(placeInput.getAttribute('data-placement-label') || placeInput.value || '')
              : '';
            const sleeveOn = !!(sleeveCheck && sleeveCheck.checked && !sleeveCheck.disabled);
            const sleeveSide = sideInput ? String(sideInput.value || '').trim() : '';
            return {
              method: methodInput ? String(methodInput.value || '') : '',
              placementId: placementId,
              placementLabel: placementLabel,
              sleeveOn: sleeveOn,
              sleeveSide: sleeveSide,
            };
          };

          const feeVidForPlacement = (placementId) => {
            const id = String(placementId || '');
            if (!id || id === 'left-chest') return '';
            return String(feeMap[id] || '').trim();
          };

          const shouldCharge = (method, placementId) => {
            if (!/^dtf$/i.test(String(method || '').trim())) return false;
            return !!feeVidForPlacement(placementId);
          };

          const readBodyText = (body) => {
            if (body == null) return '';
            if (typeof body === 'string') return body;
            if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.toString();
            return '';
          };

          const parseCartAddPayload = (body) => {
            const out = { ids: [], method: '', placementId: '', placementLabel: '', isAddonOnly: false };
            if (!body) return out;
            const takeProps = (src) => {
              if (!src || typeof src !== 'object') return;
              const props = src.properties || src.attributes || {};
              const method = src['properties[Decoration Method]'] || props['Decoration Method'] || props.decoration_method;
              const placementId = src['properties[_placement_id]'] || props['_placement_id'] || props._placement_id;
              const placementLabel = src['properties[Placement]'] || props['Placement'] || props.placement;
              if (method && !out.method) out.method = String(method);
              if (placementId && !out.placementId) out.placementId = String(placementId);
              if (placementLabel && !out.placementLabel) out.placementLabel = String(placementLabel);
              const id = src.id || src.variant_id || src.merchandiseId;
              if (id != null && String(id) !== '') out.ids.push(String(id).replace(/^gid:\/\/shopify\/ProductVariant\//, ''));
            };
            if (typeof FormData !== 'undefined' && body instanceof FormData) {
              out.method = String(body.get('properties[Decoration Method]') || '');
              out.placementId = String(body.get('properties[_placement_id]') || '');
              out.placementLabel = String(body.get('properties[Placement]') || '');
              const id = body.get('id');
              if (id) out.ids.push(String(id));
              return out;
            }
            const raw = readBodyText(body);
            if (!raw) return out;
            try {
              const json = JSON.parse(raw);
              if (Array.isArray(json.items)) json.items.forEach(takeProps);
              else takeProps(json);
            } catch (err) {
              try {
                const params = new URLSearchParams(raw);
                out.method = String(params.get('properties[Decoration Method]') || '');
                out.placementId = String(params.get('properties[_placement_id]') || '');
                out.placementLabel = String(params.get('properties[Placement]') || '');
                const id = params.get('id');
                if (id) out.ids.push(String(id));
              } catch (err2) {
                /* ignore */
              }
            }
            return out;
          };

          const payloadLooksLikeAddon = (payload) => {
            if (!payload || !payload.ids.length) return false;
            return payload.ids.every((id) => feeVids.indexOf(String(id)) !== -1);
          };

          let feeInflight = null;
          let removeInflight = null;

          const removeDtfPlacementFees = async () => {
            if (removeInflight) return removeInflight;
            removeInflight = (async () => {
              try {
                const cartRes = await origFetch('/cart.js', {
                  credentials: 'same-origin',
                  headers: { Accept: 'application/json' },
                });
                const cart = await cartRes.json();
                const lines = (cart.items || []).filter((it) => {
                  const vid = String(it.variant_id);
                  if (feeVids.indexOf(vid) !== -1) return true;
                  const props = it.properties || {};
                  return props._addon === 'dtf-placement' || props._addon === 'dtf-sleeve';
                });
                for (const line of lines) {
                  const key = line.key || line.id;
                  if (!key) continue;
                  await origFetch('/cart/change.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      Accept: 'application/json',
                    },
                    body: JSON.stringify({ id: key, quantity: 0 }),
                  });
                }
              } catch (err) {
                /* skip */
              } finally {
                removeInflight = null;
              }
            })();
            return removeInflight;
          };

          const ensureDtfPlacementFee = async (placementId, placementLabel) => {
            if (!getRoot()) return;
            if (feeInflight) return feeInflight;
            feeInflight = (async () => {
              try {
                await removeDtfPlacementFees();
                const ui = readUiState();
                const items = [];
                const feeVid = feeVidForPlacement(placementId);
                if (feeVid) {
                  items.push({
                    id: Number(feeVid),
                    quantity: 1,
                    properties: {
                      _addon: 'dtf-placement',
                      For: placementLabel || placementId || 'DTF placement upgrade',
                    },
                  });
                }
                /* Stackable Sleeve add-on — independent of placement fee. */
                if (ui.sleeveOn && sleeveFeeVid && ui.sleeveSide) {
                  items.push({
                    id: Number(sleeveFeeVid),
                    quantity: 1,
                    properties: {
                      _addon: 'dtf-sleeve',
                      For: 'Sleeve (' + ui.sleeveSide + ')',
                      'Sleeve Side': ui.sleeveSide,
                    },
                  });
                }
                if (!items.length) return;
                await origFetch('/cart/add.js', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                  body: JSON.stringify({ items: items }),
                });
              } catch (err) {
                /* product already in cart */
              } finally {
                feeInflight = null;
              }
            })();
            return feeInflight;
          };

          const wantsFeeFromPayloadOrUi = (payload) => {
            const ui = readUiState();
            const method = (payload && payload.method) || ui.method;
            const placementId = (payload && payload.placementId) || ui.placementId;
            if (!/^dtf$/i.test(String(method || '').trim())) return false;
            if (shouldCharge(method, placementId)) return true;
            if (ui.sleeveOn && sleeveFeeVid && ui.sleeveSide) return true;
            return false;
          };

          const shouldRemoveFee = (payload) => {
            /* Drop all DTF fee lines when not DTF, or when neither placement fee nor sleeve apply. */
            return !wantsFeeFromPayloadOrUi(payload);
          };

          const resolvePlacement = (payload) => {
            const ui = readUiState();
            return {
              placementId: (payload && payload.placementId) || ui.placementId,
              placementLabel: (payload && payload.placementLabel) || ui.placementLabel,
            };
          };

          window.fetch = async (input, init) => {
            const url = typeof input === 'string' ? input : (input && input.url) || '';
            const isCartAdd = cartAddRe.test(url);
            const body = init && init.body;
            const payload = isCartAdd ? parseCartAddPayload(body) : null;
            const isAddonLine = payloadLooksLikeAddon(payload);
            const res = await origFetch(input, init);
            if (!isCartAdd || isAddonLine) return res;
            if (!getRoot()) return res;
            let addFailed = !res.ok;
            try {
              const clone = res.clone();
              const data = await clone.json();
              if (data && data.status) addFailed = true;
            } catch (err) {
              /* Horizon sometimes receives HTML */
            }
            if (addFailed) return res;
            if (shouldRemoveFee(payload)) {
              await removeDtfPlacementFees();
              return res;
            }
            if (!wantsFeeFromPayloadOrUi(payload)) return res;
            const place = resolvePlacement(payload);
            await ensureDtfPlacementFee(place.placementId, place.placementLabel);
            return res;
          };

          document.addEventListener(
            'submit',
            (event) => {
              const form = event.target;
              if (!(form instanceof HTMLFormElement)) return;
              const action = form.getAttribute('action') || form.action || '';
              if (!cartAddRe.test(action)) return;
              const payload = parseCartAddPayload(new FormData(form));
              if (payloadLooksLikeAddon(payload)) return;
              if (event.defaultPrevented) {
                if (shouldRemoveFee(payload)) removeDtfPlacementFees();
                return;
              }
              const wantsFee = wantsFeeFromPayloadOrUi(payload);
              const dropFee = shouldRemoveFee(payload);
              if (!wantsFee && !dropFee) return;
              event.preventDefault();
              event.stopPropagation();
              (async () => {
                try {
                  const res = await origFetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: new FormData(form),
                    headers: { Accept: 'application/json' },
                  });
                  let addFailed = !res.ok;
                  try {
                    const data = await res.clone().json();
                    if (data && data.status) addFailed = true;
                  } catch (err) {
                    /* HTML ok */
                  }
                  if (!addFailed && dropFee) await removeDtfPlacementFees();
                  if (!addFailed && wantsFee) {
                    const place = resolvePlacement(payload);
                    await ensureDtfPlacementFee(place.placementId, place.placementLabel);
                  }
                  window.location.href = '/cart';
                } catch (err) {
                  form.submit();
                }
              })();
            },
            false
          );

          document.addEventListener('change', (event) => {
            const target = event.target;
            if (!(target instanceof HTMLInputElement)) return;
            if (
              target.name !== 'properties[_placement_id]' &&
              target.name !== 'properties[Decoration Method]' &&
              target.name !== 'properties[Sleeve Addon]' &&
              target.name !== 'properties[Sleeve Side]'
            ) {
              return;
            }
            if (!getRoot()) return;
            const ui = readUiState();
            if (!wantsFeeFromPayloadOrUi(null)) {
              removeDtfPlacementFees();
              return;
            }
            // Optional: sync fee if already in cart with product
            (async () => {
              try {
                const cartRes = await origFetch('/cart.js', {
                  credentials: 'same-origin',
                  headers: { Accept: 'application/json' },
                });
                const cart = await cartRes.json();
                const hasMain = (cart.items || []).some((it) => {
                  const props = it.properties || {};
                  return props._placement_id || props.Placement;
                });
                const hasAnyFee = (cart.items || []).some((it) => {
                  const props = it.properties || {};
                  return (
                    props._addon === 'dtf-placement' ||
                    props._addon === 'dtf-sleeve' ||
                    feeVids.indexOf(String(it.variant_id)) !== -1
                  );
                });
                if (hasMain || hasAnyFee) {
                  await ensureDtfPlacementFee(ui.placementId, ui.placementLabel);
                }
              } catch (err) {
                /* ignore */
              }
            })();
          });
        }

        syncReveal(checkbox) {
          const panel = document.getElementById(checkbox.dataset.reveal);
          if (!panel) return;
          this.applyReveal(panel, checkbox.checked);
          this.syncBothPriceNote();
        }

        isAllowed(file) {
          const ext = (file.name.split('.').pop() || '').toLowerCase();
          if (this.allowedExt.indexOf(ext) !== -1) return true;
          if (file.type && this.allowedMime.indexOf(file.type) !== -1) return true;
          return false;
        }

        isRasterImage(file) {
          const ext = (file.name.split('.').pop() || '').toLowerCase();
          const type = (file.type || '').toLowerCase();
          if (['jpg', 'jpeg', 'png', 'webp'].indexOf(ext) !== -1) return true;
          return ['image/jpeg', 'image/png', 'image/webp'].indexOf(type) !== -1;
        }

        async onFileChange(input) {
          const file = input.files && input.files[0];
          const nameEl = document.getElementById(input.dataset.filenameTarget);
          const errorEl = document.getElementById(input.dataset.errorTarget);

          const showError = (message) => {
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = message;
              errorEl.classList.add('is-visible');
            }
            input.value = '';
            if (nameEl) nameEl.textContent = '';
            this.clearLogoCache();
          };

          const clearError = () => {
            if (errorEl) {
              errorEl.hidden = true;
              errorEl.textContent = '';
              errorEl.classList.remove('is-visible');
            }
          };

          if (!file) {
            if (this._removing || this._userClearedLogo) {
              clearError();
              if (nameEl) nameEl.textContent = '';
              this._logoKeyed = false;
              this._keyedPreviewFile = null;
              this._laserSilverPreviewFile = null;
              this.syncUploadChrome();
              this.syncImprintPreview();
              this.applyDecorationMedia();
              return;
            }
            if (this._repicking) {
              clearError();
              return;
            }
            const cached = this.getLogoCache();
            if (cached && cached.file) {
              /* Hats color morph replaces the file input — put the file back. */
              this.restoreLogoFromCache();
              this.remountImprintsOnVisibleMedia();
              this.syncUploadChrome();
              this.syncImprintPreview();
              this.applyDecorationMedia();
              return;
            }
            clearError();
            if (nameEl) nameEl.textContent = '';
            this._logoKeyed = false;
            this._keyedPreviewFile = null;
            this._laserSilverPreviewFile = null;
            this.syncUploadChrome();
            this.syncImprintPreview();
            return;
          }

          if (file.size > this.maxBytes) {
            showError('File is over 20MB. Please choose a smaller file.');
            return;
          }

          if (!this.isAllowed(file)) {
            showError('Use PNG, JPG, SVG, WebP, PDF, AI, or EPS.');
            return;
          }

          clearError();
          if (nameEl) nameEl.textContent = file.name;
          this.clearPreviewOnlyRestore();
          this._removing = false;
          this._repicking = false;
          this._userClearedLogo = false;
          this.saveLogoCache({ file: file, keyedPreviewFile: this._keyedPreviewFile || null, logoKeyed: !!this._logoKeyed });
          this.syncUploadChrome();
          /* fix2: save now (encoding starts immediately) so a fast reload still restores the logo. */
          this.bindPersistFlush();
          clearTimeout(this._persistTimer);
          this.persistDesignNow().catch(() => { /* never break the page */ });

          if (!this.isRasterImage(file)) {
            this._keyedPreviewFile = null;
            this._laserSilverPreviewFile = null;
            this._logoKeyed = false;
            this.saveLogoCache({ file: file, keyedPreviewFile: null, logoKeyed: false });
            this.syncImprintPreview();
            return;
          }

          /* Re-entry guard (safety net only). Never assign input.files —
             checkout must keep the original upload. A fresh user filename
             clears flags so a second upload still keys once. */
          if (file.name !== 'logo-transparent.png') {
            this._logoKeyed = false;
            this._keyedPreviewFile = null;
            this._laserSilverPreviewFile = null;
          }
          if (file.name === 'logo-transparent.png' || this._logoKeyed) {
            this.syncImprintPreview();
            return;
          }

          try {
            const processed = await this.makeTransparentBackground(file);
            if (processed) {
              this._keyedPreviewFile = processed;
              this._logoKeyed = true;
              this._laserSilverPreviewFile = null;
              /* Jefe 2026-09-18: apparel uploads keep upload colors — strip background only (no gray plate).
                 Drinkware/glassware mono (laser/sandblast) still use Polar silver #b1b1b1 plate.
                 DTF/UV/hats: no silver plate. */
              const isApparel =
                typeof this.isApparelProduct === 'function'
                  ? this.isApparelProduct()
                  : ((this.dataset.templateSuffix || '').toLowerCase() === 'apparel' ||
                     (this.dataset.productType || '').toLowerCase() === 'apparel');
              if (
                !isApparel &&
                !this.isFullColorDecoration() &&
                !this.isHatsProduct() &&
                !this.isDtfDecoration()
              ) {
                this._laserSilverPreviewFile = await this.toLaserSilverPlate(processed);
              }
            }
          } catch (err) {
            this._logoKeyed = false;
            this._keyedPreviewFile = null;
            this._laserSilverPreviewFile = null;
            /* Keep the original file so checkout is never blocked. */
          }
          this.saveLogoCache({
            file: file,
            keyedPreviewFile: this._keyedPreviewFile || null,
            laserSilverPreviewFile: this._laserSilverPreviewFile || null,
            logoKeyed: !!this._logoKeyed,
          });
          this.syncImprintPreview();
          this.persistDesignSoon();
        }

        imprintBoxes() {
          return document.querySelectorAll('.sancando-imprint-preview');
        }

        textBoxes() {
          return document.querySelectorAll('.sancando-imprint-text');
        }

        primaryImprintBoxes() {
          return document.querySelectorAll('.sancando-imprint-preview:not(.sancando-imprint-preview--mirror)');
        }

        primaryTextBoxes() {
          return document.querySelectorAll('.sancando-imprint-text:not(.sancando-imprint-text--mirror)');
        }

        isMirrorBox(el) {
          return !!(
            el &&
            (el.classList.contains('sancando-imprint-preview--mirror') ||
              el.classList.contains('sancando-imprint-text--mirror') ||
              el.getAttribute('data-mirror') === '1')
          );
        }

        isPlaceMode() {
          return document.documentElement.dataset.sancandoPlace === '1';
        }

        canPreviewFile(file) {
          if (!file) return false;
          const ext = (file.name.split('.').pop() || '').toLowerCase();
          const type = (file.type || '').toLowerCase();
          if (['png', 'jpg', 'jpeg', 'webp', 'svg', 'gif'].indexOf(ext) !== -1) return true;
          return type.indexOf('image/') === 0;
        }

        pct(n) {
          return Math.round(n * 10) / 10 + '%';
        }

        numPct(v) {
          return parseFloat(String(v || '').replace('%', '')) || 0;
        }

        readBox(el) {
          return {
            top: el.style.top || '24.5%',
            left: el.style.left || '31%',
            width: el.style.width || '38%',
            height: el.style.height || '49.5%',
          };
        }

        writeBox(el, box) {
          if (!el || !box) return;
          el.style.top = box.top;
          el.style.left = box.left;
          el.style.width = box.width;
          el.style.height = box.height;
        }

        imprintArea(el) {
          const raw = (el && el.getAttribute('data-imprint-area')) || '';
          if (raw) {
            try {
              return JSON.parse(raw);
            } catch (err) {
              /* fall through */
            }
          }
          return { top: '24.5%', left: '31%', width: '38%', height: '49.5%' };
        }

        isTallNarrow(area) {
          const w = this.numPct(area.width);
          const h = this.numPct(area.height);
          return w > 0 && h > w;
        }

        wideTextBox(area) {
          // Tall/narrow drinkware uses the same family/rim box as logo/hint
          // (20oz rim-to-first-ring: 24.5 / 31 / 38 / 49.5). Do not force 60×28.
          const rim = { top: '24.5%', left: '31%', width: '38%', height: '49.5%' };
          if (!area) return rim;
          return {
            top: area.top || rim.top,
            left: area.left || rim.left,
            width: area.width || rim.width,
            height: area.height || rim.height,
          };
        }

        splitArea(area) {
          const top = this.numPct(area.top);
          const height = this.numPct(area.height);
          const gap = Math.min(2, Math.max(1, height * 0.05));
          const logoH = (height - gap) * 0.55;
          const textH = height - gap - logoH;
          return {
            logo: {
              top: this.pct(top),
              left: area.left,
              width: area.width,
              height: this.pct(logoH),
            },
            text: {
              top: this.pct(top + logoH + gap),
              left: area.left,
              width: area.width,
              height: this.pct(textH),
            },
          };
        }

        applyDefaultLayout(showLogo, showText) {
          const logoBoxes = this.imprintBoxes();
          const textBoxes = this.textBoxes();
          const multi = logoBoxes.length > 1 || textBoxes.length > 1;
          // Multi-stamp gift sets: each box keeps its own data-imprint-area
          // at fixed stamp size (no wideText/split across faces).
          // Single-box products keep prior split/wide-text behavior.
          if (showLogo) {
            logoBoxes.forEach((box) => {
              if (box.dataset.userMoved) return;
              /* Hats leatherette: syncLeatherettePatchPlate owns starter + full-cap clamp. */
              if (this.isHatsLeatherette()) return;
              const la = this.imprintArea(box);
              /* audit-fix 2026-10-27 #8: single-box logo+text -> logo gets the top split. */
              this.writeBox(box, (showText && !multi) ? this.splitArea(la).logo : la);
            });
          }
          if (showText) {
            textBoxes.forEach((box) => {
              if (box.dataset.userMoved) return;
              const area = this.imprintArea(box);
              let textDefault = area;
              if (multi) {
                textDefault = area;
              } else if (showLogo && !this.isHatsLeatherette()) {
                /* audit-fix 2026-10-27 #8: logo + text never share one box — logo top, text below. */
                textDefault = this.splitArea(area).text;
              } else if (this.isTallNarrow(area) || this.numPct(area.width) < 54) {
                textDefault = this.wideTextBox(area);
              }
              this.writeBox(box, textDefault);
            });
          }
        }

        fitTextBox(box) {
          if (!box) return;
          const el = box.querySelector('.sancando-imprint-text__value');
          if (!el || !String(el.textContent || '').trim()) return;
          const readAvail = () => {
            const br = box.getBoundingClientRect();
            if (br.width < 8 || br.height < 8) return null;
            const cs = getComputedStyle(el);
            const padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
            const padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
            return {
              availW: Math.max(4, el.clientWidth - padX),
              availH: Math.max(4, el.clientHeight - padY),
            };
          };
          const textRect = () => {
            if (!el.firstChild) return { width: 0, height: 0 };
            const range = document.createRange();
            range.selectNodeContents(el);
            return range.getBoundingClientRect();
          };
          const fits = (px, avail) => {
            el.style.fontSize = px + 'px';
            if (!el.firstChild) return true;
            const r = textRect();
            return r.width <= avail.availW + 1 && r.height <= avail.availH + 1;
          };
          let avail = readAvail();
          if (!avail) return;
          const minPx = 18;
          if (!fits(minPx, avail)) {
            if (box.dataset.userMoved) {
              el.style.fontSize = minPx + 'px';
              return;
            }
            el.style.fontSize = minPx + 'px';
            const r = textRect();
            const parent = box.offsetParent || box.parentElement;
            const pr = parent && parent.getBoundingClientRect();
            if (pr && pr.width > 8 && pr.height > 8) {
              const curW = this.numPct(box.style.width) || (box.getBoundingClientRect().width / pr.width) * 100;
              const curH = this.numPct(box.style.height) || (box.getBoundingClientRect().height / pr.height) * 100;
              const curL = this.numPct(box.style.left);
              const curT = this.numPct(box.style.top);
              const cx = curL + curW / 2;
              const cy = curT + curH / 2;
              const scaleW = avail.availW > 0 && r.width > avail.availW + 1 ? (r.width + 2) / avail.availW : 1;
              const scaleH = avail.availH > 0 && r.height > avail.availH + 1 ? (r.height + 2) / avail.availH : 1;
              let tw = Math.min(100, Math.max(curW * scaleW, curW));
              let th = Math.min(100, Math.max(curH * scaleH, curH));
              let tLeft = cx - tw / 2;
              let tTop = cy - th / 2;
              tLeft = Math.max(0, Math.min(tLeft, 100 - tw));
              tTop = Math.max(0, Math.min(tTop, 100 - th));
              this.writeBox(box, {
                top: this.pct(tTop),
                left: this.pct(tLeft),
                width: this.pct(tw),
                height: this.pct(th),
              });
              avail = readAvail();
              if (!avail) {
                el.style.fontSize = minPx + 'px';
                return;
              }
            }
            if (!fits(minPx, avail)) {
              el.style.fontSize = minPx + 'px';
              return;
            }
          }
          const maxPx = Math.max(minPx, avail.availH);
          if (fits(maxPx, avail)) {
            el.style.fontSize = maxPx + 'px';
            return;
          }
          let lo = minPx;
          let hi = maxPx;
          let best = minPx;
          for (let i = 0; i < 18; i++) {
            const mid = (lo + hi) / 2;
            if (fits(mid, avail)) {
              best = mid;
              lo = mid;
            } else {
              hi = mid;
            }
          }
          el.style.fontSize = (Math.round(best * 10) / 10) + 'px';
        }

        isSamplePreview() {
          try {
            return new URLSearchParams(window.location.search).get('sancando_sample') === '1';
          } catch (err) {
            return false;
          }
        }

        setTextRotation(deg) {
          deg = ((Math.round(Number(deg) || 0) % 360) + 360) % 360;
          this.textBoxes().forEach((box) => {
            box.dataset.rotation = String(deg);
            box.style.transform = deg ? 'rotate(' + deg + 'deg)' : '';
            box.style.transformOrigin = 'center center';
          });
        }

        lockSlideshow(lock) {
          const nodes = document.querySelectorAll(
            'product-media-gallery slideshow-component, .product-media-gallery slideshow-component, slideshow-component'
          );
          nodes.forEach((el) => {
            if (lock) {
              if (el.dataset.sancandoPrevDisabled == null) {
                el.dataset.sancandoPrevDisabled = el.getAttribute('disabled') || '';
              }
              el.setAttribute('disabled', 'true');
              try {
                el.disabled = true;
              } catch (err) {
                /* ignore */
              }
            } else if (el.dataset.sancandoPrevDisabled != null) {
              const prev = el.dataset.sancandoPrevDisabled;
              delete el.dataset.sancandoPrevDisabled;
              if (prev === 'true') {
                el.setAttribute('disabled', 'true');
                try {
                  el.disabled = true;
                } catch (err) {
                  /* ignore */
                }
              } else {
                el.removeAttribute('disabled');
                try {
                  el.disabled = false;
                } catch (err) {
                  /* ignore */
                }
              }
            }
          });
          this.lockZoomLightbox(lock);
        }

        lockZoomLightbox(lock) {
          document.querySelectorAll('zoom-dialog').forEach((zd) => {
            if (lock) {
              if (typeof zd.open === 'function' && !zd._sancandoOrigOpen) {
                const orig = zd.open.bind(zd);
                zd._sancandoOrigOpen = orig;
                zd.open = function (index, event) {
                  if (document.documentElement.dataset.sancandoCustomizing === '1') {
                    if (event && typeof event.preventDefault === 'function') event.preventDefault();
                    return;
                  }
                  return orig(index, event);
                };
              }
            } else if (zd._sancandoOrigOpen) {
              zd.open = zd._sancandoOrigOpen;
              delete zd._sancandoOrigOpen;
            }
          });
          document.querySelectorAll('media-gallery').forEach((mg) => {
            if (lock) {
              if (typeof mg.zoom === 'function' && !mg._sancandoOrigZoom) {
                const orig = mg.zoom.bind(mg);
                mg._sancandoOrigZoom = orig;
                mg.zoom = function (index, event) {
                  if (document.documentElement.dataset.sancandoCustomizing === '1') {
                    if (event && typeof event.preventDefault === 'function') event.preventDefault();
                    return;
                  }
                  return orig(index, event);
                };
              }
            } else if (mg._sancandoOrigZoom) {
              mg.zoom = mg._sancandoOrigZoom;
              delete mg._sancandoOrigZoom;
            }
          });
          document.querySelectorAll('[on\\:click]').forEach((el) => {
            const attr = el.getAttribute('on:click') || '';
            if (!/zoom-dialog|\/open\/|\/zoom\//.test(attr)) return;
            if (lock) {
              if (el.dataset.sancandoPrevOnClick == null) {
                el.dataset.sancandoPrevOnClick = attr;
                el.removeAttribute('on:click');
              }
            } else if (el.dataset.sancandoPrevOnClick != null) {
              el.setAttribute('on:click', el.dataset.sancandoPrevOnClick);
              delete el.dataset.sancandoPrevOnClick;
            }
          });
          document.querySelectorAll('.product-media-container__zoom-button').forEach((btn) => {
            if (lock) {
              btn.setAttribute('disabled', 'true');
              btn.setAttribute('tabindex', '-1');
            } else {
              btn.removeAttribute('disabled');
              btn.removeAttribute('tabindex');
            }
          });
        }

        persistBoxProps(showLogo, showText) {
          const logoInput = this.querySelector('[data-sancando-logo-box]');
          const textInput = this.querySelector('[data-sancando-text-box]');
          const rotInput = this.querySelector('[data-sancando-text-rotation]');
          const logoBox = document.querySelector(
            '.sancando-imprint-preview:not(.sancando-imprint-preview--mirror)'
          );
          const textBox = document.querySelector(
            '.sancando-imprint-text:not(.sancando-imprint-text--mirror)'
          );
          const hatsLeather = this.isHatsLeatherette();
          if (logoInput) {
            logoInput.disabled = !(showLogo || hatsLeather);
            if ((showLogo || hatsLeather) && logoBox) logoInput.value = JSON.stringify(this.readBox(logoBox));
          }
          if (textInput) {
            textInput.disabled = !showText;
            if (showText && textBox) textInput.value = JSON.stringify(this.readBox(textBox));
          }
          if (rotInput) {
            rotInput.disabled = !showText;
            if (showText && textBox) rotInput.value = String(textBox.dataset.rotation || '0');
          }
          try { this.syncPlacementProperty(); } catch (err) { /* ignore */ }
          this.persistDesignSoon();
        }

        /* fix2: Placement line property follows the box. Centre moved > 4 points off the preset area = 'Custom position'
           (exact box still goes in '_Logo box %', hidden at checkout); back on preset or no moved logo = the preset label again. */
        logoBoxOffPreset() {
          const box = document.querySelector('.sancando-imprint-preview.has-logo:not(.sancando-imprint-preview--mirror)');
          if (!box || !box.dataset.userMoved) return false;
          const cur = this.readBox(box);
          const area = this.imprintArea(box);
          const n = (v) => this.numPct(v);
          const dx = Math.abs(n(cur.left) + n(cur.width) / 2 - (n(area.left) + n(area.width) / 2));
          const dy = Math.abs(n(cur.top) + n(cur.height) / 2 - (n(area.top) + n(area.height) / 2));
          return dx > 4 || dy > 4;
        }

        placementInputs() {
          return this.querySelectorAll('input[type="hidden"][name="properties[Placement]"]');
        }

        currentPlacementValue() {
          const el = Array.prototype.find.call(this.placementInputs(), (i) => !i.disabled);
          return el ? el.value : null;
        }

        syncPlacementProperty() {
          const off = this.logoBoxOffPreset();
          this.placementInputs().forEach((el) => {
            if (el.value !== 'Custom position') el.dataset.sancandoPresetLabel = el.value;
            if (el.hasAttribute('data-dtf-placement-label')) {
              const checked = this.querySelector('input[data-dtf-placement]:checked');
              if (checked) el.dataset.sancandoPresetLabel = checked.getAttribute('data-placement-label') || checked.value || el.dataset.sancandoPresetLabel;
            }
            const want = off ? 'Custom position' : el.dataset.sancandoPresetLabel || el.value;
            if (el.value !== want) el.value = want;
          });
        }

        bindZoomGuard() {
          if (window.__sancandoZoomGuard === 'true') return;
          window.__sancandoZoomGuard = 'true';
          const hitBox = (e) => {
            const t = e.target;
            if (!(t instanceof Element)) return false;
            return !!t.closest(
              '.sancando-imprint-text, .sancando-imprint-preview, .sancando-box-handle, .sancando-rotate-handle'
            );
          };
          const customizing = () =>
            document.documentElement.dataset.sancandoCustomizing === '1' ||
            document.querySelector('.sancando-imprint-text.has-text, .sancando-imprint-preview.has-logo') != null;
          // Window capture runs BEFORE Horizon's document-capture on:click zoom.
          // Click only — pointerdown must still reach the box so drag can start.
          const isolateClick = (e) => {
            if (!customizing()) return;
            const t = e.target;
            if (!(t instanceof Element)) return;
            if (
              !hitBox(e) &&
              !t.closest(
                'slideshow-slide, .product-media-container--zoomable, .product-media-container__zoom-button, media-gallery'
              )
            ) {
              return;
            }
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          };
          window.addEventListener('click', isolateClick, true);
        }

        bindCustomerBoxes() {
          if (this.isPlaceMode()) return;
          this.bindDelegatedBoxDrag();
          this.primaryImprintBoxes().forEach((box) => this.enableBoxInteract(box, 'logo'));
          this.primaryTextBoxes().forEach((box) => this.enableBoxInteract(box, 'text'));
        }

        bindDelegatedBoxDrag() {
          if (window.__sancandoBoxDragBound === 'true') return;
          window.__sancandoBoxDragBound = 'true';
          const host = () => document.querySelector('sancando-customization') || this;
          let drag = null;
          let rotate = null;

          const isolate = (e) => {
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            if (e.cancelable && e.type !== 'pointermove') e.preventDefault();
          };

          const activeBoxFrom = (t) => {
            if (!(t instanceof Element)) return null;
            if (t.closest('.sancando-imprint-preview--mirror, .sancando-imprint-text--mirror')) {
              return null;
            }
            return t.closest(
              '.sancando-imprint-text.has-text:not(.sancando-imprint-text--mirror), .sancando-imprint-preview.has-logo:not(.sancando-imprint-preview--mirror), .sancando-imprint-preview.is-patch-frame:not(.sancando-imprint-preview--mirror)'
            );
          };

          const startDrag = (e, el, mode, dir) => {
            const h = host();
            if (!h || h.isPlaceMode()) return;
            if (h.isMirrorBox(el)) return;
            const parent = el.offsetParent || el.parentElement;
            if (!parent) return;
            const pr = parent.getBoundingClientRect();
            const br = el.getBoundingClientRect();
            if (pr.width < 8 || pr.height < 8) return;
            isolate(e);
            drag = {
              el: el,
              kind: el.classList.contains('sancando-imprint-text') ? 'text' : 'logo',
              mode: mode,
              dir: dir || '',
              px: e.clientX,
              py: e.clientY,
              left: br.left - pr.left,
              top: br.top - pr.top,
              w: br.width,
              h: br.height,
              pw: pr.width,
              ph: pr.height,
            };
            /* fix4: remember the pre-press state and start rect; a tap/click without movement must not count as 'moved' */
            drag.prevMoved = el.dataset.userMoved === '1';
            drag.b0 = [br.left, br.top, br.width, br.height];
            el.dataset.userMoved = '1';
            try {
              el.setPointerCapture(e.pointerId);
            } catch (err) {
              /* ignore */
            }
          };

          const onPointerDown = (e) => {
            const h = host();
            if (!h || h.isPlaceMode()) return;
            const t = e.target;
            if (!(t instanceof Element)) return;

            const rot = t.closest('.sancando-rotate-handle');
            if (rot) {
              const el = rot.closest('.sancando-imprint-text.has-text:not(.sancando-imprint-text--mirror)');
              if (!el || (h.isMirrorBox && h.isMirrorBox(el))) return;
              isolate(e);
              const r = el.getBoundingClientRect();
              rotate = {
                el: el,
                handle: rot,
                x: e.clientX,
                y: e.clientY,
                cx: r.left + r.width / 2,
                cy: r.top + r.height / 2,
                rot: Number(el.dataset.rotation || 0),
                moved: false,
              };
              rotate.pointer = (Math.atan2(e.clientY - rotate.cy, e.clientX - rotate.cx) * 180) / Math.PI;
              try {
                rot.setPointerCapture(e.pointerId);
              } catch (err) {
                /* ignore */
              }
              return;
            }

            const handle = t.closest('.sancando-box-handle');
            const box = activeBoxFrom(t);
            const el = box || (handle && handle.closest('.sancando-imprint-text, .sancando-imprint-preview'));
            if (!el) return;
            if (h.isMirrorBox(el)) return;
            if (
              !el.classList.contains('has-text') &&
              !el.classList.contains('has-logo') &&
              !el.classList.contains('is-patch-frame')
            ) {
              return;
            }
            /* Patch frame: body/interior = move; only true corner hits = resize.
               Handle ::before hit-slop must not swallow the whole frame. */
            if (handle && el.classList.contains('is-patch-frame')) {
              const hr = handle.getBoundingClientRect();
              const pad = 6;
              const inCorner =
                e.clientX >= hr.left - pad &&
                e.clientX <= hr.right + pad &&
                e.clientY >= hr.top - pad &&
                e.clientY <= hr.bottom + pad;
              if (inCorner) startDrag(e, el, 'resize', handle.getAttribute('data-dir') || '');
              else startDrag(e, el, 'move', '');
            } else if (handle) {
              startDrag(e, el, 'resize', handle.getAttribute('data-dir') || '');
            } else {
              startDrag(e, el, 'move', '');
            }
          };

          const onMove = (e) => {
            const h = host();
            if (!h) return;
            if (rotate) {
              const dx = e.clientX - rotate.x;
              const dy = e.clientY - rotate.y;
              if (dx * dx + dy * dy > 16) rotate.moved = true;
              if (!rotate.moved) return;
              const ang = (Math.atan2(e.clientY - rotate.cy, e.clientX - rotate.cx) * 180) / Math.PI;
              h.setTextRotation(rotate.rot + (ang - rotate.pointer));
              return;
            }
            if (!drag) return;
            const dx = e.clientX - drag.px;
            const dy = e.clientY - drag.py;
            let left = drag.left;
            let top = drag.top;
            let w = drag.w;
            let ht = drag.h;
            const patchFrame =
              drag.el.classList.contains('is-patch-frame') ||
              (drag.kind === 'logo' && h.isHatsLeatherette && h.isHatsLeatherette());
            if (drag.mode === 'move') {
              left += dx;
              top += dy;
            } else {
              const dir = drag.dir || '';
              if (dir.indexOf('e') >= 0) w += dx;
              if (dir.indexOf('s') >= 0) ht += dy;
              if (dir.indexOf('w') >= 0) {
                left += dx;
                w -= dx;
              }
              if (dir.indexOf('n') >= 0) {
                top += dy;
                ht -= dy;
              }
              if (patchFrame) {
                const shapeInput = h.querySelector('input[name="properties[Patch Shape]"]:checked');
                const shape = ((shapeInput && shapeInput.value) || 'Round').toLowerCase().replace(/\s+/g, '-');
                const aspect = h.hatPatchAspect(shape);
                if (aspect > 0) {
                  if (Math.abs(dx) >= Math.abs(dy)) {
                    ht = w / aspect;
                  } else {
                    w = ht * aspect;
                  }
                  if (dir.indexOf('w') >= 0) left = drag.left + drag.w - w;
                  if (dir.indexOf('n') >= 0) top = drag.top + drag.h - ht;
                }
              }
            }
            w = Math.max(24, Math.min(w, drag.pw));
            ht = Math.max(24, Math.min(ht, drag.ph));
            if (patchFrame && drag.mode === 'resize') {
              const shapeInput = h.querySelector('input[name="properties[Patch Shape]"]:checked');
              const shape = ((shapeInput && shapeInput.value) || 'Round').toLowerCase().replace(/\s+/g, '-');
              const aspect = h.hatPatchAspect(shape);
              if (aspect > 0) {
                ht = w / aspect;
                if (ht > drag.ph) {
                  ht = drag.ph;
                  w = ht * aspect;
                }
                const dir = drag.dir || '';
                if (dir.indexOf('w') >= 0) left = drag.left + drag.w - w;
                if (dir.indexOf('n') >= 0) top = drag.top + drag.h - ht;
              }
            }
            left = Math.max(0, Math.min(left, drag.pw - w));
            top = Math.max(0, Math.min(top, drag.ph - ht));
            let boxPct = {
              top: h.pct((top / drag.ph) * 100),
              left: h.pct((left / drag.pw) * 100),
              width: h.pct((w / drag.pw) * 100),
              height: h.pct((ht / drag.ph) * 100),
            };
            if (patchFrame) {
              let maxPct = null;
              try {
                /* Hats leatherette: imprintMax is full-cap; do not use Markup imprintMaxSquare. */
                const raw = (h.isHatsLeatherette && h.isHatsLeatherette())
                  ? drag.el.dataset.imprintMax
                  : (drag.el.dataset.imprintMaxSquare || drag.el.dataset.imprintMax);
                if (raw) maxPct = JSON.parse(raw);
              } catch (err) {
                maxPct = null;
              }
              if (maxPct) {
                if (drag.mode === 'resize') {
                  const shapeInput = h.querySelector('input[name="properties[Patch Shape]"]:checked');
                  const shape = ((shapeInput && shapeInput.value) || 'Round')
                    .toLowerCase()
                    .replace(/\s+/g, '-');
                  const aspect = h.hatPatchAspect(shape);
                  let bw = h.numPct(boxPct.width);
                  let bh = h.numPct(boxPct.height);
                  const mw = h.numPct(maxPct.width);
                  const mh = h.numPct(maxPct.height);
                  if (bw > mw) {
                    bw = mw;
                    bh = bw / Math.max(aspect, 0.01);
                  }
                  if (bh > mh) {
                    bh = mh;
                    bw = bh * aspect;
                  }
                  let bl = h.numPct(boxPct.left);
                  let bt = h.numPct(boxPct.top);
                  const dir = drag.dir || '';
                  if (dir.indexOf('w') >= 0) {
                    bl = h.numPct(h.pct((drag.left + drag.w) / drag.pw * 100)) - bw;
                  }
                  if (dir.indexOf('n') >= 0) {
                    bt = h.numPct(h.pct((drag.top + drag.h) / drag.ph * 100)) - bh;
                  }
                  boxPct = h.clampBoxToMax(
                    {
                      top: h.pct(bt),
                      left: h.pct(bl),
                      width: h.pct(bw),
                      height: h.pct(bh),
                    },
                    maxPct
                  );
                } else {
                  boxPct = h.clampBoxToMax(boxPct, maxPct);
                }
              }
            }
            h.writeBox(drag.el, boxPct);
            if (drag.kind === 'text' && drag.mode === 'resize') h.fitTextBox(drag.el);
            /* Antifreeze: AABB follow only during drag — full sync on pointerup. */
            if (patchFrame && h.isHatsLeatherette && h.isHatsLeatherette()) {
              try {
                h.syncLeatherettePlateFollow();
              } catch (err) {
                /* ignore */
              }
            }
          };

          const onUp = (e) => {
            const h = host();
            if (rotate) {
              if (e && e.cancelable) e.preventDefault();
              if (e) e.stopPropagation();
              if (!rotate.moved && rotate.el && h) {
                const cur = Number(rotate.el.dataset.rotation || 0);
                h.setTextRotation(cur === 90 ? 0 : 90);
              }
              rotate = null;
              if (h) {
                h.persistBoxProps(
                  document.querySelector('.sancando-imprint-preview.has-logo') != null,
                  true
                );
              }
              return;
            }
            if (!drag) return;
            const wasResize = drag.mode === 'resize';
            const el = drag.el;
            const kind = drag.kind;
            const wasPatch =
              el &&
              (el.classList.contains('is-patch-frame') ||
                (kind === 'logo' && h && h.isHatsLeatherette && h.isHatsLeatherette()));
            const d0 = drag;
            drag = null;
            if (el) window.__sancandoSettleMoved(el, d0);
            if (h) {
              if (kind === 'text' && wasResize) h.fitTextBox(el);
              if (wasPatch) {
                try {
                  h.syncLeatherettePatchPlate();
                } catch (err) {
                  /* ignore */
                }
              }
              h.persistBoxProps(
                document.querySelector('.sancando-imprint-preview.has-logo') != null ||
                  !!(h.isHatsLeatherette && h.isHatsLeatherette()),
                document.querySelector('.sancando-imprint-text.has-text') != null
              );
            }
          };

          // Document capture survives Horizon gallery remorphs / new box nodes.
          document.addEventListener('pointerdown', onPointerDown, true);
          document.addEventListener('pointermove', onMove, true);
          document.addEventListener('pointerup', onUp, true);
          document.addEventListener('pointercancel', onUp, true);
          ['mousedown', 'click', 'touchstart'].forEach((type) => {
            document.addEventListener(
              type,
              (e) => {
                const t = e.target;
                if (!(t instanceof Element)) return;
                if (
                  t.closest(
                    '.sancando-imprint-text.has-text, .sancando-imprint-preview.has-logo, .sancando-imprint-preview.is-patch-frame, .sancando-box-handle, .sancando-rotate-handle'
                  )
                ) {
                  isolate(e);
                }
              },
              true
            );
          });
        }

        enableBoxInteract(el, kind) {
          if (!el || this.isMirrorBox(el) || el.dataset.interactBound === 'true') return;
          el.dataset.interactBound = 'true';
          // Document-level capture already handles drag/resize/rotate for
          // current and remorphed boxes. Skip per-node listeners.
          if (window.__sancandoBoxDragBound === 'true') return;
          const parent = () => el.offsetParent || el.parentElement;
          let drag = null;
          let rotate = null;

          const startDrag = (e, mode, dir) => {
            e.preventDefault();
            e.stopPropagation();
            const pr = parent().getBoundingClientRect();
            const br = el.getBoundingClientRect();
            drag = {
              mode: mode,
              dir: dir,
              px: e.clientX,
              py: e.clientY,
              left: br.left - pr.left,
              top: br.top - pr.top,
              w: br.width,
              h: br.height,
              pw: pr.width,
              ph: pr.height,
            };
            /* fix4: remember the pre-press state and start rect; a tap/click without movement must not count as 'moved' */
            drag.prevMoved = el.dataset.userMoved === '1';
            drag.b0 = [br.left, br.top, br.width, br.height];
            el.dataset.userMoved = '1';
            try {
              el.setPointerCapture(e.pointerId);
            } catch (err) {
              /* ignore */
            }
          };

          const isolate = (e) => {
            e.stopPropagation();
            if (e.cancelable && e.type !== 'pointermove') e.preventDefault();
          };
          const onPointerDown = (e) => {
            isolate(e);
            if (this.isPlaceMode()) return;
            if (e.target.closest('.sancando-rotate-handle')) return;
            if (e.target.classList.contains('sancando-box-handle')) {
              startDrag(e, 'resize', e.target.dataset.dir);
            } else {
              startDrag(e, 'move');
            }
          };
          el.addEventListener('pointerdown', onPointerDown, { capture: true });
          ['mousedown', 'click', 'touchstart'].forEach((type) => {
            el.addEventListener(type, isolate, { capture: true });
            el.querySelectorAll('.sancando-box-handle, .sancando-rotate-handle').forEach((h) => {
              h.addEventListener(type, isolate, { capture: true });
            });
          });
          el.querySelectorAll('.sancando-box-handle, .sancando-rotate-handle').forEach((h) => {
            h.addEventListener('pointerdown', isolate, { capture: true });
          });

          el.addEventListener('click', (e) => {
            isolate(e);
          });

          const rot = el.querySelector('.sancando-rotate-handle');
          if (rot) {
            rot.addEventListener('pointerdown', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const r = el.getBoundingClientRect();
              rotate = {
                x: e.clientX,
                y: e.clientY,
                cx: r.left + r.width / 2,
                cy: r.top + r.height / 2,
                rot: Number(el.dataset.rotation || 0),
                moved: false,
              };
              rotate.pointer = (Math.atan2(e.clientY - rotate.cy, e.clientX - rotate.cx) * 180) / Math.PI;
              try {
                rot.setPointerCapture(e.pointerId);
              } catch (err) {
                /* ignore */
              }
            });
            rot.addEventListener('pointermove', (e) => {
              if (!rotate) return;
              const dx = e.clientX - rotate.x;
              const dy = e.clientY - rotate.y;
              if (dx * dx + dy * dy > 16) rotate.moved = true;
              if (!rotate.moved) return;
              const ang = (Math.atan2(e.clientY - rotate.cy, e.clientX - rotate.cx) * 180) / Math.PI;
              this.setTextRotation(rotate.rot + (ang - rotate.pointer));
            });
            rot.addEventListener('pointerup', (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!rotate) return;
              if (!rotate.moved) {
                const cur = Number(el.dataset.rotation || 0);
                this.setTextRotation(cur === 90 ? 0 : 90);
              }
              rotate = null;
              this.persistBoxProps(
                document.querySelector('.sancando-imprint-preview.has-logo') != null,
                true
              );
            });
          }

          const onMove = (e) => {
            if (!drag) return;
            const dx = e.clientX - drag.px;
            const dy = e.clientY - drag.py;
            let left = drag.left;
            let top = drag.top;
            let w = drag.w;
            let ht = drag.h;
            if (drag.mode === 'move') {
              left += dx;
              top += dy;
            } else {
              if (drag.dir.indexOf('e') >= 0) w += dx;
              if (drag.dir.indexOf('s') >= 0) ht += dy;
              if (drag.dir.indexOf('w') >= 0) {
                left += dx;
                w -= dx;
              }
              if (drag.dir.indexOf('n') >= 0) {
                top += dy;
                ht -= dy;
              }
            }
            w = Math.max(24, Math.min(w, drag.pw));
            ht = Math.max(24, Math.min(ht, drag.ph));
            left = Math.max(0, Math.min(left, drag.pw - w));
            top = Math.max(0, Math.min(top, drag.ph - ht));
            this.writeBox(el, {
              top: this.pct((top / drag.ph) * 100),
              left: this.pct((left / drag.pw) * 100),
              width: this.pct((w / drag.pw) * 100),
              height: this.pct((ht / drag.ph) * 100),
            });
            if (kind === 'text' && drag.mode === 'resize') this.fitTextBox(el);
          };

          const onUp = () => {
            if (!drag) return;
            const wasResize = drag.mode === 'resize';
            const d0 = drag;
            drag = null;
            window.__sancandoSettleMoved(el, d0);
            if (kind === 'text' && wasResize) this.fitTextBox(el);
            this.persistBoxProps(
              document.querySelector('.sancando-imprint-preview.has-logo') != null,
              document.querySelector('.sancando-imprint-text.has-text') != null
            );
          };

          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', onUp);
        }


        productCacheKey() {
          return String(this.dataset.productId || '').trim() || 'default';
        }

        getLogoCache() {
          const store = (window.__sancandoLogoCache = window.__sancandoLogoCache || {});
          return store[this.productCacheKey()] || null;
        }

        saveLogoCache(partial) {
          const store = (window.__sancandoLogoCache = window.__sancandoLogoCache || {});
          const key = this.productCacheKey();
          const prev = store[key] || {};
          store[key] = Object.assign({}, prev, partial || {});
          return store[key];
        }

        clearLogoCache() {
          const store = (window.__sancandoLogoCache = window.__sancandoLogoCache || {});
          const key = this.productCacheKey();
          const prev = store[key];
          if (prev && prev.imprintLogoUrl) {
            try {
              URL.revokeObjectURL(prev.imprintLogoUrl);
            } catch (err) {
              /* ignore */
            }
          }
          delete store[key];
          if (prev && prev.formState) store[key] = { formState: prev.formState }; /* 2026-10-22: clearing the logo keeps reveal/text state */
          this.dropStoredLogo();
          this._imprintLogoUrl = '';
          this._imprintLogoKey = '';
          this._keyedPreviewFile = null;
          this._laserSilverPreviewFile = null;
          this._logoKeyed = false;
        }

        logoInput() {
          return this.querySelector('input[name="properties[Logo - Front]"]');
        }

        syncUploadChrome() {
          const input = this.logoInput();
          const label = this.querySelector('[data-sancando-upload-label]');
          const removeBtn = this.querySelector('[data-sancando-remove]');
          const has = this.hasCachedOrInputLogo();
          if (label) label.textContent = has ? 'Change design' : 'Upload your design';
          if (removeBtn) removeBtn.hidden = !(has || this._restoredPreviewOnly);
        }

        hideLogoPreviewImages() {
          document.querySelectorAll('.sancando-imprint-preview__logo').forEach((el) => {
            el.src = '';
            el.hidden = true;
          });
          document.querySelectorAll('.sancando-imprint-preview').forEach((box) => {
            box.classList.remove('has-logo', 'has-content', 'sancando-logo-keyed');
            box.setAttribute('aria-hidden', 'true');
          });
        }

        removeDesign() {
          const input = this.logoInput();
          if (!input) return;
          this._removing = true;
          this._userClearedLogo = true;
          this.clearLogoCache();
          this.clearStoredDesign();
          this.clearPreviewOnlyRestore();
          if (this._restoredBoxes) delete this._restoredBoxes.logo;
          this.primaryImprintBoxes().forEach((b) => { delete b.dataset.userMoved; });
          this._logoKeyed = false;
          this._keyedPreviewFile = null;
          this._laserSilverPreviewFile = null;
          input.value = '';
          const nameEl = input.dataset.filenameTarget
            ? document.getElementById(input.dataset.filenameTarget)
            : null;
          if (nameEl) nameEl.textContent = '';
          const errorEl = input.dataset.errorTarget
            ? document.getElementById(input.dataset.errorTarget)
            : null;
          if (errorEl) {
            errorEl.hidden = true;
            errorEl.textContent = '';
            errorEl.classList.remove('is-visible');
          }
          this.hideLogoPreviewImages();
          this.syncUploadChrome();
          this.syncImprintPreview();
          this.applyDecorationMedia();
        }

        bindUploadActions() {
          if (this.dataset.uploadActionsBound === 'true') return;
          this.dataset.uploadActionsBound = 'true';
          const input = this.logoInput();
          const removeBtn = this.querySelector('[data-sancando-remove]');
          if (removeBtn) {
            removeBtn.addEventListener('click', (event) => {
              event.preventDefault();
              this.removeDesign();
            });
          }
          const clearForRepick = () => {
            if (this._removing || !input) return;
            this._repicking = true;
            input.value = '';
          };
          if (input) {
            input.addEventListener('click', clearForRepick);
            const label = this.querySelector('[data-sancando-upload-label]');
            if (label) label.addEventListener('click', clearForRepick);
          }
          this.syncUploadChrome();
        }

        logoFileKey(file) {
          if (!file) return '';
          return [file.name, file.size, file.lastModified, file.type].join('|');
        }

        hasCachedOrInputLogo() {
          const logoInput = this.querySelector('input[name="properties[Logo - Front]"]');
          if (logoInput && logoInput.files && logoInput.files[0]) return true;
          const cache = this.getLogoCache();
          return !!(cache && cache.file);
        }

        /* 2026-10-22 (#167 only): reveal checkboxes + text/font survive section re-renders (kept in the per-product window cache).
           2026-10-24: + Notes ('Any other questions or ideas?') so a reload / re-render that restores the logo no longer drops the note. */
        formStateFields() {
          return Array.prototype.filter.call(
            this.querySelectorAll('input[type="checkbox"][data-reveal], input[name="properties[Add Text]"], [name="properties[Text - Front]"], select[name="properties[Text Font]"], textarea[name="properties[Notes]"]'),
            (el) => !!(el.name || el.id)
          );
        }

        saveFormState() {
          const state = {};
          this.formStateFields().forEach((el) => {
            const k = el.name || el.id;
            state[k] = el.type === 'checkbox' ? !!el.checked : String(el.value || '');
          });
          if (Object.keys(state).length) this.saveLogoCache({ formState: state });
        }

        restoreFormState() {
          const cache = this.getLogoCache();
          const state = cache && cache.formState;
          if (!state) return false;
          let changed = false;
          const fields = this.formStateFields();
          /* checkboxes first so revealed panels are enabled before values go back in */
          fields.filter((el) => el.type === 'checkbox').forEach((el) => {
            const k = el.name || el.id;
            if (k in state && el.checked !== !!state[k]) {
              el.checked = !!state[k];
              if (el.dataset.reveal) this.syncReveal(el);
              changed = true;
            }
          });
          fields.filter((el) => el.type !== 'checkbox').forEach((el) => {
            const k = el.name || el.id;
            if (k in state && String(el.value || '') !== state[k]) {
              el.value = state[k];
              if (el instanceof HTMLSelectElement) this.syncFontPreview(el);
              changed = true;
            }
          });
          return changed;
        }

        /* ===== 2026-10-22 logo-persist (#167 only): design survives a page reload via per-product sessionStorage =====
           Stored: original logo File as data URL (if <= LP_ORIG_MAX), else a downscaled preview (display only),
           user-moved logo/text boxes, text rotation, and the reveal/text/font formState. Every step try/catch'd. */
        designStoreKey() {
          const id = String(this.dataset.productId || '').trim();
          let handle = String(this.dataset.productHandle || '').trim();
          if (!handle) {
            const m = (window.location.pathname || '').match(/\/products\/([^/?#]+)/);
            handle = m ? decodeURIComponent(m[1]) : '';
          }
          return 'sancando:design:v1:' + (id || handle || 'default');
        }

        readStoredDesign() {
          try {
            const raw = window.sessionStorage.getItem(this.designStoreKey());
            return raw ? JSON.parse(raw) : null;
          } catch (err) {
            return null;
          }
        }

        clearStoredDesign() {
          clearTimeout(this._persistTimer);
          try { window.sessionStorage.removeItem(this.designStoreKey()); } catch (err) { /* ignore */ }
          this._persistedLogo = null;
        }

        dropStoredLogo() {
          this._persistedLogo = null;
          const rec = this.readStoredDesign();
          if (!rec || !rec.logo) return;
          delete rec.logo;
          if (rec.boxes) delete rec.boxes.logo;
          this.writeStoredDesign(rec);
        }

        dataUrlToFile(dataUrl, name, type, lastModified) {
          const comma = dataUrl.indexOf(',');
          const meta = dataUrl.slice(0, comma);
          const bin = atob(dataUrl.slice(comma + 1));
          const bytes = new Uint8Array(bin.length);
          for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
          const mime = type || (meta.match(/^data:([^;]+)/) || [])[1] || 'application/octet-stream';
          return new File([bytes], name || 'logo', { type: mime, lastModified: lastModified || Date.now() });
        }

        fileToDataUrl(blob) {
          return new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => resolve(String(fr.result || ''));
            fr.onerror = () => reject(fr.error || new Error('read failed'));
            fr.readAsDataURL(blob);
          });
        }

        async downscaleForStore(file) {
          if (!this.isRasterImage(file)) return '';
          const img = await this.loadImage(file);
          const max = 1000;
          const scale = Math.min(1, max / Math.max(img.naturalWidth || 1, img.naturalHeight || 1));
          const w = Math.max(1, Math.round((img.naturalWidth || 1) * scale));
          const h = Math.max(1, Math.round((img.naturalHeight || 1) * scale));
          const c = document.createElement('canvas');
          c.width = w;
          c.height = h;
          c.getContext('2d').drawImage(img, 0, 0, w, h);
          let url = c.toDataURL('image/png');
          if (url.length > 900000) url = c.toDataURL('image/webp', 0.85); /* keeps alpha where supported */
          if (url.length > 900000) url = '';
          return url;
        }

        /* Hydrate the window cache from sessionStorage (sync; before restoreFormState/syncReveal). */
        hydrateDesignFromSession() {
          const store = (window.__sancandoLogoCache = window.__sancandoLogoCache || {});
          const key = this.productCacheKey();
          if (store[key] && (store[key].file || store[key].formState)) return; /* in-page re-render: window cache wins */
          const rec = this.readStoredDesign();
          if (!rec) return;
          const part = {};
          if (rec.formState && typeof rec.formState === 'object') part.formState = rec.formState;
          const logo = rec.logo;
          if (logo && logo.data) {
            try {
              const f = this.dataUrlToFile(logo.data, logo.name, logo.type, logo.lastModified);
              if (logo.kind === 'original') {
                part.file = f;
                this._needsRekey = true;
                this._persistedLogo = { key: this.logoFileKey(f), logo: logo };
              } else {
                part.previewOnlyFile = f;
                this._restoredPreviewOnly = { name: logo.name || 'your logo' };
              }
            } catch (err) {
              /* corrupt entry → ignore logo */
            }
          } else if (logo && logo.kind === 'lost') {
            this._restoredPreviewOnly = { name: logo.name || 'your logo', noPreview: true };
          }
          this._restoredBoxes = rec.boxes || null;
          if (Object.keys(part).length) store[key] = Object.assign({}, store[key] || {}, part);
          if (this._restoredPreviewOnly) {
            const self = this;
            requestAnimationFrame(() => self.showPreviewOnlyNotice());
            this.bindPreviewOnlyGuard();
          }
        }

        showPreviewOnlyNotice() {
          if (!this._restoredPreviewOnly) return;
          const input = this.logoInput();
          const errorEl = input && input.dataset.errorTarget ? document.getElementById(input.dataset.errorTarget) : null;
          if (!errorEl) return;
          errorEl.hidden = false;
          errorEl.textContent =
            'Your design layout was restored, but "' + this._restoredPreviewOnly.name +
            '" was too large to keep after the page reload. Please choose the file again before adding to cart.';
          errorEl.classList.add('is-visible');
        }

        clearPreviewOnlyRestore() {
          if (!this._restoredPreviewOnly) return;
          this._restoredPreviewOnly = null;
          const cache = this.getLogoCache();
          if (cache) delete cache.previewOnlyFile;
        }

        /* Preview-only restore has no real file → block ATC until the customer re-selects it (never send a preview). */
        bindPreviewOnlyGuard() {
          if (window.__sancandoPreviewOnlyGuard === 'true') return;
          window.__sancandoPreviewOnlyGuard = 'true';
          const root = this;
          const blocked = () => {
            const h = document.querySelector('sancando-customization') || root;
            if (!h._restoredPreviewOnly) return false;
            const input = h.logoInput && h.logoInput();
            return !(input && input.files && input.files[0]);
          };
          const stop = (e) => {
            if (!blocked()) return;
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            const h = document.querySelector('sancando-customization') || root;
            h.showPreviewOnlyNotice();
            const input = h.logoInput && h.logoInput();
            if (input && typeof input.scrollIntoView === 'function') input.scrollIntoView({ block: 'center', behavior: 'smooth' });
          };
          document.addEventListener('click', (e) => {
            const t = e.target;
            if (!(t instanceof Element)) return;
            if (!t.closest('button[type="submit"], button[name="add"], [name="add"], .add-to-cart, [data-sancando-add-to-quote]')) return;
            if (!t.closest('form[action*="/cart/add"], product-form-component, .product-form, add-to-cart-component, [data-sancando-add-to-quote]')) return;
            stop(e);
          }, true);
          document.addEventListener('submit', (e) => {
            const form = e.target;
            if (!(form instanceof HTMLFormElement)) return;
            if (String(form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
            stop(e);
          }, true);
        }

        /* Restored boxes: put the customer's position/size back once per box element, before default layout. */
        applyRestoredBoxes() {
          const rb = this._restoredBoxes;
          if (!rb) return;
          const ok = (b) => b && ['top', 'left', 'width', 'height'].every((k) => typeof b[k] === 'string' && /^-?\d+(\.\d+)?%$/.test(b[k]));
          if (rb.logo && ok(rb.logo)) {
            this.primaryImprintBoxes().forEach((box) => {
              if (box.dataset.sancandoRestored || box.classList.contains('is-patch-frame') && !this.isHatsLeatherette()) return;
              box.dataset.sancandoRestored = '1';
              /* fix4: a stored box that matches the preset is not a user move (keeps Placement = preset label) */
              const pa = this.imprintArea(box);
              const n = (v) => this.numPct(v);
              const same = pa && ['top', 'left', 'width', 'height'].every((k) => Math.abs(n(pa[k]) - n(rb.logo[k])) < 0.5);
              if (same) return;
              this.writeBox(box, rb.logo);
              box.dataset.userMoved = '1';
            });
          }
          if (rb.text && ok(rb.text)) {
            this.primaryTextBoxes().forEach((box) => {
              if (box.dataset.sancandoRestored) return;
              box.dataset.sancandoRestored = '1';
              this.writeBox(box, rb.text);
              box.dataset.userMoved = '1';
            });
          }
          if (rb.textRotation != null && !this._restoredRotationDone) {
            this._restoredRotationDone = true;
            this.setTextRotation(rb.textRotation);
          }
        }

        /* Restored raster original → re-run the background key once (same as a fresh upload). */
        async rekeyRestoredLogo() {
          if (!this._needsRekey) return;
          this._needsRekey = false;
          const cache = this.getLogoCache();
          const file = cache && cache.file;
          if (!file || !this.isRasterImage(file) || this._logoKeyed || file.name === 'logo-transparent.png') return;
          try {
            const processed = await this.makeTransparentBackground(file);
            if (!processed) return;
            this._keyedPreviewFile = processed;
            this._logoKeyed = true;
            this._laserSilverPreviewFile = null;
            const isApparel =
              typeof this.isApparelProduct === 'function'
                ? this.isApparelProduct()
                : ((this.dataset.templateSuffix || '').toLowerCase() === 'apparel' ||
                   (this.dataset.productType || '').toLowerCase() === 'apparel');
            if (!isApparel && !this.isFullColorDecoration() && !this.isHatsProduct() && !this.isDtfDecoration()) {
              this._laserSilverPreviewFile = await this.toLaserSilverPlate(processed);
            }
            if (this._userClearedLogo) return;
            this.saveLogoCache({
              keyedPreviewFile: this._keyedPreviewFile,
              laserSilverPreviewFile: this._laserSilverPreviewFile || null,
              logoKeyed: true,
            });
            this.syncImprintPreview();
          } catch (err) {
            this._logoKeyed = false;
            this._keyedPreviewFile = null;
            this._laserSilverPreviewFile = null;
          }
        }

        /* fix2: while the product photo under a box is (re)loading, hide the box; show it on load (3 s safety). */
        holdBoxesUntilMediaLoaded(scope) {
          /* fix3: one hold per media element + photo src. Re-checks (resyncs, morph, observer) never re-hide or restart the
             clock; release re-queries the boxes (a morph may have replaced them) and is final for that src. Hard cap 3 s. */
          const boxSel = '.sancando-imprint-preview, .sancando-imprint-text';
          const boxes = (scope || document).querySelectorAll(boxSel);
          const seen = new Set();
          const showAll = (media) => {
            media.querySelectorAll(boxSel).forEach((b) => {
              if (b.dataset.sancandoHeld) { b.style.visibility = ''; delete b.dataset.sancandoHeld; }
            });
          };
          boxes.forEach((box) => {
            const media = box.closest('.product-media') || box.parentElement;
            if (!media || seen.has(media)) return;
            seen.add(media);
            const img = media.querySelector('img:not(.sancando-imprint-preview__logo)');
            if (!img) { showAll(media); return; }
            const src = img.currentSrc || img.getAttribute('src') || '';
            /* complete with no pixels = the photo already failed: nothing to wait for */
            const failed = img.complete && !img.naturalWidth && !!src;
            const ready = (img.complete && img.naturalWidth > 0) || failed;
            let hold = media._sancandoHold;
            if (ready || (hold && hold.src === src && hold.done)) {
              if (hold && hold.src === src) hold.done = true;
              showAll(media);
              return;
            }
            if (hold && hold.src === src) {
              /* same pending photo: keep the original clock; hide only boxes that arrived since, if time remains */
              if (Date.now() - hold.t0 >= 3000) { hold.done = true; showAll(media); return; }
              media.querySelectorAll(boxSel).forEach((b) => { b.style.visibility = 'hidden'; b.dataset.sancandoHeld = '1'; });
              return;
            }
            if (hold && hold.cleanup) hold.cleanup();
            hold = media._sancandoHold = { src: src, t0: Date.now(), done: false };
            media.querySelectorAll(boxSel).forEach((b) => { b.style.visibility = 'hidden'; b.dataset.sancandoHeld = '1'; });
            const release = () => {
              if (hold.done && !hold.timer) return;
              hold.done = true;
              hold.cleanup();
              showAll(media);
            };
            hold.cleanup = () => {
              clearTimeout(hold.timer);
              hold.timer = null;
              img.removeEventListener('load', release);
              img.removeEventListener('error', release);
            };
            img.addEventListener('load', release);
            img.addEventListener('error', release);
            hold.timer = setTimeout(release, 3000);
          });
        }

        bindMediaLoadWatch() {
          if (window.__sancandoMediaLoadWatch === 'true' || typeof MutationObserver === 'undefined') return;
          window.__sancandoMediaLoadWatch = 'true';
          const mo = new MutationObserver((muts) => {
            const h = document.querySelector('sancando-customization');
            if (!h || typeof h.holdBoxesUntilMediaLoaded !== 'function') return;
            const scopes = new Set();
            muts.forEach((m) => {
              const t = m.target instanceof Element ? m.target : null;
              if (!t) return;
              const media = t.closest('.product-media');
              if (media && media.querySelector('.sancando-imprint-preview, .sancando-imprint-text')) scopes.add(media);
              else if (m.type === 'childList' && t.querySelector && t.querySelector('.sancando-imprint-preview')) scopes.add(t);
            });
            scopes.forEach((sc) => { try { h.holdBoxesUntilMediaLoaded(sc); } catch (e) { /* ignore */ } });
          });
          mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
        }

        /* Swap <img> src without a blank frame: preload, then assign. */
        swapLogoSrc(el, url) {
          if (!el || !url) return;
          if (el.getAttribute('src') === url) return;
          const showing = el.getAttribute('src') && el.complete && el.naturalWidth > 0 && !el.hidden;
          if (!showing) {
            el.src = url;
            return;
          }
          el._sancandoWant = url;
          const pre = new Image();
          const done = () => {
            if (el._sancandoWant === url) el.src = url;
          };
          pre.onload = () => {
            if (typeof pre.decode === 'function') pre.decode().then(done, done);
            else done();
          };
          pre.onerror = done;
          pre.src = url;
        }

        /* Submission fallback: if the file input could not take the restored File, add it to the cart FormData. */
        ensureLogoOnFormData(body) {
          if (!body || typeof FormData === 'undefined' || !(body instanceof FormData)) return;
          if (body.get('properties[_addon]')) return;
          try {
            this.syncPlacementProperty();
            const pv = this.currentPlacementValue();
            if (pv && body.has('properties[Placement]')) body.set('properties[Placement]', pv);
          } catch (err) { /* ignore */ }
          const cur = body.get('properties[Logo - Front]');
          if (cur && typeof cur === 'object' && cur.size) return;
          const input = this.logoInput();
          if (!input || input.disabled) return;
          const cache = this.getLogoCache();
          if (!cache || !cache.file || this._userClearedLogo) return;
          try { body.delete('properties[Logo - Front]'); } catch (err) { /* ignore */ }
          body.append('properties[Logo - Front]', cache.file, cache.file.name);
        }

        persistDesignSoon() {
          clearTimeout(this._persistTimer);
          this._persistTimer = setTimeout(() => {
            this.persistDesignNow().catch(() => { /* never break the page */ });
          }, 400);
        }

        writeStoredDesign(rec) {
          const k = this.designStoreKey();
          const json = JSON.stringify(rec);
          try {
            window.sessionStorage.setItem(k, json);
            return true;
          } catch (err) {
            /* quota → evict other products' designs (oldest first), retry once */
            try {
              const others = [];
              for (let i = 0; i < window.sessionStorage.length; i++) {
                const kk = window.sessionStorage.key(i);
                if (kk && kk !== k && kk.indexOf('sancando:design:v1:') === 0) {
                  let t = 0;
                  try { t = JSON.parse(window.sessionStorage.getItem(kk)).savedAt || 0; } catch (e) { /* ignore */ }
                  others.push([t, kk]);
                }
              }
              others.sort((a, b) => a[0] - b[0]).forEach((o) => window.sessionStorage.removeItem(o[1]));
              if (others.length) {
                window.sessionStorage.setItem(k, json);
                return true;
              }
            } catch (e2) {
              /* fall through */
            }
            return false;
          }
        }

        /* fix2: synchronous flush on pagehide/beforeunload (uses the already-encoded logo; never awaits). */
        bindPersistFlush() {
          if (window.__sancandoPersistFlush === 'true') return;
          window.__sancandoPersistFlush = 'true';
          const flush = () => {
            try {
              const h = document.querySelector('sancando-customization');
              if (h && typeof h.persistDesignSync === 'function') h.persistDesignSync();
            } catch (err) { /* ignore */ }
          };
          window.addEventListener('pagehide', flush);
          window.addEventListener('beforeunload', flush);
          document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
        }

        persistDesignSync() {
          if (!window.sessionStorage) return;
          clearTimeout(this._persistTimer);
          const cache = this.getLogoCache() || {};
          const rec = this.buildDesignRec(cache);
          const file = !this._userClearedLogo && cache.file;
          if (file) {
            const pl = this._persistedLogo;
            if (pl && pl.key === this.logoFileKey(file) && pl.logo) rec.logo = pl.logo;
            else if (this._encodedNow && this._encodedNow.key === this.logoFileKey(file)) rec.logo = this._encodedNow.logo;
          } else if (cache.previewOnlyFile && this._restoredPreviewOnly) {
            const prev = this.readStoredDesign();
            if (prev && prev.logo) rec.logo = prev.logo;
          }
          if (!this.writeStoredDesign(rec) && rec.logo) {
            delete rec.logo;
            this.writeStoredDesign(rec);
          }
        }

        buildDesignRec(cache) {
          const rec = { v: 1, savedAt: Date.now() };
          const fs = {};
          this.formStateFields().forEach((el) => {
            fs[el.name || el.id] = el.type === 'checkbox' ? !!el.checked : String(el.value || '');
          });
          rec.formState = Object.keys(fs).length ? fs : cache.formState || undefined;
          const boxes = {};
          const lb = document.querySelector('.sancando-imprint-preview.has-logo:not(.sancando-imprint-preview--mirror)');
          const tb = document.querySelector('.sancando-imprint-text.has-text:not(.sancando-imprint-text--mirror)');
          if (lb && lb.dataset.userMoved) boxes.logo = this.readBox(lb);
          else if (this._restoredBoxes && this._restoredBoxes.logo && !lb) boxes.logo = this._restoredBoxes.logo;
          if (tb && tb.dataset.userMoved) boxes.text = this.readBox(tb);
          else if (this._restoredBoxes && this._restoredBoxes.text && !tb) boxes.text = this._restoredBoxes.text;
          if (tb && tb.dataset.rotation) boxes.textRotation = Number(tb.dataset.rotation) || 0;
          if (Object.keys(boxes).length) rec.boxes = boxes;
          return rec;
        }

        async persistDesignNow() {
          if (!window.sessionStorage) return;
          const cache = this.getLogoCache() || {};
          const rec = { v: 1, savedAt: Date.now() };
          const fs = {};
          this.formStateFields().forEach((el) => {
            fs[el.name || el.id] = el.type === 'checkbox' ? !!el.checked : String(el.value || '');
          });
          rec.formState = Object.keys(fs).length ? fs : cache.formState || undefined;
          const boxes = {};
          const lb = document.querySelector('.sancando-imprint-preview.has-logo:not(.sancando-imprint-preview--mirror)');
          const tb = document.querySelector('.sancando-imprint-text.has-text:not(.sancando-imprint-text--mirror)');
          if (lb && lb.dataset.userMoved) boxes.logo = this.readBox(lb);
          else if (this._restoredBoxes && this._restoredBoxes.logo && !lb) boxes.logo = this._restoredBoxes.logo;
          if (tb && tb.dataset.userMoved) boxes.text = this.readBox(tb);
          else if (this._restoredBoxes && this._restoredBoxes.text && !tb) boxes.text = this._restoredBoxes.text;
          if (tb && tb.dataset.rotation) boxes.textRotation = Number(tb.dataset.rotation) || 0;
          if (Object.keys(boxes).length) rec.boxes = boxes;

          const file = !this._userClearedLogo && cache.file;
          let lost = false;
          if (file) {
            const fk = this.logoFileKey(file);
            if (!this._persistedLogo || this._persistedLogo.key !== fk) {
              const LP_ORIG_MAX = 2 * 1024 * 1024; /* ~2.7M chars as base64; sessionStorage is ~5M chars/origin */
              let logo = null;
              if (file.size <= LP_ORIG_MAX) {
                try {
                  if (!this._encoding || this._encoding.key !== fk) {
                    this._encoding = { key: fk, p: this.fileToDataUrl(file) };
                  }
                  const data = await this._encoding.p;
                  logo = { kind: 'original', name: file.name, type: file.type, lastModified: file.lastModified, data: data };
                  this._encodedNow = { key: fk, logo: logo };
                } catch (err) { logo = null; }
                /* a newer file was picked while this one encoded → let that call win */
                const nowFile = (this.getLogoCache() || {}).file;
                if (!nowFile || this.logoFileKey(nowFile) !== fk) return;
              }
              this._persistedLogo = { key: fk, logo: logo, bigFile: file };
            }
            rec.logo = this._persistedLogo.logo || undefined;
          } else if (cache.previewOnlyFile && this._restoredPreviewOnly) {
            const prev = this.readStoredDesign();
            if (prev && prev.logo) rec.logo = prev.logo;
          }
          if (rec.logo && this.writeStoredDesign(rec)) return;
          if (!rec.logo && !file) {
            this.writeStoredDesign(rec);
            return;
          }
          /* Original too big (or quota): keep a downscaled preview for display; the file must be re-picked before ATC. */
          let preview = '';
          try {
            const src = this._keyedPreviewFile || file;
            if (src) preview = await this.downscaleForStore(src);
          } catch (err) { preview = ''; }
          if (preview) {
            rec.logo = { kind: 'preview', name: file ? file.name : (rec.logo && rec.logo.name) || 'logo', type: preview.slice(5, preview.indexOf(';')), data: preview };
            if (this._persistedLogo) this._persistedLogo.logo = rec.logo;
            if (this.writeStoredDesign(rec)) return;
          }
          lost = true;
          rec.logo = { kind: 'lost', name: file ? file.name : 'logo' };
          if (this._persistedLogo) this._persistedLogo.logo = rec.logo;
          this.writeStoredDesign(rec); /* state-only; ignore failure */
          return lost;
        }

        restoreLogoFromCache() {
          if (this._removing || this._userClearedLogo) return null;
          try { this.restoreFormState(); } catch (err) { /* ignore */ }
          const cache = this.getLogoCache();
          if (!cache || !cache.file) return null;
          const logoInput = this.querySelector('input[name="properties[Logo - Front]"]');
          if (logoInput && !(logoInput.files && logoInput.files[0])) {
            try {
              const dt = new DataTransfer();
              dt.items.add(cache.file);
              logoInput.files = dt.files;
            } catch (err) {
              /* overlay can still paint from cache if DataTransfer is blocked */
            }
            const nameEl = logoInput.dataset.filenameTarget
              ? document.getElementById(logoInput.dataset.filenameTarget)
              : null;
            if (nameEl && !nameEl.textContent) nameEl.textContent = cache.file.name;
          }
          if (cache.keyedPreviewFile) this._keyedPreviewFile = cache.keyedPreviewFile;
          if (cache.laserSilverPreviewFile) this._laserSilverPreviewFile = cache.laserSilverPreviewFile;
          if (cache.logoKeyed) this._logoKeyed = true;
          if (cache.imprintLogoUrl && !this._imprintLogoUrl) {
            this._imprintLogoUrl = cache.imprintLogoUrl;
            this._imprintLogoKey = cache.imprintLogoKey || '';
          }
          this.syncUploadChrome();
          return cache;
        }

        schedulePreviewResync(force) {
          const now = Date.now();
          /* Coalesce gallery morph spam — one pass now, one late if forced.
             Cap bursts so color thrash cannot freeze the main thread. */
          if (force) {
            this._resyncBurstAt = now;
            this._resyncBurst = 1;
          } else if (this._resyncBurstAt && now - this._resyncBurstAt < 1000) {
            this._resyncBurst = (this._resyncBurst || 0) + 1;
            if (this._resyncBurst > 6) return;
          } else {
            this._resyncBurstAt = now;
            this._resyncBurst = 1;
          }
          if (this._previewResyncTimer) clearTimeout(this._previewResyncTimer);
          const kick = () => {
            if (this._syncingPreview) {
              this._resyncAfterSync = true;
              return;
            }
            this._syncingPreview = true;
            try {
              this.restoreLogoFromCache();
              this.ensureApparelImprintBoxes();
              this.remountImprintsOnVisibleMedia();
              /* Jefe 2026-10-02 19:08 (#167 only): after a colour switch the re-rendered slide carries the Liquid default box
                 (26/30/40/38); re-apply the selected placement's box (it ends in syncImprintPreview) instead of resetting. */
              if (this._placementBoxOn) this.applyApparelPlacementBox();
              else this.syncImprintPreview();
              this.applyDecorationMedia();
              this.bindCustomerBoxes();
            } finally {
              this._syncingPreview = false;
              if (this._resyncAfterSync) {
                this._resyncAfterSync = false;
                this._previewResyncTimer = setTimeout(() => this.schedulePreviewResync(true), 120);
              }
            }
          };
          /* Debounce: wait a frame, then one kick. Force adds one late kick only. */
          this._previewResyncTimer = setTimeout(() => {
            kick();
            if (force) {
              clearTimeout(this._previewResyncLate1);
              this._previewResyncLate1 = setTimeout(kick, 320);
            }
          }, force ? 0 : 50);
        }

        remountImprintsOnVisibleMedia() {
          const isHidden = (el) => {
            if (!el) return true;
            if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return true;
            const slide = el.closest('slideshow-slide');
            if (slide && (slide.hasAttribute('hidden') || slide.getAttribute('aria-hidden') === 'true')) return true;
            return false;
          };
          const visibleParents = [];
          const pushParent = (parent) => {
            if (!parent || isHidden(parent)) return;
            if (visibleParents.indexOf(parent) !== -1) return;
            visibleParents.push(parent);
          };
          document
            .querySelectorAll(
              '.sancando-hats-gallery .product-media, .product-media--hats, .sancando-apparel-gallery slideshow-slide:not([hidden]) .product-media, .product-media--apparel, .sancando-drinkware-gallery slideshow-slide:not([hidden]) .product-media'
            )
            .forEach(pushParent);
          /* Also any visible product-media that already hosts an imprint. */
          document.querySelectorAll('.product-media').forEach((parent) => {
            if (parent.querySelector(':scope > .sancando-imprint-preview, :scope > .sancando-imprint-text')) {
              pushParent(parent);
            }
          });
          if (!visibleParents.length) return;

          /* Snapshot geometry from any existing primary box (may be on a now-hidden slide). */
          const donorLogo = document.querySelector(
            '.sancando-imprint-preview.has-logo:not(.sancando-imprint-preview--mirror), .sancando-imprint-preview.is-patch-frame:not(.sancando-imprint-preview--mirror)'
          );
          const donorText = document.querySelector(
            '.sancando-imprint-text.has-text:not(.sancando-imprint-text--mirror)'
          );
          const donorLogoBox = donorLogo ? this.readBox(donorLogo) : null;
          const donorTextBox = donorText ? this.readBox(donorText) : null;
          const donorMoved = !!(donorLogo && donorLogo.dataset.userMoved);

          visibleParents.forEach((parent) => {
            if (this.isHatsProduct()) {
              const box = this.ensureHatsImprintBox(parent);
              if (box && donorLogoBox && (!box.dataset.userMoved || donorMoved)) {
                if (donorMoved) box.dataset.userMoved = '1';
                this.writeBox(box, donorLogoBox);
              }
            } else if (
              (this.dataset.templateSuffix || '').toLowerCase() === 'apparel' ||
              (this.dataset.productType || '').toLowerCase() === 'apparel'
            ) {
              if (!parent.querySelector(':scope > .sancando-imprint-preview')) {
                this.ensureApparelImprintBoxes();
              }
              const box = parent.querySelector(':scope > .sancando-imprint-preview');
              if (box && donorLogoBox) {
                if (donorMoved) box.dataset.userMoved = '1';
                if (!box.dataset.userMoved || donorMoved) this.writeBox(box, donorLogoBox);
              }
            }
            if (donorTextBox) {
              let tbox = parent.querySelector(':scope > .sancando-imprint-text');
              if (!tbox && donorText) {
                /* leave text creation to syncImprintPreview / existing liquid */
              }
              tbox = parent.querySelector(':scope > .sancando-imprint-text');
              if (tbox) this.writeBox(tbox, donorTextBox);
            }
          });
        }

        bindSectionMorphResync() {
          if (window.__sancandoSectionMorphBound === 'true') return;
          window.__sancandoSectionMorphBound = 'true';
          const kick = () => {
            const h = document.querySelector('sancando-customization');
            if (!h || typeof h.schedulePreviewResync !== 'function') return;
            try {
              h.restoreLogoFromCache();
            } catch (err) {
              /* ignore */
            }
            h.schedulePreviewResync(true);
          };
          document.addEventListener('shopify:section:load', kick);
          document.addEventListener('shopify:section:reorder', kick);
          /* One coalesced kick — schedulePreviewResync already does a late pass. */
          document.addEventListener('variant:change', kick, true);
          this.bindApparelGalleryObserver();
        }

        /* Jefe 2026-10-02 21:37 (#167 only). Root cause of "box hidden / logo cleared after a colour switch that bumps a sold-out size":
           the resync after a swatch click is timer-based (click +0 / +280 ms, plus one late pass +320 ms), but on a sold-out bump the
           variant picker makes a SECOND fetch (in-stock size) before the gallery is re-rendered, so the new <media-gallery> often lands
           after the last timed pass (~0.8-1 s vs ~0.6 s). The new gallery has no imprint box and nothing re-mounts it, so the box and
           the logo drawn in it disappear (the file stays in the input / cache). Fix: on apparel PDPs, watch the main content and re-run
           the same forced resync whenever new gallery media is inserted, or a primary box loses its logo while a logo is uploaded.
           Hats and drinkware are not observed (their paths are unchanged). */
        bindApparelGalleryObserver() {
          if (window.__sancandoGalleryObsBound === 'true') return;
          if (!this.isApparelProduct() || this.isHatsProduct() || typeof MutationObserver === 'undefined') return;
          const root = document.querySelector('main') || document.body;
          if (!root) return;
          window.__sancandoGalleryObsBound = 'true';
          const ours = (n) => !!(n.closest && n.closest('.sancando-imprint-preview, .sancando-imprint-text'));
          let timer = null;
          let kicks = [];
          const kick = () => {
            timer = null;
            const h = document.querySelector('sancando-customization');
            if (!h || typeof h.schedulePreviewResync !== 'function') return;
            if (h._removing || h._userClearedLogo) return;
            const now = Date.now();
            kicks = kicks.filter((t) => now - t < 2000);
            if (kicks.length >= 8) return; /* loop guard */
            kicks.push(now);
            h.schedulePreviewResync(true);
          };
          const obs = new MutationObserver((records) => {
            let hit = false;
            for (const r of records) {
              if (r.type === 'childList') {
                for (const n of r.addedNodes) {
                  if (n.nodeType !== 1 || ours(n)) continue;
                  if ((n.matches && n.matches('media-gallery, slideshow-slide, .product-media')) || (n.querySelector && n.querySelector('.product-media'))) {
                    hit = true;
                    break;
                  }
                }
              } else if (r.type === 'attributes' && r.attributeName === 'class') {
                const el = r.target;
                const h = document.querySelector('sancando-customization');
                if (
                  el.classList && el.classList.contains('sancando-imprint-preview') && !el.classList.contains('sancando-imprint-preview--mirror') &&
                  !el.classList.contains('has-logo') && /(^|\s)has-logo(\s|$)/.test(r.oldValue || '') &&
                  h && !h._syncingPreview && !h._removing && !h._userClearedLogo &&
                  typeof h.hasCachedOrInputLogo === 'function' && h.hasCachedOrInputLogo()
                ) {
                  hit = true;
                }
              }
              if (hit) break;
            }
            if (hit && !timer) timer = setTimeout(kick, 30);
          });
          obs.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
        }

        bindVariantChangeResync() {
          if (window.__sancandoVariantResyncBound === 'true') return;
          window.__sancandoVariantResyncBound = 'true';
          const host = () => document.querySelector('sancando-customization');
          const readId = () => {
            const h = host();
            const formId = h && h.querySelector('input[name="properties[Decoration Method]"]')
              ? h.querySelector('input[name="properties[Decoration Method]"]').getAttribute('form')
              : '';
            const form = formId
              ? document.getElementById(formId)
              : document.querySelector('form[action*="/cart/add"]');
            const el = form && form.querySelector('input[name="id"]');
            return el ? String(el.value || '') : '';
          };
          let last = readId();
          const onMaybeVariant = () => {
            const h = host();
            if (!h || typeof h.schedulePreviewResync !== 'function') return;
            const next = readId();
            const changed = !!(next && next !== last);
            if (changed) last = next;
            /* Always force on picker interaction so burst-cap / late morph can't drop the logo. */
            h.schedulePreviewResync(true);
          };
          /* 2026-10-22 (#167 only): a colour switch onto a sold-out size makes variant-picker do a SECOND fetch (in-stock size,
             #sancandoPickInStock) and the variant id / gallery settle after the timed passes above (and the 'variant:change'
             listener never fires on Horizon). Watch the form's variant id for ~3 s after a picker click and force one resync per
             change, so the box + uploaded design/text are re-mounted after the bumped size lands. */
          let watchTimer = null;
          const watchLateVariant = () => {
            clearInterval(watchTimer);
            let seen = readId();
            const until = Date.now() + 3000;
            watchTimer = setInterval(() => {
              const id = readId();
              if (id && id !== seen) {
                seen = id;
                onMaybeVariant();
              }
              if (Date.now() > until) clearInterval(watchTimer);
            }, 150);
          };
          document.addEventListener(
            'change',
            (e) => {
              const t = e.target;
              if (!(t instanceof HTMLElement)) return;
              if (
                t.name === 'id' ||
                t.closest(
                  'variant-picker, .variant-picker, swatches-variant-picker-component, fieldset.swatches, .swatches'
                )
              ) {
                onMaybeVariant();
              }
            },
            true
          );
          document.addEventListener(
            'click',
            (e) => {
              const t = e.target;
              if (!(t instanceof Element)) return;
              if (
                t.closest(
                  'variant-picker, .variant-picker, swatches-variant-picker-component, .swatch, [data-option-value-id]'
                )
              ) {
                setTimeout(onMaybeVariant, 0);
                setTimeout(onMaybeVariant, 280);
                watchLateVariant();
              }
            },
            true
          );
        }

        syncImprintPreview() {
          this._syncingPreview = true;
          this.ensureApparelImprintBoxes();
          this.restoreLogoFromCache();
          try { this.applyRestoredBoxes(); } catch (err) { /* ignore */ }
          const logoBoxes = this.imprintBoxes();
          const textBoxes = this.textBoxes();
          const hints = document.querySelectorAll('.sancando-placeholder-hint');
          const logoInput = this.querySelector('input[name="properties[Logo - Front]"]');
          const addText = this.querySelector('input[name="properties[Add Text]"]');
          const textInput = this.querySelector('[name="properties[Text - Front]"]');
          const fontSelect = this.querySelector('select[name="properties[Text Font]"]');
          const cache = this.getLogoCache();
          let file = logoInput && logoInput.files && logoInput.files[0];
          if (!file && cache && cache.file) file = cache.file;
          /* logo-persist: original was too big for sessionStorage → show the downscaled preview only (not submitted). */
          if (!file && cache && cache.previewOnlyFile && !this._userClearedLogo) file = cache.previewOnlyFile;
          if (cache && cache.keyedPreviewFile && !this._keyedPreviewFile) {
            this._keyedPreviewFile = cache.keyedPreviewFile;
            this._logoKeyed = true;
          }
          if (cache && cache.laserSilverPreviewFile && !this._laserSilverPreviewFile) {
            this._laserSilverPreviewFile = cache.laserSilverPreviewFile;
          }
          const showLogo = this.canPreviewFile(file) || this.canPreviewFile(this._keyedPreviewFile);
          const textOn = !!(addText && addText.checked && textInput && !textInput.disabled);
          const rawText = textOn ? String(textInput.value || '') : '';
          const showText = rawText.trim().length > 0;
          const font = (fontSelect && fontSelect.value) || 'Bree Serif';
          const family = '"' + font + '", sans-serif';
          /* Leatherette patch frame is a customize session even before logo upload. */
          const customizing = showLogo || showText || this.isHatsLeatherette();

          document.documentElement.dataset.sancandoCustomizing = customizing ? '1' : '0';
          document.documentElement.dataset.sancandoGlassware = this.isGlasswareProduct() ? '1' : '0';
          /* audit-fix 2026-10-27 #8: leatherette/cork koozies + beverage holders laser-engrave dark -> black ink preview. */
          document.documentElement.dataset.sancandoInk = this.sancandoLaserInk();
          if (!this._inkBound) {
            this._inkBound = true;
            const reInk = () => setTimeout(() => {
              document.documentElement.dataset.sancandoInk = this.sancandoLaserInk();
            }, 80);
            document.addEventListener('variant:update', reInk);
            document.addEventListener('change', reInk);
          }
          this.lockSlideshow(customizing);
          hints.forEach((hint) => hint.classList.toggle('is-hidden', customizing));

          if (showLogo) {
            const isApparelPrev =
              typeof this.isApparelProduct === 'function'
                ? this.isApparelProduct()
                : ((this.dataset.templateSuffix || '').toLowerCase() === 'apparel' ||
                   (this.dataset.productType || '').toLowerCase() === 'apparel');
            /* Apparel: always full-color keyed preview (bg stripped only). */
            const useLaserPlate =
              !isApparelPrev &&
              !this.isHatsProduct() &&
              !!this._logoKeyed &&
              !this.isDtfDecoration() &&
              !this.isFullColorDecoration();
            let previewFile = this._keyedPreviewFile || file;
            if (useLaserPlate && this._laserSilverPreviewFile) {
              previewFile = this._laserSilverPreviewFile;
            } else if (useLaserPlate && this._keyedPreviewFile && !this._laserSilverBuilding) {
              this._laserSilverBuilding = true;
              const keyed = this._keyedPreviewFile;
              this.toLaserSilverPlate(keyed)
                .then((plate) => {
                  this._laserSilverBuilding = false;
                  if (!plate) return;
                  this._laserSilverPreviewFile = plate;
                  this.saveLogoCache({ laserSilverPreviewFile: plate });
                  this._imprintLogoKey = '';
                  this.syncImprintPreview();
                })
                .catch(() => {
                  this._laserSilverBuilding = false;
                });
            }
            const decoTag = useLaserPlate ? 'laser' : 'uv';
            const key = this.logoFileKey(previewFile) + '|' + decoTag;
            if (!this._imprintLogoUrl || this._imprintLogoKey !== key) {
              if (this._imprintLogoUrl) {
                /* logo-persist polish: keep the old blob alive until the new image has loaded (no blank box). */
                const old = this._imprintLogoUrl;
                setTimeout(() => {
                  try {
                    URL.revokeObjectURL(old);
                  } catch (err) {
                    /* ignore */
                  }
                }, 3000);
              }
              this._imprintLogoUrl = URL.createObjectURL(previewFile);
              this._imprintLogoKey = key;
              this.saveLogoCache({
                imprintLogoUrl: this._imprintLogoUrl,
                imprintLogoKey: key,
              });
            }
          } else if (this._imprintLogoUrl && !this.hasCachedOrInputLogo()) {
            try {
              URL.revokeObjectURL(this._imprintLogoUrl);
            } catch (err) {
              /* ignore */
            }
            this._imprintLogoUrl = '';
            this._imprintLogoKey = '';
          }

          this.applyDefaultLayout(showLogo, showText);
          /* After layout so hats leatherette full-cap starter wins over imprint ceiling. */
          this.syncLeatherettePatchPlate();

          logoBoxes.forEach((box) => {
            const logoEl = box.querySelector('.sancando-imprint-preview__logo');
            if (logoEl) {
              if (showLogo) {
                this.swapLogoSrc(logoEl, this._imprintLogoUrl);
                logoEl.hidden = false;
              } else {
                logoEl.removeAttribute('src');
                logoEl.hidden = true;
              }
            }
            box.classList.toggle('has-logo', showLogo);
            box.classList.toggle('has-content', showLogo);
            const patchOn = box.classList.contains('is-patch-frame');
            box.setAttribute('aria-hidden', (showLogo || patchOn) ? 'false' : 'true');
            /* Keyed + laser silver plate → Polar #b1b1b1 (same as .sancando-imprint-text__value). */
            const keyedClass =
              !!(showLogo && this._logoKeyed) &&
              !(typeof this.isApparelProduct === 'function' && this.isApparelProduct());
            box.classList.toggle('sancando-logo-keyed', keyedClass);
          });

          textBoxes.forEach((box) => {
            const textEl = box.querySelector('.sancando-imprint-text__value');
            if (textEl) {
              if (showText) {
                textEl.textContent = rawText;
                textEl.style.fontFamily = family;
              } else {
                textEl.textContent = '';
              }
            }
            box.classList.toggle('has-text', showText);
            box.setAttribute('aria-hidden', showText ? 'false' : 'true');
            if (showText && !box.dataset.rotation) this.setTextRotation(0);
            if (showText) {
              this.fitTextBox(box);
              requestAnimationFrame(() => this.fitTextBox(box));
            }
          });

          const sampleOn = !customizing && this.isSamplePreview();
          if (sampleOn) {
            logoBoxes.forEach((box) => {
              const logoEl = box.querySelector('.sancando-imprint-preview__logo');
              const src = box.getAttribute('data-sample-src') || '';
              if (!logoEl || !src) return;
              logoEl.src = src;
              logoEl.hidden = false;
              box.classList.add('has-logo', 'sancando-imprint-preview--sample');
              if (!box.dataset.userMoved) this.writeBox(box, this.imprintArea(box));
            });
            hints.forEach((hint) => hint.classList.add('is-hidden'));
          }

          this.persistBoxProps(showLogo, showText);
          try { this.holdBoxesUntilMediaLoaded(); this.bindMediaLoadWatch(); } catch (err) { /* ignore */ }
          if (!customizing) this._viewingSetPhoto = false;
          this.ensureGiftSetCaveat();
          this.ensureSetViewToggle();
          this.applyDecorationMedia();
          this.syncGiftSetChrome(customizing, this.getMediaMapEntry());
          this.bindCustomerBoxes();
          requestAnimationFrame(() => {
            this._syncingPreview = false;
            if (this._resyncAfterSync) {
              this._resyncAfterSync = false;
              this.schedulePreviewResync();
            }
          });
        }


        /* ---- Quote mockup capture: product + logo/text → properties[Mockup] ---- */
        mockupInput() {
          return (
            this.querySelector('input[data-sancando-mockup]') ||
            document.querySelector('input[name="properties[Mockup]"][data-sancando-mockup]') ||
            document.querySelector('input[name="properties[Mockup]"]')
          );
        }

        findMockupCaptureParent() {
          /* Site-wide: hats, apparel, drinkware, journals — any visible product media
             that hosts the imprint overlay. */
          const prefer = document.querySelector(
            '.sancando-imprint-preview.has-logo:not(.sancando-imprint-preview--mirror), .sancando-imprint-text.has-text:not(.sancando-imprint-text--mirror)'
          );
          if (prefer) {
            return (
              prefer.closest(
                '.product-media, .product-media--hats, .product-media--drinkware, .product-media--apparel, .product-media-container, slideshow-slide'
              ) || prefer.parentElement
            );
          }
          /* Hats: prefer hat_front slide even if imprint not yet classed */
          const slides = document.querySelectorAll(
            '.sancando-hats-gallery slideshow-slide, .sancando-apparel-gallery slideshow-slide, .sancando-drinkware-gallery slideshow-slide, .product-media-gallery slideshow-slide, slideshow-slide'
          );
          let front = null;
          slides.forEach((slide) => {
            if (front) return;
            if (slide.hasAttribute('hidden') || slide.getAttribute('aria-hidden') === 'true') return;
            const img = slide.querySelector('img.product-media__image, img');
            const alt = (img && img.getAttribute('alt')) || '';
            if (/hat_front|\|\s*Front\s*\|/i.test(alt)) front = slide;
          });
          if (front) {
            return (
              front.querySelector('.product-media, .product-media--hats, .product-media--apparel, .product-media--drinkware') ||
              front
            );
          }
          return document.querySelector(
            [
              '.sancando-hats-gallery slideshow-slide:not([hidden]) .product-media',
              '.sancando-apparel-gallery slideshow-slide:not([hidden]) .product-media',
              '.sancando-drinkware-gallery slideshow-slide:not([hidden]) .product-media',
              '.product-media-gallery slideshow-slide:not([hidden]) .product-media',
              '.product-media--hats',
              '.product-media--apparel',
              '.product-media--drinkware',
              '.product-media-container .product-media',
            ].join(', ')
          );
        }

        findMockupProductImage(parent) {
          if (!parent) return null;
          const imgs = Array.from(
            parent.querySelectorAll('img.product-media__image, img')
          ).filter((img) => {
            if (!img || img.tagName !== 'IMG') return false;
            if (img.classList.contains('sancando-imprint-preview__logo')) return false;
            if (img.classList.contains('sancando-placeholder-hint__img')) return false;
            if (img.closest('.sancando-imprint-preview, .sancando-imprint-text, .sancando-placeholder-hint, .sancando-leatherette-plate')) {
              return false;
            }
            return true;
          });
          return imgs[0] || null;
        }

        loadImageCors(src) {
          return new Promise((resolve, reject) => {
            if (!src) {
              reject(new Error('no src'));
              return;
            }
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error('image load failed: ' + String(src).slice(0, 120)));
            /* Bust CDN cache params that sometimes omit CORS headers on reused decoded bitmaps */
            try {
              const u = new URL(src, window.location.href);
              if (!u.searchParams.has('sancando_cors')) {
                u.searchParams.set('sancando_cors', '1');
              }
              img.src = u.toString();
            } catch (err) {
              img.src = src;
            }
          });
        }

        drawObjectFitContain(ctx, img, x, y, w, h) {
          const iw = img.naturalWidth || img.width;
          const ih = img.naturalHeight || img.height;
          if (!iw || !ih || w <= 0 || h <= 0) return;
          const scale = Math.min(w / iw, h / ih);
          const dw = iw * scale;
          const dh = ih * scale;
          const dx = x + (w - dw) / 2;
          const dy = y + (h - dh) / 2;
          ctx.drawImage(img, dx, dy, dw, dh);
        }

        async captureMockupBlob() {
          const parent = this.findMockupCaptureParent();
          if (!parent) {
            console.warn('[sancando] mockup: no product media parent');
            return null;
          }
          const productImg = this.findMockupProductImage(parent);
          if (!productImg) {
            console.warn('[sancando] mockup: no product image');
            return null;
          }
          const src =
            productImg.currentSrc ||
            productImg.getAttribute('src') ||
            (productImg.srcset && String(productImg.srcset).split(',')[0].trim().split(/\s+/)[0]) ||
            '';
          if (!src) return null;

          let baseImg;
          try {
            baseImg = await this.loadImageCors(src);
          } catch (err) {
            console.warn('[sancando] mockup: CORS product image failed, trying without reload', err);
            try {
              /* Last resort: draw from DOM image (may taint if cross-origin without CORS) */
              baseImg = productImg;
              if (!baseImg.complete || !(baseImg.naturalWidth || baseImg.width)) return null;
            } catch (err2) {
              return null;
            }
          }

          const natW = baseImg.naturalWidth || baseImg.width || 1200;
          const natH = baseImg.naturalHeight || baseImg.height || 1200;
          if (!natW || !natH) return null;

          const maxW = 1200;
          const scale = Math.min(1, maxW / natW);
          const canvasW = Math.max(1, Math.round(natW * scale));
          const canvasH = Math.max(1, Math.round(natH * scale));
          const canvas = document.createElement('canvas');
          canvas.width = canvasW;
          canvas.height = canvasH;
          const ctx = canvas.getContext('2d');
          if (!ctx) return null;

          try {
            ctx.drawImage(baseImg, 0, 0, canvasW, canvasH);
          } catch (err) {
            console.warn('[sancando] mockup: tainted product draw', err);
            return null;
          }

          const logoBoxes = Array.from(
            parent.querySelectorAll(
              '.sancando-imprint-preview.has-logo:not(.sancando-imprint-preview--mirror)'
            )
          );
          const textBoxes = Array.from(
            parent.querySelectorAll(
              '.sancando-imprint-text.has-text:not(.sancando-imprint-text--mirror)'
            )
          );

          /* If parent had no boxes (e.g. wrong parent), fall back to page-level primary boxes */
          const logos =
            logoBoxes.length > 0
              ? logoBoxes
              : Array.from(
                  document.querySelectorAll(
                    '.sancando-imprint-preview.has-logo:not(.sancando-imprint-preview--mirror)'
                  )
                );
          const texts =
            textBoxes.length > 0
              ? textBoxes
              : Array.from(
                  document.querySelectorAll(
                    '.sancando-imprint-text.has-text:not(.sancando-imprint-text--mirror)'
                  )
                );

          for (const box of logos) {
            const logoEl = box.querySelector('.sancando-imprint-preview__logo');
            const logoSrc = logoEl && (logoEl.currentSrc || logoEl.getAttribute('src'));
            if (!logoSrc || logoEl.hidden) continue;
            const boxPct = this.readBox(box);
            const left = (this.numPct(boxPct.left) / 100) * canvasW;
            const top = (this.numPct(boxPct.top) / 100) * canvasH;
            const width = (this.numPct(boxPct.width) / 100) * canvasW;
            const height = (this.numPct(boxPct.height) / 100) * canvasH;
            /* Match CSS padding: 4% of box on .sancando-imprint-preview__inner */
            const padX = width * 0.04;
            const padY = height * 0.04;
            let logoImg;
            try {
              if (logoSrc.indexOf('blob:') === 0 || logoSrc.indexOf('data:') === 0) {
                logoImg = await new Promise((resolve, reject) => {
                  const im = new Image();
                  im.onload = () => resolve(im);
                  im.onerror = reject;
                  im.src = logoSrc;
                });
              } else {
                logoImg = await this.loadImageCors(logoSrc);
              }
            } catch (err) {
              console.warn('[sancando] mockup: logo draw skipped', err);
              continue;
            }
            try {
              this.drawObjectFitContain(ctx, logoImg, left + padX, top + padY, width - padX * 2, height - padY * 2);
            } catch (err) {
              console.warn('[sancando] mockup: logo draw failed', err);
            }
          }

          for (const box of texts) {
            const textEl = box.querySelector('.sancando-imprint-text__value');
            const raw = textEl && String(textEl.textContent || '').trim();
            if (!raw) continue;
            const boxPct = this.readBox(box);
            const left = (this.numPct(boxPct.left) / 100) * canvasW;
            const top = (this.numPct(boxPct.top) / 100) * canvasH;
            const width = (this.numPct(boxPct.width) / 100) * canvasW;
            const height = (this.numPct(boxPct.height) / 100) * canvasH;
            const rot = parseFloat(box.dataset.rotation || '0') || 0;
            const family = (textEl.style.fontFamily || getComputedStyle(textEl).fontFamily || 'sans-serif').trim();
            const color = getComputedStyle(textEl).color || '#b1b1b1';
            /* Approximate fit: start from box height fraction, shrink to fit width */
            let fontPx = Math.max(10, Math.min(height * 0.5, width * 0.35));
            ctx.save();
            try {
              const cx = left + width / 2;
              const cy = top + height / 2;
              ctx.translate(cx, cy);
              if (rot) ctx.rotate((rot * Math.PI) / 180);
              ctx.fillStyle = color;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.shadowColor = 'rgba(0,0,0,0.35)';
              ctx.shadowBlur = 2;
              ctx.shadowOffsetY = 1;
              const lines = raw.split(/\n/);
              const measure = (px) => {
                ctx.font = '600 ' + px + 'px ' + family;
                let maxLine = 0;
                lines.forEach((ln) => {
                  maxLine = Math.max(maxLine, ctx.measureText(ln).width);
                });
                const lineH = px * 1.15;
                return { maxLine, totalH: lineH * lines.length };
              };
              for (let i = 0; i < 24; i++) {
                const m = measure(fontPx);
                if (m.maxLine <= width * 0.84 && m.totalH <= height * 0.84) break;
                fontPx = Math.max(8, fontPx * 0.9);
              }
              ctx.font = '600 ' + fontPx + 'px ' + family;
              const lineH = fontPx * 1.15;
              const startY = -((lines.length - 1) * lineH) / 2;
              lines.forEach((ln, i) => {
                ctx.fillText(ln, 0, startY + i * lineH);
              });
            } catch (err) {
              console.warn('[sancando] mockup: text draw failed', err);
            }
            ctx.restore();
          }

          if (logos.length === 0 && texts.length === 0) {
            console.warn('[sancando] mockup: no logo/text overlays — skipping bare product');
            return null;
          }

          try {
            const blob = await new Promise((resolve) =>
              canvas.toBlob((b) => resolve(b), 'image/jpeg', 0.88)
            );
            return blob || null;
          } catch (err) {
            console.warn('[sancando] mockup: toBlob failed (tainted?)', err);
            return null;
          }
        }

        async attachMockupFile(blob) {
          if (!blob) return false;
          const input = this.mockupInput();
          const file = new File([blob], 'custom-mockup.jpg', { type: blob.type || 'image/jpeg' });
          if (input && typeof DataTransfer !== 'undefined') {
            try {
              const dt = new DataTransfer();
              dt.items.add(file);
              input.files = dt.files;
            } catch (err) {
              console.warn('[sancando] mockup: DataTransfer set failed', err);
            }
          }
          this._mockupFile = file;
          this._mockupBlob = blob;
          return true;
        }

        formDataLooksLikeProductAdd(body) {
          if (!body || typeof FormData === 'undefined' || !(body instanceof FormData)) return false;
          if (body.get('properties[_addon]')) return false;
          /* Site-wide quote lines: any product add with decoration/logo/text */
          if (
            body.get('properties[Decoration Method]') ||
            body.get('properties[Logo - Front]') ||
            body.get('properties[Text - Front]') ||
            body.get('properties[Add Text]') ||
            body.get('properties[Patch Color]') ||
            body.get('properties[Patch Shape]')
          ) {
            return true;
          }
          /* Fallback: main product id present + customization root on page */
          if (body.get('id') && document.querySelector('sancando-customization')) {
            return true;
          }
          return false;
        }

        async ensureMockupOnFormData(body) {
          if (!this.formDataLooksLikeProductAdd(body)) return;
          try { this.ensureLogoOnFormData(body); } catch (err) { /* ignore */ }
          try {
            let file = this._mockupFile;
            const input = this.mockupInput();
            if ((!file || !file.size) && input && input.files && input.files[0]) {
              file = input.files[0];
            }
            if (!file || !file.size) {
              const blob = await this.captureMockupBlob();
              if (blob) {
                await this.attachMockupFile(blob);
                file = this._mockupFile;
              }
            }
            if (!file || !file.size) return;
            try {
              body.delete('properties[Mockup]');
            } catch (err) {
              /* ignore */
            }
            /* Product+logo composite for quote line thumb. Liquid only uses CDN URLs
               (never bare filenames) so the drawer cannot blank again. */
            body.append('properties[Mockup]', file, 'product-logo-mockup.jpg');
          } catch (err) {
            console.warn('[sancando] mockup: ensure on FormData failed', err);
          }
        }

        bindMockupCapture() {
          if (window.__sancandoMockupCaptureBound === 'true') return;
          window.__sancandoMockupCaptureBound = 'true';
          const root = this;
          const cartAddRe = /\/cart\/add(\.js)?(\/|$|\?)/i;
          const origFetch = window.fetch.bind(window);

          /* Warm mockup on ATC click so FormData(form) may already include it. */
          document.addEventListener(
            'click',
            (e) => {
              const t = e.target;
              if (!(t instanceof Element)) return;
              if (
                !t.closest(
                  'button[type="submit"], button[name="add"], [name="add"], .add-to-cart, .product-form-buttons, .buy-buttons-block, add-to-cart-component, [data-sancando-add-to-quote]'
                )
              ) {
                return;
              }
              if (
                !document.querySelector(
                  '.sancando-imprint-preview.has-logo, .sancando-imprint-text.has-text'
                )
              ) {
                return;
              }
              root._mockupWarmPromise = (async () => {
                try {
                  const blob = await root.captureMockupBlob();
                  if (blob) await root.attachMockupFile(blob);
                } catch (err) {
                  console.warn('[sancando] mockup warm failed', err);
                }
              })();
            },
            true
          );

          window.fetch = async (input, init) => {
            const url = typeof input === 'string' ? input : (input && input.url) || '';
            if (cartAddRe.test(url) && init && init.body) {
              try {
                if (root._mockupWarmPromise) {
                  try {
                    await root._mockupWarmPromise;
                  } catch (err) {
                    /* ignore */
                  }
                }
                if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
                  await root.ensureMockupOnFormData(init.body);
                }
              } catch (err) {
                console.warn('[sancando] mockup fetch hook failed', err);
              }
            }
            return origFetch(input, init);
          };

          document.addEventListener(
            'submit',
            (event) => {
              const form = event.target;
              if (!(form instanceof HTMLFormElement)) return;
              const action = String(form.getAttribute('action') || form.action || '');
              if (action.indexOf('/cart/add') === -1) return;
              if (
                !document.querySelector(
                  '.sancando-imprint-preview.has-logo, .sancando-imprint-text.has-text'
                )
              ) {
                return;
              }
              /* Sync warm into file input before Horizon builds FormData / navigates. */
              if (root._mockupWarmPromise) {
                /* cannot await in sync submit; fetch path covers Ajax ATC */
              }
            },
            true
          );
        }

        loadImage(file) {
          return new Promise((resolve, reject) => {
            const url = URL.createObjectURL(file);
            const img = new Image();
            img.onload = () => {
              URL.revokeObjectURL(url);
              resolve(img);
            };
            img.onerror = () => {
              URL.revokeObjectURL(url);
              reject(new Error('image load failed'));
            };
            img.src = url;
          });
        }

        async makeTransparentBackground(file) {
          const img = await this.loadImage(file);
          const maxDim = 2500;
          let w = img.naturalWidth || img.width;
          let h = img.naturalHeight || img.height;
          if (!w || !h) return null;
          const scale = Math.min(1, maxDim / Math.max(w, h));
          w = Math.max(1, Math.round(w * scale));
          h = Math.max(1, Math.round(h * scale));

          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          if (!ctx) return null;
          ctx.drawImage(img, 0, 0, w, h);
          const imageData = ctx.getImageData(0, 0, w, h);
          const data = imageData.data;

          const lumaAt = (i) => 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
          const WHITE_HARD = 232;
          const WHITE_SOFT = 248;
          const n = w * h;
          const labels = new Int32Array(n);
          const areas = [0];
          const edgeTouch = [false];
          let lab = 0;

          const neighbors = (idx, fn) => {
            const x = idx % w;
            const y = (idx - x) / w;
            if (x + 1 < w) fn(idx + 1);
            if (x > 0) fn(idx - 1);
            if (y + 1 < h) fn(idx + w);
            if (y > 0) fn(idx - w);
          };

          /* 4-connected near-white components. Transparent (alpha < 8) ignored.
             Key a component if it touches the image edge (background flood)
             or is a large enclosed plate (>= 1%). (2026-10-24: holes are keyed too — see below.)
             No corner-color pass — black / red / non-near-white never keyed. */
          for (let idx = 0; idx < n; idx++) {
            const i = idx * 4;
            if (labels[idx]) continue;
            if (data[i + 3] < 8 || lumaAt(i) < WHITE_HARD) continue;
            lab += 1;
            areas.push(0);
            edgeTouch.push(false);
            const queue = [idx];
            labels[idx] = lab;
            let qi = 0;
            while (qi < queue.length) {
              const cidx = queue[qi++];
              const cx = cidx % w;
              const cy = (cidx - cx) / w;
              areas[lab] += 1;
              if (cx === 0 || cy === 0 || cx === w - 1 || cy === h - 1) edgeTouch[lab] = true;
              neighbors(cidx, (nidx) => {
                if (labels[nidx]) return;
                const ni = nidx * 4;
                if (data[ni + 3] < 8 || lumaAt(ni) < WHITE_HARD) {
                  labels[nidx] = -1;
                  return;
                }
                labels[nidx] = lab;
                queue.push(nidx);
              });
            }
          }

          const minPlate = n * 0.01;
          for (let idx = 0; idx < n; idx++) {
            const id = labels[idx];
            if (id <= 0) continue;
            /* 2026-10-24 (#167): per-pixel key — enclosed near-white counters (R, B, O, A...) are see-through too,
               otherwise the laser plate paints them solid silver. No enclosure / hole-fill logic. */
            const i = idx * 4;
            const yLuma = lumaAt(i);
            if (yLuma >= WHITE_SOFT) {
              data[i + 3] = 0;
            } else {
              const t = (WHITE_SOFT - yLuma) / (WHITE_SOFT - WHITE_HARD);
              data[i + 3] = Math.round(data[i + 3] * t);
            }
          }

          let opaque = 0;
          for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] > 20) opaque += 1;
          }
          if (opaque < n * 0.05) return null;

          ctx.putImageData(imageData, 0, 0);
          const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
          if (!blob) return null;
          return new File([blob], 'logo-transparent.png', { type: 'image/png' });
        }

        /* Preview-only laser plate. Hard alpha + Polar silver RGB so CSS
           contrast(0)+brightness cannot turn a soft fringe into a gray lap.
           Cart/input still holds the original upload; keyed color PNG is
           kept on _keyedPreviewFile for UV. */
        async toLaserSilverPlate(file) {
          if (!file) return null;
          const img = await this.loadImage(file);
          const w = img.naturalWidth || img.width;
          const h = img.naturalHeight || img.height;
          if (!w || !h) return null;
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          if (!ctx) return null;
          ctx.drawImage(img, 0, 0, w, h);
          const imageData = ctx.getImageData(0, 0, w, h);
          const data = imageData.data;
          const ALPHA_CUT = 140;
          const SR = 177;
          const SG = 177;
          const SB = 177;
          for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] < ALPHA_CUT) {
              data[i] = 0;
              data[i + 1] = 0;
              data[i + 2] = 0;
              data[i + 3] = 0;
            } else {
              data[i] = SR;
              data[i + 1] = SG;
              data[i + 2] = SB;
              data[i + 3] = 255;
            }
          }
          ctx.putImageData(imageData, 0, 0);
          const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
          if (!blob) return null;
          return new File([blob], 'logo-laser-silver.png', { type: 'image/png' });
        }
      }
    );
  }



/* fix3: late colour morph (slow network) can replace the gallery after the capped resync burst and outside
   the per-gallery observers, leaving the new box without the logo (invisible). One document-level watcher:
   250 ms after DOM churn, an orphan box + a previewable logo → one forced resync (max 1/s; PDF/AI never loop). */
(function () {
  if (window.__sancandoOrphanWatch) return;
  window.__sancandoOrphanWatch = true;
  let timer = null;
  const check = () => {
    try {
      const hh = document.querySelector('sancando-customization');
      if (!hh || hh._userClearedLogo || typeof hh.schedulePreviewResync !== 'function') return;
      const orphan = document.querySelector('.sancando-imprint-preview:not(.sancando-imprint-preview--mirror):not(.has-logo):not(.is-patch-frame)');
      if (!orphan) return;
      const cache = hh.getLogoCache && hh.getLogoCache();
      const inp = hh.querySelector('input[type="file"][name^="properties[Logo"]') || document.querySelector('input[type="file"][name^="properties[Logo"]');
      const f = (inp && inp.files && inp.files[0]) || (cache && (cache.file || cache.previewOnlyFile));
      if (!f || !(hh.canPreviewFile(f) || (hh._keyedPreviewFile && hh.canPreviewFile(hh._keyedPreviewFile)))) return;
      if (Date.now() - (window.__sancandoOrphanAt || 0) < 1000) { clearTimeout(timer); timer = setTimeout(check, 1000); return; }
      window.__sancandoOrphanAt = Date.now();
      hh.schedulePreviewResync(true);
    } catch (e) { /* never break the page */ }
  };
  const start = () => {
    try {
      new MutationObserver((muts) => {
        /* idiomorph-style morphs edit the box in place (class stripped), so watch class changes on boxes too */
        if (!muts.some((m) => (m.addedNodes && m.addedNodes.length) ||
          (m.type === 'attributes' && m.target.classList && m.target.classList.contains('sancando-imprint-preview') &&
            !m.target.classList.contains('has-logo')))) return;
        clearTimeout(timer); timer = setTimeout(check, 250);
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (e) { /* ignore */ }
  };
  start();
  /* belt and braces: some section morphs escape observers; a cheap 1 s probe (one querySelector) catches the rest */
  setInterval(() => { if (!document.hidden) check(); }, 1000);
})();
